import { default as addlCmS6CkS0dMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/add.vue?macro=true";
import { default as deletevNpwBdtVwUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/delete.vue?macro=true";
import { default as detailXTvInzXbZkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/detail.vue?macro=true";
import { default as edit51CmCL1MXZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/edit.vue?macro=true";
import { default as dataXSRr97q4nBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/imports/data.ts?macro=true";
import { default as form9RUrrvwQKfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/imports/form.ts?macro=true";
import { default as node_45type_45namewUif88G8uMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/node-type-name.vue?macro=true";
import { default as node_45typesAg8aLBUFkQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/node-types.vue?macro=true";
import { default as task_45nameczOOPUsAUhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/task-name.vue?macro=true";
import { default as tasks_45namedbRlloeQDtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/tasks-name.vue?macro=true";
import { default as addLkMSs1gGGAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/add.vue?macro=true";
import { default as deletenqTrYhrUYJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/delete.vue?macro=true";
import { default as detailqmWDuOoffgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/detail.vue?macro=true";
import { default as editF8yWrllF7TMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/edit.vue?macro=true";
import { default as replicatekl16DJ4jnKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/replicate.vue?macro=true";
import { default as task_45namegGqjH0Ez98Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/task-name.vue?macro=true";
import { default as indexezmq9K0jJCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/index.vue?macro=true";
import { default as taskNGXbFwpS9NMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/task.vue?macro=true";
import { default as ratingbAt55VkzuXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/rating.vue?macro=true";
import { default as view_45detail_45staticjFFIsCUgs4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/view-detail-static.vue?macro=true";
import { default as view_45general_45staticg3Xhr5H7OlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/view-general-static.vue?macro=true";
import { default as view_45mapSeLC3FwcXYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/view-map.vue?macro=true";
import { default as indexv1XVSPlhYuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/index.vue?macro=true";
import { default as history3SAfNJgNpQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/history.vue?macro=true";
import { default as add_45nodeLxCgaDaaJWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/add-node.vue?macro=true";
import { default as select_45nodeCKrocMbb2xMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/autocomplete/select-node.vue?macro=true";
import { default as detail_45nodeh9eS9SjPvMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/detail-node.vue?macro=true";
import { default as edit_45node6jFnLo91mJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/edit-node.vue?macro=true";
import { default as initG0lJQpoJlzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/imports/init.ts?macro=true";
import { default as modelqGBTC5Pl1lMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/imports/model.ts?macro=true";
import { default as utilsJoPurHDat0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/imports/utils.ts?macro=true";
import { default as addypOTAyenvZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/add.vue?macro=true";
import { default as detaill13TEPua3sMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/detail.vue?macro=true";
import { default as editoKulTgXSBLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/edit.vue?macro=true";
import { default as listRok3ZuEY2HMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/list.vue?macro=true";
import { default as business_45namebhWkv3uvgGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/tables/business-name.vue?macro=true";
import { default as node_45name4My0knC4krMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/tables/node-name.vue?macro=true";
import { default as task_45nameiBDiTKvMK7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/tables/task-name.vue?macro=true";
import { default as edit_45working_45timeaxQIiLqZU0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node/edit-working-time.vue?macro=true";
import { default as toll_45stations3vZaT8dChHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node/toll-stations.vue?macro=true";
import { default as working_45timea8n6t1Jt26Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node/working-time.vue?macro=true";
import { default as business_45nameIUVbuPwyHAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/tables/business-name.vue?macro=true";
import { default as addIaxnthDv4zMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/add.vue?macro=true";
import { default as deleteZRNsXONXAVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/delete.vue?macro=true";
import { default as detailrYYPoOV8upMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/detail.vue?macro=true";
import { default as editfFQj6WmvLHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/edit.vue?macro=true";
import { default as update_45relation_45nodeFmiZsNsEOyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/update-relation-node.vue?macro=true";
import { default as list0lO65jzSCHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/list.vue?macro=true";
import { default as actionQrvOZKL2J6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location/ignore/action.vue?macro=true";
import { default as addqX3Hqi7BnLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location/ignore/add.vue?macro=true";
import { default as detailZNMZY1z44cMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location/ignore/detail.vue?macro=true";
import { default as locationx22KmdOct5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location.vue?macro=true";
import { default as typebgdBkH2RX0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/type.vue?macro=true";
import { default as change_45passwordUEbfBL84LdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index/change-password.vue?macro=true";
import { default as informationZ01sBHK46bMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index/information.vue?macro=true";
import { default as timeEm64qGzWxLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index/time.vue?macro=true";
import { default as index1qU8UE5YZkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index.vue?macro=true";
import { default as indexLs5r3SEOCeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/settings/index.vue?macro=true";
import { default as indexW6Wtqz5e1rMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/settings/toll-stations/index.vue?macro=true";
import { default as usersF2HdS9HmWzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/users.vue?macro=true";
import { default as addRbn8w7B9AZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/ignore/add.vue?macro=true";
import { default as editWRDjhcjx9JMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/ignore/edit.vue?macro=true";
import { default as formY381GTMJ15Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/ignore/import/form.ts?macro=true";
import { default as indexiThhRJCXqkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/index.vue?macro=true";
import { default as indexHu9HcebhSaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/index.vue?macro=true";
import { default as addgXZQHNlbGyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/add.vue?macro=true";
import { default as deletenMWu36jZ9RMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/delete.vue?macro=true";
import { default as detaillpj471Bv6jMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/detail.vue?macro=true";
import { default as editw9UJJf7HOnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/edit.vue?macro=true";
import { default as find_45business7gkm2Icfr9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/find-business.vue?macro=true";
import { default as setting_45position_45numberrQ2qnduBYnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/setting-position-number.vue?macro=true";
import { default as workflow_45positiongXuC2uiPepMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/workflow-position.vue?macro=true";
import { default as data2uYXU2TpRVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-imports/data.ts?macro=true";
import { default as formH6rw9uFwAhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-imports/form.ts?macro=true";
import { default as index8mBMFZrSFEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/index.vue?macro=true";
import { default as workspacesfpN3XcBMguMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workspaces.vue?macro=true";
import { default as admincpdQcDN9vAnnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp.vue?macro=true";
import { default as callback_45_91app_93akkXQJ7UqOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/callback-[app].vue?macro=true";
import { default as forgot_45passwordklIwaXTY1qMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/forgot-password.vue?macro=true";
import { default as invite_45userQWvhSsLDCNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/invite-user.vue?macro=true";
import { default as inviteShPWCr9mjTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/invite.vue?macro=true";
import { default as loginJWcdWYqCU1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/login.vue?macro=true";
import { default as registerMEj76kV8VdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/register.vue?macro=true";
import { default as reset_45passwordv9wuoNR4fGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/reset-password.vue?macro=true";
import { default as orders3McuxDd4ZVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity-detail/orders.vue?macro=true";
import { default as quote_45request8qaodct76zMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity-detail/quote-request.vue?macro=true";
import { default as table9ByOHdi7cTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity-detail/table.vue?macro=true";
import { default as activityAVHLT6gbjrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity.vue?macro=true";
import { default as activitiesiPnDYXnwAIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/activities.vue?macro=true";
import { default as alert_45actionQoCZ3CG74mMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-action.vue?macro=true";
import { default as alert_45stageMuHMEIqbAnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-stage.vue?macro=true";
import { default as alert_45task_45delaytZTi3G07CoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task-delay.vue?macro=true";
import { default as alert_45task_45processha8VPai8xmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task-process.vue?macro=true";
import { default as alert_45task_45waitingo90jk6TQZ1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task-waiting.vue?macro=true";
import { default as alert_45taskJnZbyZOKAtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task.vue?macro=true";
import { default as alert_45itemOHUhD2d9S5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-item.vue?macro=true";
import { default as alertsL3gJWQajPOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alerts.vue?macro=true";
import { default as driver_45alert_45itemUQ8seNh6vCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-alert-item.vue?macro=true";
import { default as driver_45infoxLBHfNy6a1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-info.vue?macro=true";
import { default as driver_45notificationsZnKMUg2PSIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-notifications.vue?macro=true";
import { default as driver_45statusVp0BCOTUorMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-status.vue?macro=true";
import { default as files9mgqHComvPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/files.vue?macro=true";
import { default as planning_45actualhgUkNZjmgiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/planning-actual.vue?macro=true";
import { default as planningR7l6ql7zN2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/planning.vue?macro=true";
import { default as pricesiF0cBSp6hEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/prices.vue?macro=true";
import { default as sub_45tasksP2QqaJogbfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/sub-tasks.vue?macro=true";
import { default as tasksi8k6VkyQSwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/tasks.vue?macro=true";
import { default as travel_45detailiNV8nI0s1DMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-detail.vue?macro=true";
import { default as travel_45mapAArCbzXB1KMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-map.vue?macro=true";
import { default as travel_45route_45info56VXHYdCnWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-route-info.vue?macro=true";
import { default as travel_45stepAwhlT8PWO1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-step.vue?macro=true";
import { default as alertsNumoNLCL6EMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-tabs/alerts.vue?macro=true";
import { default as indexwrqt4zslLLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-tabs/index.vue?macro=true";
import { default as travelyjwDrWUYL5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel.vue?macro=true";
import { default as utils3iYmISKhuRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/utils.ts?macro=true";
import { default as vehicle_45infoP44eWYb4jpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/vehicle-info.vue?macro=true";
import { default as vehicle_45statusWwX85JJQxAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/vehicle-status.vue?macro=true";
import { default as journey_45infoFecxIsXn1dMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info.vue?macro=true";
import { default as time_45condition_45formatq9wkYF3Tx7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/time-condition-format.ts?macro=true";
import { default as driverpASPpKpoi4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/transportation-info/driver.vue?macro=true";
import { default as indexnoGxSZCGwjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/transportation-info/index.vue?macro=true";
import { default as vehiclewwMn3GaBHDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/transportation-info/vehicle.vue?macro=true";
import { default as trip_45info_45contentjYMfoA17ruMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info-content.vue?macro=true";
import { default as driver_45alert_45item9FBpjliGqpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/driver-alert-item.vue?macro=true";
import { default as driver_45infoMnZmF9tGITMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/driver-info.vue?macro=true";
import { default as driver_45notificationsZwOjKCPfcvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/driver-notifications.vue?macro=true";
import { default as travel_45detailNEg9skigzlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-detail.vue?macro=true";
import { default as travel_45mapTIceFpVFXuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-map.vue?macro=true";
import { default as travel_45route_45infoAHBBNDf9paMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-route-info.vue?macro=true";
import { default as travel_45stepF01b7EGNpyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-step.vue?macro=true";
import { default as travelzaNgtYuhIyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel.vue?macro=true";
import { default as trip_45filesuQNYod0H9yMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/trip-files.vue?macro=true";
import { default as vehicle_45infoDBFSS14CnAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/vehicle-info.vue?macro=true";
import { default as trip_45infoSIZDSZvyNgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info.vue?macro=true";
import { default as trip_45utilsdyINxXPvZ5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-utils.ts?macro=true";
import { default as bankuIpsWo62k5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/bank.vue?macro=true";
import { default as branchsMHJKTKCSwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/branch.vue?macro=true";
import { default as formLvBXFXTM3oMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/cost/ignore/imports/form.ts?macro=true";
import { default as indexTgvye9ksAjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/cost/index.vue?macro=true";
import { default as formeaTUcAn1TjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/ignore/imports/form.ts?macro=true";
import { default as setting_45conta0JcFNepG7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/ignore/setting-cont.vue?macro=true";
import { default as update_45markupkCMQEXIIvxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/ignore/update-markup.vue?macro=true";
import { default as indexudfJlK9AXSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/index.vue?macro=true";
import { default as indexi25DBOHatyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/gps/index.vue?macro=true";
import { default as indexeYlF3GnmxcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/driver/index.vue?macro=true";
import { default as index5bRb6MIfCjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/index.vue?macro=true";
import { default as indexBFEAj982NhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/remooc/index.vue?macro=true";
import { default as indexXJCB106IGHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/vehicle/index.vue?macro=true";
import { default as form55vAy9dmrgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/policy/ignore/imports/form.ts?macro=true";
import { default as indexEhLgS0X0xBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/policy/index.vue?macro=true";
import { default as indexYaYSRxuf2wMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/route/index.vue?macro=true";
import { default as indexUZc9jtzjJ8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/schedule/index.vue?macro=true";
import { default as form3XGGuVOrjLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/times/ignore/imports/form.ts?macro=true";
import { default as index5IDYVM8fZ6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/times/index.vue?macro=true";
import { default as global_45settingsynU7YfJyrYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings.vue?macro=true";
import { default as historyJXrgUMAYn5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/history.vue?macro=true";
import { default as actionj4M4YjkWoAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/action.vue?macro=true";
import { default as add_45banking7tlTIpXx41Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/add-banking.vue?macro=true";
import { default as add_45branchKCDEKO2eKrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/add-branch.vue?macro=true";
import { default as add_45companyOp2ASRY5WmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/add-company.vue?macro=true";
import { default as banking_45branchqL8uIsVKeUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/banking-branch.vue?macro=true";
import { default as company_45history_45detail2pl1kdhF2HMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/company-history-detail.vue?macro=true";
import { default as edit_45bankWRfwQP0cgIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-bank.vue?macro=true";
import { default as edit_45banking_45branchF6KL3Dd0XMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-banking-branch.vue?macro=true";
import { default as edit_45branch7kIXnbShIfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-branch.vue?macro=true";
import { default as edit_45companyeRk2Z8uqIuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-company.vue?macro=true";
import { default as edit_45invoice_45branch6hw6a6tf9ZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-invoice-branch.vue?macro=true";
import { default as edit_45invoiceMpHVZ1CTVcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-invoice.vue?macro=true";
import { default as banking_45formMyq6Izj3r2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/imports/banking-form.ts?macro=true";
import { default as formn3LHxR50N0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/imports/form.ts?macro=true";
import { default as invoice_45formdAFpfX4K3HMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/imports/invoice-form.ts?macro=true";
import { default as invoicing_45branchogJRiR8wr5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/invoicing-branch.vue?macro=true";
import { default as list_45companyIZ9bp6LixzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/list-company.vue?macro=true";
import { default as index2czfpsi99IMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/information/index.vue?macro=true";
import { default as updatez4BxXCOMFKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/information/update.vue?macro=true";
import { default as add3rhLwlawtWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/integration/internal/ignore/add.vue?macro=true";
import { default as indexnMYTlXy7ibMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/integration/internal/index.vue?macro=true";
import { default as invoicetoKNrAqiX1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/invoice.vue?macro=true";
import { default as actions5X6SN0NCaeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/actions.vue?macro=true";
import { default as add_45company_45usermVP6IWPPnLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/add-company-user.vue?macro=true";
import { default as add_45groupmzhb0U8Jg1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/add-group.vue?macro=true";
import { default as edit_45company_45userNRpXyhVVC2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/edit-company-user.vue?macro=true";
import { default as edit_45groupYVrghbsQeuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/edit-group.vue?macro=true";
import { default as group_45nameX3qU5V3lfZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/ignore/group-name.vue?macro=true";
import { default as group_45typePlYO7F1KoOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/ignore/group-type.vue?macro=true";
import { default as permission_45checkboxQ3kVCEf8ogMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/ignore/permission-checkbox.vue?macro=true";
import { default as dataqlCJvBhXOhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/imports/data.ts?macro=true";
import { default as formWsr9I12dTUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/imports/form.ts?macro=true";
import { default as modelZJUcPS8qdVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/imports/model.ts?macro=true";
import { default as update_45permissionscdxGt21fJtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/update-permissions.vue?macro=true";
import { default as user_45statusFwef9IgSu2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/user-status.vue?macro=true";
import { default as groupsolH2TYdPbQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/groups.vue?macro=true";
import { default as usersQBepjGweRZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/users.vue?macro=true";
import { default as indexBW1M6prpo1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/components/index.vue?macro=true";
import { default as indexavMuX9Jd1JMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/dashboard/index.vue?macro=true";
import { default as indexrwqpVdYyQsMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/index.vue?macro=true";
import { default as actions9Dw1YQ3VyOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/actions.vue?macro=true";
import { default as add_45orderQEKeu72OjMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/add-order.vue?macro=true";
import { default as cancel3GJpSqDEHcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/cancel.vue?macro=true";
import { default as container_45numbersumwjMvomDgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/container-numbers.vue?macro=true";
import { default as date_45timeCCJuFctfZ8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/date-time.vue?macro=true";
import { default as deadlinePsGSwJuqydMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/deadline.vue?macro=true";
import { default as delivery_45warehouseJBqYOS67gQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/delivery-warehouse.vue?macro=true";
import { default as edit_45productivitytNTiu423gUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/edit-productivity.vue?macro=true";
import { default as edit_45travel_45timey4qRvCPdAcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/edit-travel-time.vue?macro=true";
import { default as loading_45taskT4fHVqp0IOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/loading-task.vue?macro=true";
import { default as requestQWIFoIm2SKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/request.vue?macro=true";
import { default as condition_45settingfjnqIDg3mEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/condition-setting.vue?macro=true";
import { default as add_45container_45numberswJrEsJ81obMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/add-container-numbers.vue?macro=true";
import { default as add_45partnerFRbhiTZqfFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/add-partner.vue?macro=true";
import { default as add_45quote_45to_45ordersLUSMKl1XjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/add-quote-to-order.ts?macro=true";
import { default as allotmentio6E9uC8NfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/allotment.vue?macro=true";
import { default as edit_45allotmentjYOyn42e3sMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/edit-allotment.vue?macro=true";
import { default as edit_45shipping_45planyIqzXgOwV3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/edit-shipping-plan.vue?macro=true";
import { default as general_45informationX337fQHDJmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/general-information.vue?macro=true";
import { default as indexVJhDNoyTlWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/index.vue?macro=true";
import { default as quote7qUYgm29JqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/quote.vue?macro=true";
import { default as shipping_45planVQf4I2d0olMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/shipping-plan.vue?macro=true";
import { default as add_45documentTLB667HbhTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/document/add-document.vue?macro=true";
import { default as documentcv1jYsY3TGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/document/document.vue?macro=true";
import { default as edit_45documentO8ceBL5vcxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/document/edit-document.vue?macro=true";
import { default as edit_45order0gHpBABp6AMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/edit-order.vue?macro=true";
import { default as edit_45requestytr7Nc2UfWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/edit-request.vue?macro=true";
import { default as dataYLH6ILnQz3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/imports/data.ts?macro=true";
import { default as form5oS31TMrfYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/imports/form.ts?macro=true";
import { default as indexnrjxjr8upTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/optimize-waiting-time/index.vue?macro=true";
import { default as directionFrfgBkNgrJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/plugins/direction.ts?macro=true";
import { default as indexdewlTTZm0AMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/plugins/index.ts?macro=true";
import { default as routeQA91h3o6gzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/plugins/route.ts?macro=true";
import { default as shipping_45informationl6nbg3peEjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/shipping-information.vue?macro=true";
import { default as shipping_45plantOF6h7K8UhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/shipping-plan.vue?macro=true";
import { default as commodityggAUlhgMeyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/table/commodity.vue?macro=true";
import { default as contM4draUq4SlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/table/cont.vue?macro=true";
import { default as customerjyzqSpPmUaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/table/customer.vue?macro=true";
import { default as travel_45detailVQtH3GP8lYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/travel-detail.vue?macro=true";
import { default as view_45positionQSXVskjNRxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/view-position.vue?macro=true";
import { default as waiting_45task7j1abnTDxmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/waiting-task.vue?macro=true";
import { default as workflow_45positionS8BK1WboUdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/workflow-position.vue?macro=true";
import { default as indexIAAekfWvI6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/index.vue?macro=true";
import { default as actionsOoFyNgIiJ5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/actions.vue?macro=true";
import { default as addXtzbqBWGpfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/add.vue?macro=true";
import { default as cooperator_45labelHZJbfzvEESMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/cooperator-label.vue?macro=true";
import { default as detailRr1wYX11QJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/detail.vue?macro=true";
import { default as formlvIt7jZ0rqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/imports/form.ts?macro=true";
import { default as invitekKJZ72YsXlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/invite.vue?macro=true";
import { default as selectq1xkdEvPiUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/select.vue?macro=true";
import { default as statusxMdl4ao7WeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/status.vue?macro=true";
import { default as commodity_45nameukEGjOhIiNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/tabels/commodity-name.vue?macro=true";
import { default as system_45participation_45statusQIkMJzLgiqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/tabels/system-participation-status.vue?macro=true";
import { default as addAkkWv807TgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank/-components/add.vue?macro=true";
import { default as editcbm199gCIYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank/[idbank]/edit.vue?macro=true";
import { default as bankQejwIokBFoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank/ignore/bank.ts?macro=true";
import { default as bank0Mrs1kOOYvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank.vue?macro=true";
import { default as addC7qySS26O2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/-components/add.vue?macro=true";
import { default as position7MddO5p6NiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/-components/position.vue?macro=true";
import { default as workflow_45positionyZ9i36e49mMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/-components/workflow-position.vue?macro=true";
import { default as editGkBo9iVe8OMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/edit.vue?macro=true";
import { default as replicatew2DcLNUH02Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/replicate.vue?macro=true";
import { default as business_45opportunityj53M8HBQMoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity.vue?macro=true";
import { default as add_45commodityZEO0ua6cSbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue?macro=true";
import { default as edityo2ZBGTIX8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/commodity/[idcommodity]/edit.vue?macro=true";
import { default as commodityQhtlYnnqpNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/commodity.vue?macro=true";
import { default as addU35U23VRLMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact/-components/add.vue?macro=true";
import { default as editLOwCacRKuAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact/[idcontact]/edit.vue?macro=true";
import { default as dataN3ajnUaZQDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact/ignore/data.ts?macro=true";
import { default as contactLZ4bUyJNVmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact.vue?macro=true";
import { default as add_45documentHWDMogDSayMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document/-components/add-document.vue?macro=true";
import { default as approvepBBxr3BeDzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document/[iddocumentpartner]/approve.vue?macro=true";
import { default as edityx13Mhh6iOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document/[iddocumentpartner]/edit.vue?macro=true";
import { default as documentsmiHg1SofPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document.vue?macro=true";
import { default as editUFjmoVXye4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/edit.vue?macro=true";
import { default as addi85X2nB7VfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/add.vue?macro=true";
import { default as detailFRmB6TSOW2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/detail.vue?macro=true";
import { default as editxz6893dOfkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/edit.vue?macro=true";
import { default as formrWMF04rnVOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/form.ts?macro=true";
import { default as utilsENmx3Hcvl7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/utils.ts?macro=true";
import { default as task_45completion_45timeGUSLuiZH1wMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time.vue?macro=true";
import { default as customercpXDaziCIFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/accept/customer.vue?macro=true";
import { default as vendora2QrttWqkCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/accept/vendor.vue?macro=true";
import { default as partneravkgiq5PhgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner.vue?macro=true";
import { default as change_45passwordzejLTsxbzYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index/change-password.vue?macro=true";
import { default as informationez5POuPGYmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index/information.vue?macro=true";
import { default as timeuSVzMmTGQjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index/time.vue?macro=true";
import { default as index1CopfWxRiFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index.vue?macro=true";
import { default as addjlMn2onV78Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/add.vue?macro=true";
import { default as createrDUp0g8EzFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/create.vue?macro=true";
import { default as formdKcxv1xsNnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/ignore/imports/form.ts?macro=true";
import { default as informationQeT10GNsxGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/information.vue?macro=true";
import { default as markup_45editxDT0m4IdeKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/markup-edit.vue?macro=true";
import { default as markup_45viewz9PjOpd1SpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/markup-view.vue?macro=true";
import { default as price_45information7zSkjqRGqKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/price-information.vue?macro=true";
import { default as type_45commodity_45nameF0JJ0YhKPzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/type-commodity-name.vue?macro=true";
import { default as view_45offline_45fee73EnQNJyV8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/view-offline-fee.vue?macro=true";
import { default as view_45price_45detail6xTCbw31OCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/view-price-detail.vue?macro=true";
import { default as view_45quote_45priceHvSC4NkNBpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/view-quote-price.vue?macro=true";
import { default as managementiCc01It4bqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/management.vue?macro=true";
import { default as add_45quotepLhZUduzHpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/add-quote.vue?macro=true";
import { default as addREnalvO2JKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/add.vue?macro=true";
import { default as formLLo2Hs43mRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/ignore/imports/form.ts?macro=true";
import { default as routing_45connectionIyf3FS4njJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/routing-connection.vue?macro=true";
import { default as view_45position7Rp7z4d5J4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/view-position.vue?macro=true";
import { default as workflow_45position52lzZpLALuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/workflow-position.vue?macro=true";
import { default as editxSIoULo2IEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/[idquoterequest]/edit.vue?macro=true";
import { default as viewy5hkiXxHpEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/[idquoterequest]/view.vue?macro=true";
import { default as quote_45requestAcIJM6Y4YRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request.vue?macro=true";
import { default as addZI5ygjVCc0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/add.vue?macro=true";
import { default as cancelPVeAqIqKuVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/cancel.vue?macro=true";
import { default as deadlinec88Xb47ZYcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/deadline.vue?macro=true";
import { default as journey_45cellaBMXVSclG5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/journey-cell.vue?macro=true";
import { default as requestqFkkoGBqABMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/request.vue?macro=true";
import { default as route0q8PGDxEVBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/route.vue?macro=true";
import { default as detailsHqbbDvMs3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/detail.vue?macro=true";
import { default as editHF6y7dHoQsMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/edit.vue?macro=true";
import { default as reasonMFmUro5gmKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/reason.ts?macro=true";
import { default as indexAmfBCUEJMRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/index.vue?macro=true";
import { default as c_45_91id_93mCBZJ3unozMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id].vue?macro=true";
import { default as oauthyZkFqSvhUtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/callback/oauth.vue?macro=true";
import { default as travel_45detailIBPoNinwJjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer/trip/[code]/-component/travel-detail.vue?macro=true";
import { default as travel_45stepOhwqf9uj8GMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer/trip/[code]/-component/travel-step.vue?macro=true";
import { default as index9PYQW4amT6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer/trip/[code]/index.vue?macro=true";
import { default as customerRLouyP1MBEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer.vue?macro=true";
import { default as search_45bookingxv6KecCkmjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/embed/search-booking.vue?macro=true";
import { default as access_45deniedaWjiIg81MqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/errors/access-denied.vue?macro=true";
import { default as indexE5wZiFS5mnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/index.vue?macro=true";
import { default as ordersYCDtnTVyz8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity-detail/orders.vue?macro=true";
import { default as quote_45requesttbQpxs3AO2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity-detail/quote-request.vue?macro=true";
import { default as tableXjqebx8RR6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity-detail/table.vue?macro=true";
import { default as activityJx3XM6HDK1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity.vue?macro=true";
import { default as activitiesXQm8OhKuGzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/activities.vue?macro=true";
import { default as alert_45action0d6VF0deDUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-action.vue?macro=true";
import { default as alert_45stageTVsFU6Tq5CMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-stage.vue?macro=true";
import { default as alert_45task_45delayr1NUgv2zLBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task-delay.vue?macro=true";
import { default as alert_45task_45processL2WK9IyXrEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task-process.vue?macro=true";
import { default as alert_45task_45waitingsZ3g2ffjp1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task-waiting.vue?macro=true";
import { default as alert_45taskju85AaA2SKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task.vue?macro=true";
import { default as alert_45itemmGJO7Lku1DMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-item.vue?macro=true";
import { default as alerts4slNOF2ywhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alerts.vue?macro=true";
import { default as driver_45alert_45item8CUnUmCSdcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-alert-item.vue?macro=true";
import { default as driver_45info4p1jvoq1D4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-info.vue?macro=true";
import { default as driver_45notificationsohwwNEZIkHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-notifications.vue?macro=true";
import { default as driver_45statuskCEYoKk29cMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-status.vue?macro=true";
import { default as files4UmodMi0YpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/files.vue?macro=true";
import { default as planning_45actualYqS2PlhNgzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/planning-actual.vue?macro=true";
import { default as planningSOD8Bhie0dMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/planning.vue?macro=true";
import { default as priceslmnaBDGYy2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/prices.vue?macro=true";
import { default as sub_45taskssAycVyohTcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/sub-tasks.vue?macro=true";
import { default as tasksMEBAwcm7sTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/tasks.vue?macro=true";
import { default as travel_45detailntPBcaf6z4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-detail.vue?macro=true";
import { default as travel_45mapRn3boPc5aBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-map.vue?macro=true";
import { default as travel_45route_45infogPqxYnEpKWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-route-info.vue?macro=true";
import { default as travel_45stepDGTXpF72Q9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-step.vue?macro=true";
import { default as alertskHJKCsRWQOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-tabs/alerts.vue?macro=true";
import { default as indexxDTpdawKKwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-tabs/index.vue?macro=true";
import { default as travele038vIPMPzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel.vue?macro=true";
import { default as utilsGGy66L1Hc4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/utils.ts?macro=true";
import { default as vehicle_45info3WnZReqa9XMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/vehicle-info.vue?macro=true";
import { default as vehicle_45statusyVayEgFIymMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/vehicle-status.vue?macro=true";
import { default as journey_45infoCGaY0etJoyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info.vue?macro=true";
import { default as time_45condition_45formatzOaAg4Gs0wMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/time-condition-format.ts?macro=true";
import { default as driver7DZPzyY2FvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/transportation-info/driver.vue?macro=true";
import { default as indexwPO6vpjkUYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/transportation-info/index.vue?macro=true";
import { default as vehicleDUqNmNeeIlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/transportation-info/vehicle.vue?macro=true";
import { default as trip_45info_45content6Ik5y8izsrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info-content.vue?macro=true";
import { default as driver_45alert_45item4vxcbh0dCTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/driver-alert-item.vue?macro=true";
import { default as driver_45infoKcwttscuK9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/driver-info.vue?macro=true";
import { default as driver_45notificationsmNtAxSNg37Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/driver-notifications.vue?macro=true";
import { default as travel_45detailbEibkurXPiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-detail.vue?macro=true";
import { default as travel_45mapVYmJai2VndMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-map.vue?macro=true";
import { default as travel_45route_45info67M4O9ZF3vMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-route-info.vue?macro=true";
import { default as travel_45stepEJxxgtZvluMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-step.vue?macro=true";
import { default as travelKrLX5r8sLLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel.vue?macro=true";
import { default as trip_45fileshu1YSdHdxtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/trip-files.vue?macro=true";
import { default as vehicle_45infoiRb5PoLYmrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/vehicle-info.vue?macro=true";
import { default as trip_45inforliv8uoLSqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info.vue?macro=true";
import { default as trip_45utilsnaZeCkOpvcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-utils.ts?macro=true";
import { default as bankKKdDNgXgZYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/bank.vue?macro=true";
import { default as branchZFLg01p6BAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/branch.vue?macro=true";
import { default as formtLP48H05TrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/cost/ignore/imports/form.ts?macro=true";
import { default as indexlLTYdU0vOpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/cost/index.vue?macro=true";
import { default as form7HI2XCT8i0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/ignore/imports/form.ts?macro=true";
import { default as setting_45cont3UQ6OAwVY5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/ignore/setting-cont.vue?macro=true";
import { default as update_45markupAL8anULaqOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/ignore/update-markup.vue?macro=true";
import { default as indexFdpwfB1Kq5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/index.vue?macro=true";
import { default as indexzYAKPH2RofMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/gps/index.vue?macro=true";
import { default as indexxMnPyfSU9KMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/driver/index.vue?macro=true";
import { default as indexliynPpoX2dMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/index.vue?macro=true";
import { default as indexztIimzuN3gMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/remooc/index.vue?macro=true";
import { default as indexn9fCosXUDxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/vehicle/index.vue?macro=true";
import { default as form0aWyRWSDcbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/policy/ignore/imports/form.ts?macro=true";
import { default as indexzocKdDa8fJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/policy/index.vue?macro=true";
import { default as indexrWSpUxc8JtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/route/index.vue?macro=true";
import { default as indexYthEFDa33NMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/schedule/index.vue?macro=true";
import { default as formCGwqtVPeGwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/times/ignore/imports/form.ts?macro=true";
import { default as indexaKGX286LvOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/times/index.vue?macro=true";
import { default as global_45settingsAOrKe5SchPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings.vue?macro=true";
import { default as historyMQEJ1bGUCFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/history.vue?macro=true";
import { default as actionvz8yerhF3ZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/action.vue?macro=true";
import { default as add_45bankingTceMJNFxAOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/add-banking.vue?macro=true";
import { default as add_45branchkbK5js8VrNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/add-branch.vue?macro=true";
import { default as add_45companylfTFjO8LDaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/add-company.vue?macro=true";
import { default as banking_45branchDXELr9ZTmwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/banking-branch.vue?macro=true";
import { default as company_45history_45detail0lRKJaAp1hMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/company-history-detail.vue?macro=true";
import { default as edit_45bankEhTonVIK5RMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-bank.vue?macro=true";
import { default as edit_45banking_45branchf7MGChLQsHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-banking-branch.vue?macro=true";
import { default as edit_45branchIn1tEVR9cXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-branch.vue?macro=true";
import { default as edit_45companySM8xoiFyqyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-company.vue?macro=true";
import { default as edit_45invoice_45branchobT3gIJiBrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-invoice-branch.vue?macro=true";
import { default as edit_45invoiceGsJQ3thRzVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-invoice.vue?macro=true";
import { default as banking_45formXMWpezrvboMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/imports/banking-form.ts?macro=true";
import { default as formYXwwkQWOF1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/imports/form.ts?macro=true";
import { default as invoice_45formnqG2p4tqd4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/imports/invoice-form.ts?macro=true";
import { default as invoicing_45branchjuWkSbsvuIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/invoicing-branch.vue?macro=true";
import { default as list_45companylI999Fi0STMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/list-company.vue?macro=true";
import { default as informationqEMwAgbAPFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/information.vue?macro=true";
import { default as invoiceCauA62T8w8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/invoice.vue?macro=true";
import { default as actionsFuiN2AvaSkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/actions.vue?macro=true";
import { default as add_45company_45userER6sf7EWGRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/add-company-user.vue?macro=true";
import { default as add_45groupYAYBa0FOflMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/add-group.vue?macro=true";
import { default as edit_45company_45usern0Mkr12YNwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/edit-company-user.vue?macro=true";
import { default as edit_45groupPTOsjMZUcYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/edit-group.vue?macro=true";
import { default as group_45nameSInzbISQE8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/ignore/group-name.vue?macro=true";
import { default as group_45typeMLuMIDMAW0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/ignore/group-type.vue?macro=true";
import { default as permission_45checkboxrmMkwWkjkQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/ignore/permission-checkbox.vue?macro=true";
import { default as datavlrwp1ixJ4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/imports/data.ts?macro=true";
import { default as formj2Ha09Q7DZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/imports/form.ts?macro=true";
import { default as modelktbzuVGkovMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/imports/model.ts?macro=true";
import { default as update_45permissionsqbP6hA4UxLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/update-permissions.vue?macro=true";
import { default as user_45status42OdnkfGbWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/user-status.vue?macro=true";
import { default as groupss5G2HRITsZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/groups.vue?macro=true";
import { default as usersppf2NnKvVbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/users.vue?macro=true";
import { default as index8eA39TvkzaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/components/index.vue?macro=true";
import { default as indexRfiZJeW099Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/dashboard/index.vue?macro=true";
import { default as indexEoDkDx6OFFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/index.vue?macro=true";
import { default as actions5nAPGb1QnhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/actions.vue?macro=true";
import { default as add_45order9WAnV3fq4MMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/add-order.vue?macro=true";
import { default as cancelN5HRHO15DCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/cancel.vue?macro=true";
import { default as container_45numberswPUx0FSl13Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/container-numbers.vue?macro=true";
import { default as date_45timez04Yh8z01IMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/date-time.vue?macro=true";
import { default as deadlineKmofFLHFzSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/deadline.vue?macro=true";
import { default as delivery_45warehousepFkViiS4kzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/delivery-warehouse.vue?macro=true";
import { default as edit_45productivityLUgqLO0e7rMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/edit-productivity.vue?macro=true";
import { default as edit_45travel_45timeURyLUFaBCYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/edit-travel-time.vue?macro=true";
import { default as loading_45taskQ6kTBMxk8KMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/loading-task.vue?macro=true";
import { default as requestaUedsen8KDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/request.vue?macro=true";
import { default as condition_45settingwp71FUoDaSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/condition-setting.vue?macro=true";
import { default as add_45container_45numbersDRQuS8Nn85Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/add-container-numbers.vue?macro=true";
import { default as add_45partnerbfdDE9D5AJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/add-partner.vue?macro=true";
import { default as add_45quote_45to_45order9tTWTW6WKOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/add-quote-to-order.ts?macro=true";
import { default as allotmentgR2SLsq47OMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/allotment.vue?macro=true";
import { default as edit_45allotmentfs6R0rXpctMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/edit-allotment.vue?macro=true";
import { default as edit_45shipping_45planMEnzUvz1vMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/edit-shipping-plan.vue?macro=true";
import { default as general_45informationXA3z13x7KJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/general-information.vue?macro=true";
import { default as index9KIB3GfdKnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/index.vue?macro=true";
import { default as quotewJHvyWKF3aMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/quote.vue?macro=true";
import { default as shipping_45planbbvXLctn0IMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/shipping-plan.vue?macro=true";
import { default as add_45documentsfHHsaVV1ZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/document/add-document.vue?macro=true";
import { default as documentUUV2oPFrrjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/document/document.vue?macro=true";
import { default as edit_45documentER3TB0aD2VMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/document/edit-document.vue?macro=true";
import { default as edit_45ordernvzAl1g3eHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/edit-order.vue?macro=true";
import { default as edit_45requestoFJo8XsMPqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/edit-request.vue?macro=true";
import { default as datazq3QxShg7vMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/imports/data.ts?macro=true";
import { default as form63X0Afv80WMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/imports/form.ts?macro=true";
import { default as index6bNOoSs2ihMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/optimize-waiting-time/index.vue?macro=true";
import { default as directionY1UpsPUbifMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/plugins/direction.ts?macro=true";
import { default as indexeplIREvXi8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/plugins/index.ts?macro=true";
import { default as routetWpliMYxQ5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/plugins/route.ts?macro=true";
import { default as shipping_45informationHbFDzEzp9lMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/shipping-information.vue?macro=true";
import { default as shipping_45plano6Qs32wPIRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/shipping-plan.vue?macro=true";
import { default as commodityNkG92rNW8aMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/table/commodity.vue?macro=true";
import { default as contbFaMdL9rnQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/table/cont.vue?macro=true";
import { default as customerh4dKhCR78IMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/table/customer.vue?macro=true";
import { default as travel_45detail1tzgNA5h1fMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/travel-detail.vue?macro=true";
import { default as view_45positionp86oMjE0GDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/view-position.vue?macro=true";
import { default as waiting_45taskit14JpaQdKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/waiting-task.vue?macro=true";
import { default as workflow_45positionI5T5DwUkK8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/workflow-position.vue?macro=true";
import { default as indexA3nOY8LC2jMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/index.vue?macro=true";
import { default as actionsvZVTLQ4XonMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/actions.vue?macro=true";
import { default as addmW7MA31E4WMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/add.vue?macro=true";
import { default as cooperator_45labeln5tTRWRJKMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/cooperator-label.vue?macro=true";
import { default as detailAtBwiiDr60Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/detail.vue?macro=true";
import { default as form1OHxNLHWyRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/imports/form.ts?macro=true";
import { default as inviteyYDtfGivy4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/invite.vue?macro=true";
import { default as selectXS6kEgshXdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/select.vue?macro=true";
import { default as statusIq8XfiCPuCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/status.vue?macro=true";
import { default as commodity_45nameSC131l3u76Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/tabels/commodity-name.vue?macro=true";
import { default as system_45participation_45statusC4MYd0BgY5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/tabels/system-participation-status.vue?macro=true";
import { default as add3Dg6vXktUkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank/-components/add.vue?macro=true";
import { default as editE5BV9Iw1OUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank/[idbank]/edit.vue?macro=true";
import { default as bankI1Egkmlh07Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank/ignore/bank.ts?macro=true";
import { default as bankLla87PaRsBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank.vue?macro=true";
import { default as addNM5X2yfN6vMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/-components/add.vue?macro=true";
import { default as position6heD3d1ufuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/-components/position.vue?macro=true";
import { default as workflow_45positionxK11YohnLeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/-components/workflow-position.vue?macro=true";
import { default as edita9tcYeEoHvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/edit.vue?macro=true";
import { default as replicatefTnrFIkvNAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/replicate.vue?macro=true";
import { default as business_45opportunity9JLlFfoggmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity.vue?macro=true";
import { default as add_45commodityO3bR22AvBrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue?macro=true";
import { default as edit6kgdxXcRtPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/commodity/[idcommodity]/edit.vue?macro=true";
import { default as commodity5IL4Zrs7LOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/commodity.vue?macro=true";
import { default as addsgznnDJcxXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact/-components/add.vue?macro=true";
import { default as editbBQCx0LhgoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact/[idcontact]/edit.vue?macro=true";
import { default as data44MAEKle5MMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact/ignore/data.ts?macro=true";
import { default as contactShiplXP8twMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact.vue?macro=true";
import { default as add_45documentdex3VDb422Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document/-components/add-document.vue?macro=true";
import { default as approve90RFVQY4SgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document/[iddocumentpartner]/approve.vue?macro=true";
import { default as editCEeqoguWjlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document/[iddocumentpartner]/edit.vue?macro=true";
import { default as documentcC0gItcoKhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document.vue?macro=true";
import { default as edit9NEkBQOxNSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/edit.vue?macro=true";
import { default as addm4A66q60cyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/add.vue?macro=true";
import { default as detaillZbkvlZpEOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/detail.vue?macro=true";
import { default as edit74sSRXcbDWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/edit.vue?macro=true";
import { default as form0leBphfOwEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/form.ts?macro=true";
import { default as utilslzkE0CTYChMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/utils.ts?macro=true";
import { default as task_45completion_45time1RLvmfFH0DMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time.vue?macro=true";
import { default as customeruufrGK6lhrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/accept/customer.vue?macro=true";
import { default as vendorfjdawFKrLtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/accept/vendor.vue?macro=true";
import { default as partnervAnh3IpGRJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner.vue?macro=true";
import { default as change_45passwordwSH6GYAkL2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index/change-password.vue?macro=true";
import { default as informationkSMq7vQvbcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index/information.vue?macro=true";
import { default as timePlqohSzeRiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index/time.vue?macro=true";
import { default as indexLhOFZzX0GIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index.vue?macro=true";
import { default as add5EizNWPIxXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/add.vue?macro=true";
import { default as createm49sv5nyiWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/create.vue?macro=true";
import { default as formXt5dycfBGpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/ignore/imports/form.ts?macro=true";
import { default as informationgBC21JLB3xMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/information.vue?macro=true";
import { default as markup_45editR019RoalBRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/markup-edit.vue?macro=true";
import { default as markup_45viewvG5bTncHogMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/markup-view.vue?macro=true";
import { default as price_45informationC6Kq6bDecPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/price-information.vue?macro=true";
import { default as type_45commodity_45nameBenbBzeRSUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/type-commodity-name.vue?macro=true";
import { default as view_45offline_45feevcaEnjXyciMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/view-offline-fee.vue?macro=true";
import { default as view_45price_45detail2vR8q6PXspMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/view-price-detail.vue?macro=true";
import { default as view_45quote_45priceeAqCncjw7fMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/view-quote-price.vue?macro=true";
import { default as managementos6xV4BCufMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/management.vue?macro=true";
import { default as add_45quotemXWriFZpwvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/add-quote.vue?macro=true";
import { default as addRsCSvPeKwTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/add.vue?macro=true";
import { default as formFWQRE9OoQKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/ignore/imports/form.ts?macro=true";
import { default as routing_45connection1gUskKIX8oMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/routing-connection.vue?macro=true";
import { default as view_45position8GPJQdXIYEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/view-position.vue?macro=true";
import { default as workflow_45positionRW3GT9NaqCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/workflow-position.vue?macro=true";
import { default as editInQXXK8VaTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/[idquoterequest]/edit.vue?macro=true";
import { default as viewJsRRZ9kSUCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/[idquoterequest]/view.vue?macro=true";
import { default as quote_45request9UVNQrjXurMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request.vue?macro=true";
import { default as addokglaHFCLNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/add.vue?macro=true";
import { default as canceltPBhCCxqXAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/cancel.vue?macro=true";
import { default as deadlineDfjCy1nYhPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/deadline.vue?macro=true";
import { default as journey_45cellyCP6ygk5O1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/journey-cell.vue?macro=true";
import { default as request48NvhkvAUqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/request.vue?macro=true";
import { default as routelTHbWbm4JyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/route.vue?macro=true";
import { default as detail5w9gIK9eHgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/detail.vue?macro=true";
import { default as editt3h5zFV7KzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/edit.vue?macro=true";
import { default as reasonTA6zbazC5MMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/reason.ts?macro=true";
import { default as indexyxcbJVA2b4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/index.vue?macro=true";
import { default as pc_45_91id_930rixQ2q9dZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id].vue?macro=true";
import { default as ordersl0rvNH0pmvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity-detail/orders.vue?macro=true";
import { default as quote_45requestVOEzfCofSlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity-detail/quote-request.vue?macro=true";
import { default as tabley2SkCCJNpVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity-detail/table.vue?macro=true";
import { default as activitylIMk1JdrezMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity.vue?macro=true";
import { default as activitiesnf6yEbEprtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/activities.vue?macro=true";
import { default as alert_45actionx5keGMg6CFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-action.vue?macro=true";
import { default as alert_45stage9FrgsKV8eEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-stage.vue?macro=true";
import { default as alert_45task_45delayZKeVfdnokIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task-delay.vue?macro=true";
import { default as alert_45task_45processjdRLUj3KXxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task-process.vue?macro=true";
import { default as alert_45task_45waitingypYKGYrRTMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task-waiting.vue?macro=true";
import { default as alert_45task68Zxzcr0PFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task.vue?macro=true";
import { default as alert_45itemcIcUnNvaZbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-item.vue?macro=true";
import { default as alertsEXml8LMOYpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alerts.vue?macro=true";
import { default as driver_45alert_45item3FO2Gyo5TUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-alert-item.vue?macro=true";
import { default as driver_45infoJEPOFHKHykMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-info.vue?macro=true";
import { default as driver_45notificationsaF5V3yki5cMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-notifications.vue?macro=true";
import { default as driver_45statuseGJY3f3cuAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-status.vue?macro=true";
import { default as filesA51rG7HBI3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/files.vue?macro=true";
import { default as planning_45actual63OgNzy5B6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/planning-actual.vue?macro=true";
import { default as planningF0D73zbsj9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/planning.vue?macro=true";
import { default as pricesd9p8a04QVEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/prices.vue?macro=true";
import { default as sub_45tasksjKuXUfQfAgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/sub-tasks.vue?macro=true";
import { default as tasksWk7UGkdQp0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/tasks.vue?macro=true";
import { default as travel_45detailnkgC4rBjunMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-detail.vue?macro=true";
import { default as travel_45mapLFviuCpwpWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-map.vue?macro=true";
import { default as travel_45route_45infoKuPOeFgKDQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-route-info.vue?macro=true";
import { default as travel_45stepxwA9wCNE0MMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-step.vue?macro=true";
import { default as alerts5ZAZMkTkoKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-tabs/alerts.vue?macro=true";
import { default as indexdSawWwqtZaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-tabs/index.vue?macro=true";
import { default as travelvJzo66Ad5fMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel.vue?macro=true";
import { default as vehicle_45info8PlS9ZsGPBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/vehicle-info.vue?macro=true";
import { default as vehicle_45statuslMtQxWV3Z2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/vehicle-status.vue?macro=true";
import { default as journey_45infoTwmYGGIFdRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info.vue?macro=true";
import { default as driverByv68rmfMuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/transportation-info/driver.vue?macro=true";
import { default as indexuIMRkh4yhHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/transportation-info/index.vue?macro=true";
import { default as vehicleV0q0lOEF8xMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/transportation-info/vehicle.vue?macro=true";
import { default as trip_45info_45contentAdDyS7x1AYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info-content.vue?macro=true";
import { default as driver_45alert_45itemMozYYek1ulMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/driver-alert-item.vue?macro=true";
import { default as driver_45infoFATIq3TjcYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/driver-info.vue?macro=true";
import { default as driver_45notificationsEwnV1PYJAoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/driver-notifications.vue?macro=true";
import { default as travel_45detailiVtS4fCW7rMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-detail.vue?macro=true";
import { default as travel_45mapZZWE5ZmeV1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-map.vue?macro=true";
import { default as travel_45route_45infoZ5P5BuqUFDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-route-info.vue?macro=true";
import { default as travel_45stepPhFQxvOjFhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-step.vue?macro=true";
import { default as travelHU6l2A3GzoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel.vue?macro=true";
import { default as vehicle_45infoNH6dpGbDmcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/vehicle-info.vue?macro=true";
import { default as trip_45infoI34BB2PKwhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info.vue?macro=true";
import { default as indexVoAJVngpNtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/global-settings/gps/index.vue?macro=true";
import { default as global_45settingscFtSmfx4koMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/global-settings.vue?macro=true";
import { default as gps_45settingslSSIViVbD3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/gps-settings.vue?macro=true";
import { default as actionV9q1GzF6IKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/action.vue?macro=true";
import { default as add_45companyDBtX56IiylMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/add-company.vue?macro=true";
import { default as edit_45company0gZrvr08LpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/edit-company.vue?macro=true";
import { default as formyqNYSyeKRcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/imports/form.ts?macro=true";
import { default as list_45companyQcyUgSkUxHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/list-company.vue?macro=true";
import { default as informationGBtzChi8EoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/information.vue?macro=true";
import { default as actionsUvqmoQmrTTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/actions.vue?macro=true";
import { default as add_45company_45usernjEBTVajMgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/add-company-user.vue?macro=true";
import { default as add_45groupH790e30jJxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/add-group.vue?macro=true";
import { default as edit_45company_45userEUhzVbcJWyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/edit-company-user.vue?macro=true";
import { default as edit_45groupHqtnHTQyvdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/edit-group.vue?macro=true";
import { default as permission_45checkbox84CwlSssfJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/ignore/permission-checkbox.vue?macro=true";
import { default as datalzw0gCdVpiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/imports/data.ts?macro=true";
import { default as formAwM2yfvcytMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/imports/form.ts?macro=true";
import { default as modelJ3GHprlPkTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/imports/model.ts?macro=true";
import { default as update_45permissionsl64LBLfyEwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/update-permissions.vue?macro=true";
import { default as user_45statusWRJS7iiBlsMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/user-status.vue?macro=true";
import { default as groupsMs7iXV0hcJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/groups.vue?macro=true";
import { default as usersXADRvqIPutMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/users.vue?macro=true";
import { default as indexFlg7HoAhiwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/dashboard/index.vue?macro=true";
import { default as indexVAEOtt7PQxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/index.vue?macro=true";
import { default as journey_45carduiHDoxJwmCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-card.vue?macro=true";
import { default as journey_45detach_45card1arI8ZlmXJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-detach-card.vue?macro=true";
import { default as journey_45listJaNRYnvSgnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-list.vue?macro=true";
import { default as action_45tabspHCtIQtQxeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/action-tabs.vue?macro=true";
import { default as boardK6MI6VoZAOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/board.vue?macro=true";
import { default as mapYlktzcy5WIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/map.vue?macro=true";
import { default as warning_45listykfDQNKd78Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/warning-list.vue?macro=true";
import { default as journey_45scheduleF2R8ZbwHnzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule.vue?macro=true";
import { default as routeqE8ribVcEcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/route.vue?macro=true";
import { default as schedule_45info6PxNnxhOowMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/schedule-info.vue?macro=true";
import { default as confirmk7G9dKSqbUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/[allocation-code]/confirm.vue?macro=true";
import { default as distributingsjylDDXPo1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/distributing.vue?macro=true";
import { default as managementC8JVRQZwJtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/management.vue?macro=true";
import { default as journeyDU9ZjDxcVPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey.vue?macro=true";
import { default as alert_45list_45drawerSRhtZsK5DZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/alert-list-drawer.vue?macro=true";
import { default as alert_45list7BDGmLU7qaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/alert-list.vue?macro=true";
import { default as vehicle_45item6fbz3nzDgeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/vehicle-item.vue?macro=true";
import { default as vehicle_45list2qkHF4zYw7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/vehicle-list.vue?macro=true";
import { default as managementuS3F8EMsM9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/management.vue?macro=true";
import { default as change_45passwordJk9rmkR1GqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index/change-password.vue?macro=true";
import { default as informationx3f5tjIshJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index/information.vue?macro=true";
import { default as timecrtuJwZH6fMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index/time.vue?macro=true";
import { default as index6NH3VzOBzpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index.vue?macro=true";
import { default as add3xuFQLKzqaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/add.vue?macro=true";
import { default as datayDZzMrcTYfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/data.ts?macro=true";
import { default as detailwhWxXzgHLlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/detail.vue?macro=true";
import { default as editMDwOc2xg6bMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/edit.vue?macro=true";
import { default as form4IgnNOvY2DMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/form.ts?macro=true";
import { default as statusAZ4Mw7jDb7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/status.vue?macro=true";
import { default as view_45selling_45priceYVFuEt2ywxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/view-selling-price.vue?macro=true";
import { default as indexgciM3QJ6i9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/index.vue?macro=true";
import { default as actions6krKJnDELiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/actions.vue?macro=true";
import { default as add_45vehicleqKLp1h579JMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/add-vehicle.vue?macro=true";
import { default as select_45remooc_45categorycy1PPiYpW6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/autocomplete/select-remooc-category.vue?macro=true";
import { default as select_45remooc2oA7dJv8y3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/autocomplete/select-remooc.vue?macro=true";
import { default as select_45vehicle_45categoryNGJ3y23zwDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/autocomplete/select-vehicle-category.vue?macro=true";
import { default as detail_45vehicleFMQcnJZiFVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/detail-vehicle.vue?macro=true";
import { default as add_45documentCBgvWCZsIhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/document/add-document.vue?macro=true";
import { default as documentNo5X4i9cdlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/document/document.vue?macro=true";
import { default as edit_45documentcRqP06T69hMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/document/edit-document.vue?macro=true";
import { default as edit_45vehicleLC8Gz7NaazMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/edit-vehicle.vue?macro=true";
import { default as formVA1rkdDzdSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/imports/form.ts?macro=true";
import { default as remoocAl6lOKWNziMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/imports/remooc.ts?macro=true";
import { default as utils4bLZqegta7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/imports/utils.ts?macro=true";
import { default as maintenance_45scheduleVXB5pjSixMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/maintenance-schedule.vue?macro=true";
import { default as add_45plugina87ostebRMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/plugin/add-plugin.vue?macro=true";
import { default as edit_45pluginm6XY2bZPyMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/plugin/edit-plugin.vue?macro=true";
import { default as list_45pluginGzOXsNFizoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/plugin/list-plugin.vue?macro=true";
import { default as statusQtbiDje6SZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/status.vue?macro=true";
import { default as add_45categoryn2vBaDkzluMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/vehicle-category/add-category.vue?macro=true";
import { default as edit_45categoryewbmnuKjDZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/vehicle-category/edit-category.vue?macro=true";
import { default as listp6BbplajIcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/list.vue?macro=true";
import { default as pp_45_91id_93Q4wuVR760VMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id].vue?macro=true";
import { default as triphhRODj6AxmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/shared/trip.vue?macro=true";
import { default as shared8ExSRcTmNcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/shared.vue?macro=true";
import { default as ordersnJ4lfA03GwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity-detail/orders.vue?macro=true";
import { default as quote_45request7NwqS1jeANMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity-detail/quote-request.vue?macro=true";
import { default as tableHWCBfn9nSmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity-detail/table.vue?macro=true";
import { default as activityj4kpzo5rn1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity.vue?macro=true";
import { default as activitiesfmYq8dvy1bMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/activities.vue?macro=true";
import { default as alert_45action6av82NRNzgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-action.vue?macro=true";
import { default as alert_45stageGECHs4GFi5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-stage.vue?macro=true";
import { default as alert_45task_45delayQHZ0FjARfeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task-delay.vue?macro=true";
import { default as alert_45task_45processHtHtQpSdaCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task-process.vue?macro=true";
import { default as alert_45task_45waitingxysCnLrCJXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task-waiting.vue?macro=true";
import { default as alert_45task0z2Z63RglKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task.vue?macro=true";
import { default as alert_45itemq4fdtRz0FTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-item.vue?macro=true";
import { default as alertsS2hfIH9aewMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alerts.vue?macro=true";
import { default as driver_45alert_45itemqiATLJI0fOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-alert-item.vue?macro=true";
import { default as driver_45infoUWkXmr2bHQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-info.vue?macro=true";
import { default as driver_45notifications0rIwAgEQzVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-notifications.vue?macro=true";
import { default as driver_45statuslZvwgWmRbfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-status.vue?macro=true";
import { default as filesvb5ME86g6HMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/files.vue?macro=true";
import { default as planning_45actualdVW1D48ReNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/planning-actual.vue?macro=true";
import { default as planningDfUVBn5XJXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/planning.vue?macro=true";
import { default as pricesg3kBWry3rSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/prices.vue?macro=true";
import { default as sub_45tasksUjUJReAmTTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/sub-tasks.vue?macro=true";
import { default as tasks551FWEGBEIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/tasks.vue?macro=true";
import { default as travel_45details1hBFrpprJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-detail.vue?macro=true";
import { default as travel_45mapMWOCkvuMt3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-map.vue?macro=true";
import { default as travel_45route_45infoG4NH3nqDa2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-route-info.vue?macro=true";
import { default as travel_45stepourPhq3mj6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-step.vue?macro=true";
import { default as alertsyWS3MX4SbBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-tabs/alerts.vue?macro=true";
import { default as indexi9n5mb9mOEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-tabs/index.vue?macro=true";
import { default as travel1RD1KmAl1KMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel.vue?macro=true";
import { default as utils0geRXtNmtBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/utils.ts?macro=true";
import { default as vehicle_45infofxAclYTDEEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/vehicle-info.vue?macro=true";
import { default as vehicle_45statusOZxJS7viGNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/vehicle-status.vue?macro=true";
import { default as journey_45info0ENCVfEuOvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info.vue?macro=true";
import { default as time_45condition_45formatdRH9rohEMhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/time-condition-format.ts?macro=true";
import { default as driverdspNtXJEZdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/transportation-info/driver.vue?macro=true";
import { default as indexl9wrw8sCQdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/transportation-info/index.vue?macro=true";
import { default as vehicleMZN9SsVyUcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/transportation-info/vehicle.vue?macro=true";
import { default as trip_45info_45contentYVxFn92pOzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info-content.vue?macro=true";
import { default as driver_45alert_45itemTAd68VGoq6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/driver-alert-item.vue?macro=true";
import { default as driver_45infoNTva8qAcgDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/driver-info.vue?macro=true";
import { default as driver_45notificationsUXQdNTm9xpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/driver-notifications.vue?macro=true";
import { default as travel_45detailXG3qROEBOHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-detail.vue?macro=true";
import { default as travel_45mapIjkrBOdXmzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-map.vue?macro=true";
import { default as travel_45route_45infoWQXXnr3D7JMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-route-info.vue?macro=true";
import { default as travel_45stepotG2sD8vfTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-step.vue?macro=true";
import { default as travelis69PX9NjUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel.vue?macro=true";
import { default as trip_45filesg2R2IE5GXBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/trip-files.vue?macro=true";
import { default as vehicle_45infoRRCwmuzm64Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/vehicle-info.vue?macro=true";
import { default as trip_45infoMPh57guRc3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info.vue?macro=true";
import { default as trip_45utilsRR99YI3salMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-utils.ts?macro=true";
import { default as historyR9q4KMzzeRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/history.vue?macro=true";
import { default as add_45areaNKTEn9uKj7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/add-area.vue?macro=true";
import { default as edit_45areaQs2MrfMldoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/edit-area.vue?macro=true";
import { default as modelfUEwbiLAMOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/imports/model.ts?macro=true";
import { default as select_45areacAOwCZv3y8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/select-area.vue?macro=true";
import { default as list1CRsn87OGGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/list.vue?macro=true";
import { default as add_45category5JmtEAGHVUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/ignore/add-category.vue?macro=true";
import { default as list_45categoryMjfF8cqVgUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/ignore/list-category.vue?macro=true";
import { default as type_45categoryc7UTW917zEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/ignore/type-category.vue?macro=true";
import { default as listU9JrwugHuPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/index/list.vue?macro=true";
import { default as typehRRoLH2r0mMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/index/type.vue?macro=true";
import { default as index2QqFiTN3qVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/index.vue?macro=true";
import { default as addfUEmwgcRsfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/add.vue?macro=true";
import { default as edit77PznaKzBRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/edit.vue?macro=true";
import { default as indexfgyaYuPueWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/index.vue?macro=true";
import { default as keyiRQXawkYtxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/table/key.vue?macro=true";
import { default as bankecOULQ7gNqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/bank.vue?macro=true";
import { default as branchS4SzTuOuy1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/branch.vue?macro=true";
import { default as add0ELHzEjdFCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/ignore/add.vue?macro=true";
import { default as deletecyhZKCh4Q0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/ignore/delete.vue?macro=true";
import { default as editghlhT0DkmEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/ignore/edit.vue?macro=true";
import { default as indexvh6kqE62QIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/index.vue?macro=true";
import { default as formvPqffMGUgbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/cost/ignore/imports/form.ts?macro=true";
import { default as index3dJqnRubmoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/cost/index.vue?macro=true";
import { default as formhlJMOzXeYgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/ignore/imports/form.ts?macro=true";
import { default as setting_45contJ2yWchoq1oMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/ignore/setting-cont.vue?macro=true";
import { default as update_45markupqgbLaMAKHBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/ignore/update-markup.vue?macro=true";
import { default as indexJ6sQ9r8LWAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/index.vue?macro=true";
import { default as index7BOnZl0oWGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/gps/index.vue?macro=true";
import { default as indexTuOjlO5H4FMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/driver/index.vue?macro=true";
import { default as indexq2cY3HrjjsMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/index.vue?macro=true";
import { default as indexBt6Vpy1xiSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/remooc/index.vue?macro=true";
import { default as index5rCpCKylxoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/vehicle/index.vue?macro=true";
import { default as formu88O83uwh1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/policy/ignore/imports/form.ts?macro=true";
import { default as index3p1j9pCxiYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/policy/index.vue?macro=true";
import { default as indexzMpqOY4zebMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/route/index.vue?macro=true";
import { default as index112ZkH1qr6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/schedule/index.vue?macro=true";
import { default as formPiMJUdRo1sMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/times/ignore/imports/form.ts?macro=true";
import { default as indexlNA3KHWdcgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/times/index.vue?macro=true";
import { default as global_45settingsRyPpWw6EKgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings.vue?macro=true";
import { default as historyZ8owGuuBjcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/history.vue?macro=true";
import { default as actionAu9eey8TOkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/action.vue?macro=true";
import { default as add_45bankingNIHMkyNSA4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/add-banking.vue?macro=true";
import { default as add_45branch9UkP6KLwdnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/add-branch.vue?macro=true";
import { default as add_45companyI35fPsxIf5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/add-company.vue?macro=true";
import { default as banking_45branchdfIlbe9XKbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/banking-branch.vue?macro=true";
import { default as company_45history_45detailzI4W5OnybqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/company-history-detail.vue?macro=true";
import { default as edit_45bankJMEt4L0k1FMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-bank.vue?macro=true";
import { default as edit_45banking_45branchqglWj7dNaPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-banking-branch.vue?macro=true";
import { default as edit_45branchr46CLyF8ouMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-branch.vue?macro=true";
import { default as edit_45companyD0pUcPEiGdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-company.vue?macro=true";
import { default as edit_45invoice_45branchYUGayqUOdBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-invoice-branch.vue?macro=true";
import { default as edit_45invoice5bCeLhDedXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-invoice.vue?macro=true";
import { default as banking_45form9PngYpPFtuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/imports/banking-form.ts?macro=true";
import { default as formj4ONIG5ZPjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/imports/form.ts?macro=true";
import { default as invoice_45formjMQKgkcHv5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/imports/invoice-form.ts?macro=true";
import { default as invoicing_45branch5QUwB2XpoOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/invoicing-branch.vue?macro=true";
import { default as list_45companyXdNvr4Ak6TMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/list-company.vue?macro=true";
import { default as indexCyAAQRIAHcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/information/index.vue?macro=true";
import { default as update54xzcaUx0gMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/information/update.vue?macro=true";
import { default as apppdDdqCWVIaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/app.vue?macro=true";
import { default as freightek_45workspacesjZ4cGXCuWvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/apps/freightek-workspaces.vue?macro=true";
import { default as freightekE02Xg6MeHSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/apps/freightek.vue?macro=true";
import { default as hwl_45crmWzhnpmB0F9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/apps/hwl-crm.vue?macro=true";
import { default as index83KjQHWZGiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/index.vue?macro=true";
import { default as add1oF40AeRhbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/internal/ignore/add.vue?macro=true";
import { default as indexxEHbcrlJVVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/internal/index.vue?macro=true";
import { default as invoicetfCgIxq6zeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/invoice.vue?macro=true";
import { default as actions2r35UN50QaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/actions.vue?macro=true";
import { default as add_45company_45user0KR2aOUHfhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/add-company-user.vue?macro=true";
import { default as add_45groupxZRKRwmqu5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/add-group.vue?macro=true";
import { default as edit_45company_45userr9cifj6QkwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/edit-company-user.vue?macro=true";
import { default as edit_45groupDNKAs5EV7zMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/edit-group.vue?macro=true";
import { default as group_45nameFVqsI1rGRdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/ignore/group-name.vue?macro=true";
import { default as group_45type4yFYILB2lLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/ignore/group-type.vue?macro=true";
import { default as permission_45checkboxyRCObTasQEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/ignore/permission-checkbox.vue?macro=true";
import { default as dataQEWV8HlqlNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/imports/data.ts?macro=true";
import { default as formpWymHS5A1vMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/imports/form.ts?macro=true";
import { default as modelR2EZwrLXJoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/imports/model.ts?macro=true";
import { default as update_45permissionsvl11tZfAI9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/update-permissions.vue?macro=true";
import { default as user_45statusbA5WDS3pRBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/user-status.vue?macro=true";
import { default as groupsikmyjfqTCjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/groups.vue?macro=true";
import { default as usersdylRmoOdkQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/users.vue?macro=true";
import { default as indexDXhhgX03etMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/components/index.vue?macro=true";
import { default as add4IBbRDaswoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-costing/add.vue?macro=true";
import { default as editnkUmxqkhHfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-costing/edit.vue?macro=true";
import { default as add0C9D1niX3iMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-driver/add.vue?macro=true";
import { default as editKjms0mq30yMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-driver/edit.vue?macro=true";
import { default as addJEsotAGnyqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption/add.vue?macro=true";
import { default as editiliAd4LijKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption/edit.vue?macro=true";
import { default as addouDgpbp0jGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/gasoline/add.vue?macro=true";
import { default as editVsCZXMPXliMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/gasoline/edit.vue?macro=true";
import { default as formtfEuUoJ3QGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/imports/form.ts?macro=true";
import { default as actions3u37m69bWqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/tables/actions.vue?macro=true";
import { default as vehicle_45nameDLXUTxcCscMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/tables/vehicle-name.vue?macro=true";
import { default as assumption_45driverc21me3o8EyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/assumption-driver.vue?macro=true";
import { default as assumptionLnuSceX678Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/assumption.vue?macro=true";
import { default as driverOGVyAMDQ4GMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/driver.vue?macro=true";
import { default as gasolinegBfw2DPBOaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/gasoline.vue?macro=true";
import { default as indexYLhn2g3WJXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/index.vue?macro=true";
import { default as analytics_45cardmNK3TwW5BOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/analytics-card.vue?macro=true";
import { default as analytics_45modalMVlOpaNSo2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/analytics-modal.vue?macro=true";
import { default as cargo_45segment_45statusIsDvxB6bx3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/cargo-segment-status.vue?macro=true";
import { default as order_45allocation_45statusULepzR3SGBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/order-allocation-status.vue?macro=true";
import { default as order_45allocation_45volumeTZY9v1RPZAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/order-allocation-volume.vue?macro=true";
import { default as shipment_45leg_45transport_45status_45in_45dayjh9u4S7lp7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/shipment-leg-transport-status-in-day.vue?macro=true";
import { default as shipment_45scheduling_45statusTXp1SZk1HLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/shipment-scheduling-status.vue?macro=true";
import { default as direction_45of_45fleet1qWK32YIzgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet.vue?macro=true";
import { default as fleet_45operation_45status7sUhaHePM8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/fleet-operation/fleet-operation-status.vue?macro=true";
import { default as vehicle_45transport_45status995ueIomyGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/fleet-operation/vehicle-transport-status.vue?macro=true";
import { default as fleet_45operationKydfbOkx0NMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/fleet-operation.vue?macro=true";
import { default as cargo_45segment_45alert_45statusol9nyPHRpVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg/cargo-segment-alert-status.vue?macro=true";
import { default as shipment_45operation_45status_45for_45task_45close_45cargo0i0lCQwulOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg/shipment-operation-status-for-task-close-cargo.vue?macro=true";
import { default as shipment_45operation_45status_45for_45task_45unloading_45yardDfOn5PDfW6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg/shipment-operation-status-for-task-unloading-yard.vue?macro=true";
import { default as operation_45shipment_45legRH2R9W6MYAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg.vue?macro=true";
import { default as order_45allocation_45volumer0BKjwNdLpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/order-allocation-volume.vue?macro=true";
import { default as status_45quote_45requestK1NZocrJL8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales/status-quote-request.vue?macro=true";
import { default as status_45quotelb81Tx7IgkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales/status-quote.vue?macro=true";
import { default as timely_45alert_45creation_45tracking_45operationckeNdmKHPDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales/timely-alert-creation-tracking-operation.vue?macro=true";
import { default as salesWoJeFzhmSUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales.vue?macro=true";
import { default as trip_45monitoroIupBWuMtaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/trip-monitor.vue?macro=true";
import { default as legal_status_container_transportnK8LpJMTp8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/legal_status_container_transport.vue?macro=true";
import { default as nearing_45expiration_45document_45driverkNefsLFC2ZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/nearing-expiration-document-driver.vue?macro=true";
import { default as nearing_45expiration_45remoocbqbSH0ObtTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/nearing-expiration-remooc.vue?macro=true";
import { default as nearing_45expiration_45vehicleQ0U7SMYqKhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/nearing-expiration-vehicle.vue?macro=true";
import { default as vehicle_45transport_45ready_45statusJLSaRCvTX0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/vehicle-transport-ready-status.vue?macro=true";
import { default as vehicle_45fleet_45managementNRxd802q2nMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management.vue?macro=true";
import { default as ratingk5SRcQbXOpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/rating.vue?macro=true";
import { default as view_45detail_45static6G14C9OObJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/view-detail-static.vue?macro=true";
import { default as view_45general_45static5cYKGakf37Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/view-general-static.vue?macro=true";
import { default as view_45mapLnHShNOD2WMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/view-map.vue?macro=true";
import { default as indexY1pJLSE2cKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/index.vue?macro=true";
import { default as tmpzIRkoDrYhbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/tmp.vue?macro=true";
import { default as actionsUaiXhCQrOwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/actions.vue?macro=true";
import { default as add_45documentwJLMAkCM57Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/add-document.vue?macro=true";
import { default as add_45driver96UmanjykMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/add-driver.vue?macro=true";
import { default as documentdRloMJne5yMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/document.vue?macro=true";
import { default as driver_45history_45detailQpi8yACczvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/driver-history-detail.vue?macro=true";
import { default as edit_45document_45driveraGhUUdVNOuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/edit-document-driver.vue?macro=true";
import { default as edit_45driverszVzvIOgn6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/edit-driver.vue?macro=true";
import { default as history_45drivercxmecrAzFdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/history-driver.vue?macro=true";
import { default as datasDekWumQ3hMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/imports/data.ts?macro=true";
import { default as formzVCQiXvtvGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/imports/form.ts?macro=true";
import { default as licenseSkm4LGydUmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/imports/license.ts?macro=true";
import { default as license_45addjQnN1EfCveMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/license-add.vue?macro=true";
import { default as license_45editZCTr83SPjnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/license-edit.vue?macro=true";
import { default as licenseVZrIlvZfH9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/license.vue?macro=true";
import { default as select_45driver8NXvYgmQPtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/select-driver.vue?macro=true";
import { default as listNnKcIAep4lMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/list.vue?macro=true";
import { default as index2vyEwxYv2oMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/index.vue?macro=true";
import { default as deadlineYz1tSrws8MMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/deadline.vue?macro=true";
import { default as journey_45cardNXgtvQhowYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-card.vue?macro=true";
import { default as journey_45detach_45cardrbUqIztnTFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-detach-card.vue?macro=true";
import { default as journey_45listZ2SBzP13LYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-list.vue?macro=true";
import { default as action_45tabsSZmqmRkMITMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/action-tabs.vue?macro=true";
import { default as boardq8EEmLBBS0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/board.vue?macro=true";
import { default as mapbPA7SI7XliMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/map.vue?macro=true";
import { default as warning_45listOXvsMGTg3JMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/warning-list.vue?macro=true";
import { default as journey_45scheduled6fNNUVcCTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule.vue?macro=true";
import { default as change_45partneru7WPTpBcKWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/change-partner.vue?macro=true";
import { default as container_45noc0IcEMPwzeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/container-no.vue?macro=true";
import { default as reasonbBG7FRg4JMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/reason.ts?macro=true";
import { default as update_45statusCveZRVOpPZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/update-status.vue?macro=true";
import { default as request0ppL3exicPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/request.vue?macro=true";
import { default as routegPPVQrj4e2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/route.vue?macro=true";
import { default as schedule_45infoYxmRf49m9xMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/schedule-info.vue?macro=true";
import { default as schedule_45settingsvapGJuDoZ1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/schedule-settings.vue?macro=true";
import { default as distributingG4ifoIbjS6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/distributing.vue?macro=true";
import { default as managementuLidR3Hnl4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/management.vue?macro=true";
import { default as journeyuEFJFjiCk6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey.vue?macro=true";
import { default as movementz8Gry1DFV4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/last-24h-path/ignore/movement.vue?macro=true";
import { default as indexFfBLit0tYIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/last-24h-path/index.vue?macro=true";
import { default as bookingoxLeS9ShNVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/booking.vue?macro=true";
import { default as booking_45detailFVrVYV1hUbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/booking-detail.vue?macro=true";
import { default as reject_45bookingIP0AxPLBYjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/reject-booking.vue?macro=true";
import { default as addH3kHXlO6zqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/add.vue?macro=true";
import { default as detail6yahiKY4MfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/detail.vue?macro=true";
import { default as editEKdcEQSu6SMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/edit.vue?macro=true";
import { default as workflow_45positionkjh3eAOlY7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/workflow-position.vue?macro=true";
import { default as update_45statusYAjgyNEPnAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/update-status.vue?macro=true";
import { default as settingJPMkLqdLl1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/setting.vue?macro=true";
import { default as alert_45list_45drawerptei8wdEUOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/alert-list-drawer.vue?macro=true";
import { default as alert_45listeO0PmsYRuHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/alert-list.vue?macro=true";
import { default as alert_45statusGh7z1JepktMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/alert-status.vue?macro=true";
import { default as vehicle_45itemyAJTP1b8CzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/vehicle-item.vue?macro=true";
import { default as vehicle_45list5uOOkqOThEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/vehicle-list.vue?macro=true";
import { default as abc8oGyA3X0S9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-driver/abc.vue?macro=true";
import { default as driverRMP3dfQexvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/driver.vue?macro=true";
import { default as ownerdXt91RKPU0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/owner.vue?macro=true";
import { default as partner9CJGiRqWXSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/partner.vue?macro=true";
import { default as monitoringTUMctEemzTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring.vue?macro=true";
import { default as add_45order3qQC9MFlcrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/add-order.vue?macro=true";
import { default as canceltzIafmJQZEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/cancel.vue?macro=true";
import { default as container_45numbersEAisTbN5emMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/container-numbers.vue?macro=true";
import { default as CRMStatussgCkPC0RU8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/CRMStatus.vue?macro=true";
import { default as date_45timeIlNxk3CkuTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/date-time.vue?macro=true";
import { default as deadlinesBKLgY79VqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/deadline.vue?macro=true";
import { default as delivery_45warehousecMkL4tb08kMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/delivery-warehouse.vue?macro=true";
import { default as edit_45productivityXRiNgnm2dCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/edit-productivity.vue?macro=true";
import { default as edit_45travel_45timejZxrJGKDfJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/edit-travel-time.vue?macro=true";
import { default as loading_45taskXffBuFPb9lMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/loading-task.vue?macro=true";
import { default as requestLm866z3CsZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/request.vue?macro=true";
import { default as condition_45setting0bhYwCitbxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/condition-setting.vue?macro=true";
import { default as add_45container_45numbersSiJCQrxPqmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/add-container-numbers.vue?macro=true";
import { default as add_45partnergmNgR270NlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/add-partner.vue?macro=true";
import { default as add_45quote_45to_45orderVikPrfBH8iMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/add-quote-to-order.ts?macro=true";
import { default as allotmentPWrqr31BDhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/allotment.vue?macro=true";
import { default as edit_45allotmentHaNoS9vIoEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/edit-allotment.vue?macro=true";
import { default as edit_45shipping_45plan0x6hBtAIb5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/edit-shipping-plan.vue?macro=true";
import { default as general_45informationdWDNB3QjclMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/general-information.vue?macro=true";
import { default as indexqRYybmEyxWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/index.vue?macro=true";
import { default as quotemkqYeOj3PGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/quote.vue?macro=true";
import { default as shipping_45planbnD0V1ugNsMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/shipping-plan.vue?macro=true";
import { default as add_45document8MK3VYeOPZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/document/add-document.vue?macro=true";
import { default as documentxhJMEAief8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/document/document.vue?macro=true";
import { default as edit_45documentMWIsAE2bD8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/document/edit-document.vue?macro=true";
import { default as edit_45orderJo2WPpvTuUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/edit-order.vue?macro=true";
import { default as edit_45requestD1rNLs92M4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/edit-request.vue?macro=true";
import { default as dataRmVx997a9EMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/imports/data.ts?macro=true";
import { default as formFOj5CPw4WgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/imports/form.ts?macro=true";
import { default as indexTY871TUKOXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/optimize-waiting-time/index.vue?macro=true";
import { default as directioniiBEhxmRCLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/plugins/direction.ts?macro=true";
import { default as indexH7osqianbhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/plugins/index.ts?macro=true";
import { default as route7ly496D2lkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/plugins/route.ts?macro=true";
import { default as shipping_45informationhufq0ncYsGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/shipping-information.vue?macro=true";
import { default as shipping_45plan7bLatUaRnyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/shipping-plan.vue?macro=true";
import { default as commodityAB3ry5iGB6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/table/commodity.vue?macro=true";
import { default as contC3ymfRUVfgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/table/cont.vue?macro=true";
import { default as customerUfWZ78M6YNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/table/customer.vue?macro=true";
import { default as travel_45detailnVUisQTAUPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/travel-detail.vue?macro=true";
import { default as waiting_45taskOCy4SeowezMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/waiting-task.vue?macro=true";
import { default as indexUgWQRpy55OMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/index.vue?macro=true";
import { default as actionsECPF9MXEszMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/actions.vue?macro=true";
import { default as addovjBZFSYpkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/add.vue?macro=true";
import { default as cooperator_45labelDw87l4y1OfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/cooperator-label.vue?macro=true";
import { default as detailgFMW9D08TGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/detail.vue?macro=true";
import { default as formFViQkYDutfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/imports/form.ts?macro=true";
import { default as inviteQBkBwTglkUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/invite.vue?macro=true";
import { default as selectUpGP0YMGIAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/select.vue?macro=true";
import { default as statusG2LD2bTXMIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/status.vue?macro=true";
import { default as commodity_45nameAGH7XImncGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/tabels/commodity-name.vue?macro=true";
import { default as system_45participation_45statustap4gRD1mvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/tabels/system-participation-status.vue?macro=true";
import { default as addQSZiSbozRwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank/-components/add.vue?macro=true";
import { default as editK6z0PSM22lMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank/[idbank]/edit.vue?macro=true";
import { default as bankXK92VF4ZySMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank/ignore/bank.ts?macro=true";
import { default as bankf6n1P5WgoVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank.vue?macro=true";
import { default as adddvOYtQndZJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/-components/add.vue?macro=true";
import { default as positionB31HNuPQB8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/-components/position.vue?macro=true";
import { default as workflow_45positionqnpHCDCrr6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/-components/workflow-position.vue?macro=true";
import { default as editBFAdtBdmNMMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/edit.vue?macro=true";
import { default as replicate3R8V0laWYRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/replicate.vue?macro=true";
import { default as business_45opportunitybjh3BUg4YrMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity.vue?macro=true";
import { default as add_45commoditydd5AByyWUaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue?macro=true";
import { default as edit6u376kNzpFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/commodity/[idcommodity]/edit.vue?macro=true";
import { default as commodityeugQ5g56nKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/commodity.vue?macro=true";
import { default as addXgXayuHXdGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact/-components/add.vue?macro=true";
import { default as editmJFfDOrxOxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact/[idcontact]/edit.vue?macro=true";
import { default as datalzHAFk0dGNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact/ignore/data.ts?macro=true";
import { default as contactmfJdVOvQP6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact.vue?macro=true";
import { default as add_45documentt2AWS8yN9AMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document/-components/add-document.vue?macro=true";
import { default as approvezkn0M1OYyaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document/[iddocumentpartner]/approve.vue?macro=true";
import { default as editvCkyB2C6QDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document/[iddocumentpartner]/edit.vue?macro=true";
import { default as documentiZadIVU8IGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document.vue?macro=true";
import { default as editnuckr1saPJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/edit.vue?macro=true";
import { default as addDwLLqAyMWFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information/-components/add.vue?macro=true";
import { default as editpV530QmxF4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information/[idinvoicinginformation]/edit.vue?macro=true";
import { default as dataARayRfeXNkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information/ignore/data.ts?macro=true";
import { default as invoicing_45information5aFjL3XuU0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information.vue?macro=true";
import { default as addBGZ9KISJZ8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/add.vue?macro=true";
import { default as detailT5mRTNnGU3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/detail.vue?macro=true";
import { default as editsDOuliBmPoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/edit.vue?macro=true";
import { default as formNdW0OVa5DUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/form.ts?macro=true";
import { default as utilsvnH52HlVukMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/utils.ts?macro=true";
import { default as task_45completion_45timevGgwJSC8n3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time.vue?macro=true";
import { default as customer0UjIz1B0VKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/accept/customer.vue?macro=true";
import { default as vendorKbiDfxahCaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/accept/vendor.vue?macro=true";
import { default as partner4GYiNwMbYtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner.vue?macro=true";
import { default as add3dyzk91sddMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/-components/add.vue?macro=true";
import { default as view_45price_45vendorjXr20yeBFuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/-components/view-price-vendor.vue?macro=true";
import { default as editXQLuDzUd4kMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/[cooperatorId]/edit.vue?macro=true";
import { default as view0pUZy9HVttMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/[cooperatorId]/view.vue?macro=true";
import { default as actionvRbV19QLJeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/action.vue?macro=true";
import { default as detailqvpMzDGbVpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/detail.vue?macro=true";
import { default as dataVBo7q3Al50Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/ignore/data.ts?macro=true";
import { default as formz30MyZrXlFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/ignore/form.ts?macro=true";
import { default as statusQ80Qy3NsTBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/status.vue?macro=true";
import { default as vendord33NjCINKCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor.vue?macro=true";
import { default as change_45passwordW4dw3pXW55Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index/change-password.vue?macro=true";
import { default as informationgauq6QcxojMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index/information.vue?macro=true";
import { default as timeF56KmZ7Yc6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index/time.vue?macro=true";
import { default as indexjnMIkU8HWyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index.vue?macro=true";
import { default as indexryEtqrHrF3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/provider/index.vue?macro=true";
import { default as addcGXf0NcHXLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/add.vue?macro=true";
import { default as createiSxee5ZWgTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/create.vue?macro=true";
import { default as form3YsZyerW0oMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/ignore/imports/form.ts?macro=true";
import { default as informationUVrEJe6PzyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/information.vue?macro=true";
import { default as markup_45editsY4ILo4Q3GMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/markup-edit.vue?macro=true";
import { default as markup_45view7E8fM73bb1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/markup-view.vue?macro=true";
import { default as price_45information55tbg4SRatMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/price-information.vue?macro=true";
import { default as sync_45status94sDZZESD4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/sync-status.vue?macro=true";
import { default as type_45commodity_45nameJlgLP3eWVuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/type-commodity-name.vue?macro=true";
import { default as view_45offline_45feeIsxl18KxUUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-offline-fee.vue?macro=true";
import { default as view_45price_45detailbs0QjlNCaZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-price-detail.vue?macro=true";
import { default as view_45price_45vendor6BQ8Kp1YKtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-price-vendor.vue?macro=true";
import { default as view_45quote_45price4OG9h6U12HMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-quote-price.vue?macro=true";
import { default as data_45table_45pricefSTMyMAMdxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management/-components/data-table-price.vue?macro=true";
import { default as edit2RbAkoB0cJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management/[idquote]/edit.vue?macro=true";
import { default as viewzDdZlqRpk9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management/[idquote]/view.vue?macro=true";
import { default as managementFogm2MHnXqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management.vue?macro=true";
import { default as add_45quoteLooArpr3IfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/add-quote.vue?macro=true";
import { default as addJQlgmtmbAYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/add.vue?macro=true";
import { default as formqQhmvgOUURMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/ignore/imports/form.ts?macro=true";
import { default as routing_45connectionldJU7vwom6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/routing-connection.vue?macro=true";
import { default as view_45positionllhw0Ocy4aMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/view-position.vue?macro=true";
import { default as workflow_45positionwOLfN5qMu0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/workflow-position.vue?macro=true";
import { default as editFFLkLgENt7Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/[idquoterequest]/edit.vue?macro=true";
import { default as viewIGj2XtKIPtMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/[idquoterequest]/view.vue?macro=true";
import { default as quote_45requestwnCa0fZEg1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request.vue?macro=true";
import { default as quoteeacvqrOejuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote.vue?macro=true";
import { default as driverLEEacP5ULCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index/driver.vue?macro=true";
import { default as supplytcsOPktl8CMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index/supply.vue?macro=true";
import { default as vehicleN3ciMHgJiVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index/vehicle.vue?macro=true";
import { default as index7xf9VjOGtuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index.vue?macro=true";
import { default as customertS3Kv7L2RyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/customer.vue?macro=true";
import { default as distributionebAA7869LJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/distribution.vue?macro=true";
import { default as driverw3UQDPW3rkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/driver.vue?macro=true";
import { default as journeykdqkmeX1IAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/journey.vue?macro=true";
import { default as opportunityFRo0SjFafYMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/opportunity.vue?macro=true";
import { default as order1utcwoUs1iMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/order.vue?macro=true";
import { default as partnerpz97BUlojnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/partner.vue?macro=true";
import { default as route8ZlsIdUhSfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/route.vue?macro=true";
import { default as sale_45kpiaW91VtR4noMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/sale-kpi.vue?macro=true";
import { default as salesUsDV3COAx9Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/sales.vue?macro=true";
import { default as taske1Wld4SEo5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/task.vue?macro=true";
import { default as toll_45station_45vehicletAD9OTuNoXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/toll-station-vehicle.vue?macro=true";
import { default as toll_45stationwDY0l4H04DMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/toll-station.vue?macro=true";
import { default as tripgQkliiHfnlMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/trip.vue?macro=true";
import { default as vehicleqEwGH3wCL6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/vehicle.vue?macro=true";
import { default as workflowoNqOP3v3BCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/workflow.vue?macro=true";
import { default as general3mxddnJ7ZmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general.vue?macro=true";
import { default as reportooK4Bg6enKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report.vue?macro=true";
import { default as internalzZ17EqsaVxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route-fee/index/internal.vue?macro=true";
import { default as partnerzuITrwBlCLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route-fee/index/partner.vue?macro=true";
import { default as indexXQH6TaNWazMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route-fee/index.vue?macro=true";
import { default as addXYnc92a0rdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/add.vue?macro=true";
import { default as deleteEOPlvGSXXTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/delete.vue?macro=true";
import { default as detailjo4fgH0G6QMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/detail.vue?macro=true";
import { default as editCsP7ZjLCarMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/edit.vue?macro=true";
import { default as route_45mapV4pL0GDovBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/route-map.ts?macro=true";
import { default as distancevbjwROgMmeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/distance.vue?macro=true";
import { default as durationlWoTONDo6NMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/duration.vue?macro=true";
import { default as routeEoAGQyOm6lMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/route.vue?macro=true";
import { default as toll_45stationEAWP7aNPrBMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/toll-station.vue?macro=true";
import { default as indexqmPjlM85hOMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/index.vue?macro=true";
import { default as add_45routingJjKBaPAgpZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/add-routing.vue?macro=true";
import { default as edit_45routingBA4peeVnqXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/edit-routing.vue?macro=true";
import { default as input_45routinghbLnFCV1ixMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/component/input-routing.vue?macro=true";
import { default as formXiwH9Xt3NUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/imports/form.ts?macro=true";
import { default as utilsczvE4plfCLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/imports/utils.ts?macro=true";
import { default as map_45routingIR7Aj5e5OqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/screen/map-routing.vue?macro=true";
import { default as select_45routingXEUaVIuxxzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/screen/select-routing.vue?macro=true";
import { default as listXooF2JJqgRMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/list.vue?macro=true";
import { default as routing_45detailrUD9TgiNBdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/routing-detail.vue?macro=true";
import { default as booking4OPpo1UWn1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/booking.vue?macro=true";
import { default as customsxDzyDmK6bhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/customs.vue?macro=true";
import { default as documentzyopSOAActMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/document.vue?macro=true";
import { default as shipmentcSLt51J3bDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/shipment.vue?macro=true";
import { default as index9XSKIbmwt1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index.vue?macro=true";
import { default as dataX6YLaETZ7XMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/ignore/imports/data.ts?macro=true";
import { default as report_45card_45chartEUM1Orr9qaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-card-chart.vue?macro=true";
import { default as report_45chart5qSqdndJ1qMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-chart.vue?macro=true";
import { default as report_45detail_45tablesEx8pOJdNDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-detail-table.vue?macro=true";
import { default as report_45managementH3Ki1j9FC0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-management.vue?macro=true";
import { default as statusMiuaPGj5J8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/status.vue?macro=true";
import { default as company_45operation5pXP5kjEzZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/company-operation.vue?macro=true";
import { default as financeTaFvcSQrhAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/finance.vue?macro=true";
import { default as generalBX8nUCs0L3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/general.vue?macro=true";
import { default as add_45type_45supplyf1qNkljrZDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/add-type-supply.vue?macro=true";
import { default as edit_45type_45supplyJXoMbyMiFxMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/edit-type-supply.vue?macro=true";
import { default as list_45supply9P6YAIWTcgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/list-supply.vue?macro=true";
import { default as list_45type_45supplyFbZNXgPpPkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/list-type-supply.vue?macro=true";
import { default as supply_45document_45editorYuA081NTkLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-document-editor.vue?macro=true";
import { default as supply_45editorXYH4IiayrHMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-editor.vue?macro=true";
import { default as supply_45history_45detail4t0NYxH4aaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-history-detail.vue?macro=true";
import { default as supply_45historyosIB3b8yL3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-history.vue?macro=true";
import { default as supply_45insurance_45editor9s52ByPU9UMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-insurance-editor.vue?macro=true";
import { default as supply_45list_45documentn99n7lWN8jMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-list-document.vue?macro=true";
import { default as supply_45list_45insurancemezPOTaVqjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-list-insurance.vue?macro=true";
import { default as supply_45list_45pluginsmp1GqtwmPvMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-list-plugins.vue?macro=true";
import { default as supply_45plugins_45editor6P0HrkgQ7XMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-plugins-editor.vue?macro=true";
import { default as listqma2HMRB7LMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/list.vue?macro=true";
import { default as supplyfgOhhEwImeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/models/supply.ts?macro=true";
import { default as helperj8lBpIFFxLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/service/helper.ts?macro=true";
import { default as routerHVgxj5mEW2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/service/router.ts?macro=true";
import { default as testIeGXHqoNtuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/test.vue?macro=true";
import { default as addbNQgkO5iqwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/add.vue?macro=true";
import { default as create_45invoicew2BNI3TpZ5Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/create-invoice.vue?macro=true";
import { default as create_45receipt_45recordbUFG7FOSqTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/create-receipt-record.vue?macro=true";
import { default as delete_45invoiceUxHfpz7jo2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/delete-invoice.vue?macro=true";
import { default as detail_45invoiceHK4PP51jDmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/detail-invoice.vue?macro=true";
import { default as indexbgGbFAvbgDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/index.vue?macro=true";
import { default as invoicexA0hWIG0hnMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/invoice.vue?macro=true";
import { default as change_45tableRDjhRpJko8Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/-components/change-table.vue?macro=true";
import { default as InvoiceStatus9lMMt9X7Q3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/-components/InvoiceStatus.vue?macro=true";
import { default as createuBitbD7xEyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/create.vue?macro=true";
import { default as deleteP1tfhAG9jQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/delete.vue?macro=true";
import { default as detailttTmN6BQhqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/detail.vue?macro=true";
import { default as editHFpPqoYR22Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/edit.vue?macro=true";
import { default as list_45payment_45notegUHUad403nMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/list-payment-note.vue?macro=true";
import { default as listeHxV6p3PG6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/list.vue?macro=true";
import { default as cancelixOuo2dPECMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/cancel.vue?macro=true";
import { default as deadlinezTQxXeyIIzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/deadline.vue?macro=true";
import { default as journey_45cellrPmXAtD5FkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/journey-cell.vue?macro=true";
import { default as requestUyjJYZtscIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/request.vue?macro=true";
import { default as routeCO1CPF6hBVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/route.vue?macro=true";
import { default as detailOFWtyscyATMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/detail.vue?macro=true";
import { default as edit4pFeiGVasqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/edit.vue?macro=true";
import { default as indexuTOgLDZMfCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/index.vue?macro=true";
import { default as indexqe3u8XQYmgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/unit-price/index.vue?macro=true";
import { default as actionsWkIgEqnya6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/actions.vue?macro=true";
import { default as add_45toll_45stationhJHzGo380zMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/add-toll-station.vue?macro=true";
import { default as add_45vehiclegP2RU08OdJMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/add-vehicle.vue?macro=true";
import { default as select_45remooc_45categoryy0daixLeogMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/autocomplete/select-remooc-category.vue?macro=true";
import { default as select_45remoocrasWLoHmUzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/autocomplete/select-remooc.vue?macro=true";
import { default as select_45vehicle_45categoryBzjMo5CBdjMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/autocomplete/select-vehicle-category.vue?macro=true";
import { default as detail_45vehicle4K4mk0cEm6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/detail-vehicle.vue?macro=true";
import { default as add_45document5EeKXpVDJFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/document/add-document.vue?macro=true";
import { default as documentpw3iRYH5ZWMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/document/document.vue?macro=true";
import { default as edit_45documentBqHOoJJhKEMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/document/edit-document.vue?macro=true";
import { default as edit_45vehiclemICjpC1OlPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/edit-vehicle.vue?macro=true";
import { default as open0gdzli0lQaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/exploit/open.vue?macro=true";
import { default as stopz4hcEI14XwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/exploit/stop.vue?macro=true";
import { default as form9E5ckdFAf6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/imports/form.ts?macro=true";
import { default as remoocsNGxYblDI1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/imports/remooc.ts?macro=true";
import { default as utilspApRjf06C6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/imports/utils.ts?macro=true";
import { default as add_45plugin4RAFJ4aq0EMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/plugin/add-plugin.vue?macro=true";
import { default as list_45pluginbJn1YmTB5TMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/plugin/list-plugin.vue?macro=true";
import { default as add_45remooc_45categorypF9sgHNovsMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-category/add-remooc-category.vue?macro=true";
import { default as detailtoQMYVa8jSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-category/detail.vue?macro=true";
import { default as edit_45remooc_45categoryHGL6nTuat4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-category/edit-remooc-category.vue?macro=true";
import { default as add_45documentRTLxumwwIQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-document/add-document.vue?macro=true";
import { default as document0ePDPpKh4kMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-document/document.vue?macro=true";
import { default as edit_45documentjb1vKY2VBVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-document/edit-document.vue?macro=true";
import { default as add_45remoocoKEaRczYNcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc/add-remooc.vue?macro=true";
import { default as detailXv825K4f0UMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc/detail.vue?macro=true";
import { default as edit_45remoocvQPakjYVb0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc/edit-remooc.vue?macro=true";
import { default as addmw3qIpmTjgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/add.vue?macro=true";
import { default as detailiDi49Bk6x2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/detail.vue?macro=true";
import { default as editfOz6OGMoOuMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/edit.vue?macro=true";
import { default as link_45documentBZS4CHoOxcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/link-document.vue?macro=true";
import { default as statusjCIK87l6JLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/status.vue?macro=true";
import { default as listiaOBKjssLyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/list.vue?macro=true";
import { default as remooc_45categoryYjGbABZ26AMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/remooc-category.vue?macro=true";
import { default as remoocL4h7jTfCyhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/remooc.vue?macro=true";
import { default as repair05quiPmQ9mMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/repair.vue?macro=true";
import { default as trucker_45_91id_937WrNPBndifMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id].vue?macro=true";
import { default as adminlqHO6EzvoyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/admin.vue?macro=true";
import { default as addm8AM5LhAt2Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/add.vue?macro=true";
import { default as deleteui8WmpfLgZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/delete.vue?macro=true";
import { default as detail8Ktsz8BAOfMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/detail.vue?macro=true";
import { default as edit64gKZAwD2JMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/edit.vue?macro=true";
import { default as dataYbhg976bZzMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/imports/data.ts?macro=true";
import { default as formVDxghkvZlPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/imports/form.ts?macro=true";
import { default as node_45type_45nameIsJKeMBo5PMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/node-type-name.vue?macro=true";
import { default as node_45typesOVfuVrDqcGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/node-types.vue?macro=true";
import { default as task_45nameRXtmn8TR05Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/task-name.vue?macro=true";
import { default as tasks_45name802jLhn4PgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/tasks-name.vue?macro=true";
import { default as addo5l8GYH6tpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/add.vue?macro=true";
import { default as deletegCksBAKaPdMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/delete.vue?macro=true";
import { default as detailgL0rFlQXUTMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/detail.vue?macro=true";
import { default as editlQDMmvd0aGMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/edit.vue?macro=true";
import { default as replicateSGXma945sSMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/replicate.vue?macro=true";
import { default as task_45nameEZSCWSMuveMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/task-name.vue?macro=true";
import { default as index3EnYjlgF8ZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/index.vue?macro=true";
import { default as taskKnsdaoXECwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/task.vue?macro=true";
import { default as history9OMCKGMfztMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/history.vue?macro=true";
import { default as add_45nodewpsbcVhc6PMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/add-node.vue?macro=true";
import { default as select_45nodeANQRX6DEugMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/autocomplete/select-node.vue?macro=true";
import { default as detail_45nodey2C7D5I7xpMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/detail-node.vue?macro=true";
import { default as edit_45nodehorDx5j7O4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/edit-node.vue?macro=true";
import { default as initnOmsapP7VbMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/imports/init.ts?macro=true";
import { default as model5CBCx2LUxDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/imports/model.ts?macro=true";
import { default as utilshwFIkpkrLeMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/imports/utils.ts?macro=true";
import { default as addQ0OEBEC1CLMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/add.vue?macro=true";
import { default as detailba09DXhOUKMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/detail.vue?macro=true";
import { default as edittW6q5HWMxCMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/edit.vue?macro=true";
import { default as listYeY5tvPYajMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/list.vue?macro=true";
import { default as business_45namehWPbjxHNQoMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/tables/business-name.vue?macro=true";
import { default as node_45nameF8nTuyRRfgMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/tables/node-name.vue?macro=true";
import { default as task_45nameZRiUNzJStAMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/tables/task-name.vue?macro=true";
import { default as edit_45working_45timeMGN9R7xMA4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node/edit-working-time.vue?macro=true";
import { default as toll_45stationsUSWxKVl9RDMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node/toll-stations.vue?macro=true";
import { default as working_45timerTn5BH3vsIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node/working-time.vue?macro=true";
import { default as business_45namehWiuMmv29uMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/tables/business-name.vue?macro=true";
import { default as addx85kxEF8GcMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/add.vue?macro=true";
import { default as deleteXMqdiPNlE3Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/delete.vue?macro=true";
import { default as detailRR7gwyFl35Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/detail.vue?macro=true";
import { default as editlLpfCMLzfZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/edit.vue?macro=true";
import { default as update_45relation_45node0FI2ldIYTyMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/update-relation-node.vue?macro=true";
import { default as listM7GGIDcx8iMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/list.vue?macro=true";
import { default as actionbgY6wnmjCQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/action.vue?macro=true";
import { default as addAFxrtTG06pMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/add.vue?macro=true";
import { default as detail8U1mJaUzrPMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/detail.vue?macro=true";
import { default as editebqzB7snmVMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/edit.vue?macro=true";
import { default as location4RSA0l79WaMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location.vue?macro=true";
import { default as typeXGNjshNhx1Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/type.vue?macro=true";
import { default as index6BY1J6HGiQMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle-search-setting/index.vue?macro=true";
import { default as addv2eYur8w5oMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/ignore/add.vue?macro=true";
import { default as editbLRClLmq4yMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/ignore/edit.vue?macro=true";
import { default as formwJEfsrsGq6Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/ignore/import/form.ts?macro=true";
import { default as index9KhDIiUKVXMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/index.vue?macro=true";
import { default as indexkD0m4kc33zMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/index.vue?macro=true";
import { default as addlxyyLSSssFMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/add.vue?macro=true";
import { default as deleteyYBBLllcwqMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/delete.vue?macro=true";
import { default as detailOt769TD0qmMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/detail.vue?macro=true";
import { default as editGy4AKtRJNIMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/edit.vue?macro=true";
import { default as find_45businessSBuwxNqnBkMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/find-business.vue?macro=true";
import { default as setting_45position_45numberZf0GCkenU0Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/setting-position-number.vue?macro=true";
import { default as workflow_45positionj6gQQyOComMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/workflow-position.vue?macro=true";
import { default as datavf1TOjARrwMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-imports/data.ts?macro=true";
import { default as formpTPyT1wA1MMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-imports/form.ts?macro=true";
import { default as index5r1eCCGyjiMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/index.vue?macro=true";
import { default as trucker_45admin_45_91id_93JC5eyqWJ5xMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id].vue?macro=true";
import { default as booking_45managementZqL6Ser4taMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/booking-management.vue?macro=true";
import { default as booking_45detailzZ8uEmcIzNMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/ignore/booking-detail.vue?macro=true";
import { default as cancel_45booking9Um3t0RId4Meta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/ignore/cancel-booking.vue?macro=true";
import { default as search_45bookingE8j4rLMb5lMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/search-booking.vue?macro=true";
import { default as index3CRdd9qptUMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/upgrate/index.vue?macro=true";
import { default as userAmT8guRmOZMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user.vue?macro=true";
import { default as listeVPs6P69MhMeta } from "C:/Users/ngngo/Projects/ft_hts_fe/src/pages/workspace/list.vue?macro=true";
export default [
  {
    name: "admincp",
    path: "/admincp",
    meta: admincpdQcDN9vAnnMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp.vue"),
    children: [
  {
    name: "admincp-business-ignore-businesses-add",
    path: "business/ignore/businesses/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/add.vue")
  },
  {
    name: "admincp-business-ignore-businesses-delete",
    path: "business/ignore/businesses/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/delete.vue")
  },
  {
    name: "admincp-business-ignore-businesses-detail",
    path: "business/ignore/businesses/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/detail.vue")
  },
  {
    name: "admincp-business-ignore-businesses-edit",
    path: "business/ignore/businesses/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/businesses/edit.vue")
  },
  {
    name: "admincp-business-ignore-imports-data",
    path: "business/ignore/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/imports/data.ts")
  },
  {
    name: "admincp-business-ignore-imports-form",
    path: "business/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/imports/form.ts")
  },
  {
    name: "admincp-business-ignore-tables-node-type-name",
    path: "business/ignore/tables/node-type-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/node-type-name.vue")
  },
  {
    name: "admincp-business-ignore-tables-node-types",
    path: "business/ignore/tables/node-types",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/node-types.vue")
  },
  {
    name: "admincp-business-ignore-tables-task-name",
    path: "business/ignore/tables/task-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/task-name.vue")
  },
  {
    name: "admincp-business-ignore-tables-tasks-name",
    path: "business/ignore/tables/tasks-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tables/tasks-name.vue")
  },
  {
    name: "admincp-business-ignore-tasks-add",
    path: "business/ignore/tasks/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/add.vue")
  },
  {
    name: "admincp-business-ignore-tasks-delete",
    path: "business/ignore/tasks/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/delete.vue")
  },
  {
    name: "admincp-business-ignore-tasks-detail",
    path: "business/ignore/tasks/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/detail.vue")
  },
  {
    name: "admincp-business-ignore-tasks-edit",
    path: "business/ignore/tasks/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/edit.vue")
  },
  {
    name: "admincp-business-ignore-tasks-replicate",
    path: "business/ignore/tasks/replicate",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/replicate.vue")
  },
  {
    name: "admincp-business-ignore-tasks-task-name",
    path: "business/ignore/tasks/task-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/ignore/tasks/task-name.vue")
  },
  {
    name: "admincp-business",
    path: "business",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/index.vue")
  },
  {
    name: "admincp-business-task",
    path: "business/task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/business/task.vue")
  },
  {
    name: "admincp-dashboard--components-rating",
    path: "dashboard/-components/rating",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/rating.vue")
  },
  {
    name: "admincp-dashboard--components-view-detail-static",
    path: "dashboard/-components/view-detail-static",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/view-detail-static.vue")
  },
  {
    name: "admincp-dashboard--components-view-general-static",
    path: "dashboard/-components/view-general-static",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/view-general-static.vue")
  },
  {
    name: "admincp-dashboard--components-view-map",
    path: "dashboard/-components/view-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/-components/view-map.vue")
  },
  {
    name: "admincp-dashboard",
    path: "dashboard",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/dashboard/index.vue")
  },
  {
    name: "admincp-node-history",
    path: "node/history",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/history.vue")
  },
  {
    name: "admincp-node-ignore-add-node",
    path: "node/ignore/add-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/add-node.vue")
  },
  {
    name: "admincp-node-ignore-autocomplete-select-node",
    path: "node/ignore/autocomplete/select-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/autocomplete/select-node.vue")
  },
  {
    name: "admincp-node-ignore-detail-node",
    path: "node/ignore/detail-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/detail-node.vue")
  },
  {
    name: "admincp-node-ignore-edit-node",
    path: "node/ignore/edit-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/edit-node.vue")
  },
  {
    name: "admincp-node-ignore-imports-init",
    path: "node/ignore/imports/init",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/imports/init.ts")
  },
  {
    name: "admincp-node-ignore-imports-model",
    path: "node/ignore/imports/model",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/imports/model.ts")
  },
  {
    name: "admincp-node-ignore-imports-utils",
    path: "node/ignore/imports/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/imports/utils.ts")
  },
  {
    name: "admincp-node-ignore-node-connection-add",
    path: "node/ignore/node-connection/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/add.vue")
  },
  {
    name: "admincp-node-ignore-node-connection-detail",
    path: "node/ignore/node-connection/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/detail.vue")
  },
  {
    name: "admincp-node-ignore-node-connection-edit",
    path: "node/ignore/node-connection/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/edit.vue")
  },
  {
    name: "admincp-node-ignore-node-connection-list",
    path: "node/ignore/node-connection/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/list.vue")
  },
  {
    name: "admincp-node-ignore-node-connection-tables-business-name",
    path: "node/ignore/node-connection/tables/business-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/tables/business-name.vue")
  },
  {
    name: "admincp-node-ignore-node-connection-tables-node-name",
    path: "node/ignore/node-connection/tables/node-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/tables/node-name.vue")
  },
  {
    name: "admincp-node-ignore-node-connection-tables-task-name",
    path: "node/ignore/node-connection/tables/task-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node-connection/tables/task-name.vue")
  },
  {
    name: "admincp-node-ignore-node-edit-working-time",
    path: "node/ignore/node/edit-working-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node/edit-working-time.vue")
  },
  {
    name: "admincp-node-ignore-node-toll-stations",
    path: "node/ignore/node/toll-stations",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node/toll-stations.vue")
  },
  {
    name: "admincp-node-ignore-node-working-time",
    path: "node/ignore/node/working-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/node/working-time.vue")
  },
  {
    name: "admincp-node-ignore-tables-business-name",
    path: "node/ignore/tables/business-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/tables/business-name.vue")
  },
  {
    name: "admincp-node-ignore-type-add",
    path: "node/ignore/type/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/add.vue")
  },
  {
    name: "admincp-node-ignore-type-delete",
    path: "node/ignore/type/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/delete.vue")
  },
  {
    name: "admincp-node-ignore-type-detail",
    path: "node/ignore/type/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/detail.vue")
  },
  {
    name: "admincp-node-ignore-type-edit",
    path: "node/ignore/type/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/type/edit.vue")
  },
  {
    name: "admincp-node-ignore-update-relation-node",
    path: "node/ignore/update-relation-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/ignore/update-relation-node.vue")
  },
  {
    name: "admincp-node-list",
    path: "node/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/list.vue")
  },
  {
    name: "admincp-node-location",
    path: "node/location",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location.vue"),
    children: [
  {
    name: "admincp-node-location-ignore-action",
    path: "ignore/action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location/ignore/action.vue")
  },
  {
    name: "admincp-node-location-ignore-add",
    path: "ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location/ignore/add.vue")
  },
  {
    name: "admincp-node-location-ignore-detail",
    path: "ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/location/ignore/detail.vue")
  }
]
  },
  {
    name: "admincp-node-type",
    path: "node/type",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/node/type.vue")
  },
  {
    name: "admincp-profile",
    path: "profile",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index.vue"),
    children: [
  {
    name: "admincp-profile-index-change-password",
    path: "change-password",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index/change-password.vue")
  },
  {
    name: "admincp-profile-index-information",
    path: "information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index/information.vue")
  },
  {
    name: "admincp-profile-index-time",
    path: "time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/profile/index/time.vue")
  }
]
  },
  {
    name: "admincp-settings",
    path: "settings",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/settings/index.vue")
  },
  {
    name: "admincp-settings-toll-stations",
    path: "settings/toll-stations",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/settings/toll-stations/index.vue")
  },
  {
    name: "admincp-users",
    path: "users",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/users.vue")
  },
  {
    name: "admincp-vehicle-category-ignore-add",
    path: "vehicle/category/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/ignore/add.vue")
  },
  {
    name: "admincp-vehicle-category-ignore-edit",
    path: "vehicle/category/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/ignore/edit.vue")
  },
  {
    name: "admincp-vehicle-category-ignore-import-form",
    path: "vehicle/category/ignore/import/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/ignore/import/form.ts")
  },
  {
    name: "admincp-vehicle-category",
    path: "vehicle/category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/category/index.vue")
  },
  {
    name: "admincp-vehicle",
    path: "vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/vehicle/index.vue")
  },
  {
    name: "admincp-workflow--components-add",
    path: "workflow/-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/add.vue")
  },
  {
    name: "admincp-workflow--components-delete",
    path: "workflow/-components/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/delete.vue")
  },
  {
    name: "admincp-workflow--components-detail",
    path: "workflow/-components/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/detail.vue")
  },
  {
    name: "admincp-workflow--components-edit",
    path: "workflow/-components/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/edit.vue")
  },
  {
    name: "admincp-workflow--components-find-business",
    path: "workflow/-components/find-business",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/find-business.vue")
  },
  {
    name: "admincp-workflow--components-setting-position-number",
    path: "workflow/-components/setting-position-number",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/setting-position-number.vue")
  },
  {
    name: "admincp-workflow--components-workflow-position",
    path: "workflow/-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-components/workflow-position.vue")
  },
  {
    name: "admincp-workflow--imports-data",
    path: "workflow/-imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-imports/data.ts")
  },
  {
    name: "admincp-workflow--imports-form",
    path: "workflow/-imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/-imports/form.ts")
  },
  {
    name: "admincp-workflow",
    path: "workflow",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workflow/index.vue")
  },
  {
    name: "admincp-workspaces",
    path: "workspaces",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/admincp/workspaces.vue")
  }
]
  },
  {
    name: "auth-callback-app",
    path: "/auth/callback-:app()",
    meta: callback_45_91app_93akkXQJ7UqOMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/callback-[app].vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordklIwaXTY1qMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-invite-user",
    path: "/auth/invite-user",
    meta: invite_45userQWvhSsLDCNMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/invite-user.vue")
  },
  {
    name: "auth-invite",
    path: "/auth/invite",
    meta: inviteShPWCr9mjTMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/invite.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginJWcdWYqCU1Meta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/login.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerMEj76kV8VdMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/register.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45passwordv9wuoNR4fGMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/auth/reset-password.vue")
  },
  {
    name: c_45_91id_93mCBZJ3unozMeta?.name,
    path: "/c-:id()",
    meta: c_45_91id_93mCBZJ3unozMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id].vue"),
    children: [
  {
    name: "c-id--components-activity-detail-orders",
    path: "-components/activity-detail/orders",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity-detail/orders.vue")
  },
  {
    name: "c-id--components-activity-detail-quote-request",
    path: "-components/activity-detail/quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity-detail/quote-request.vue")
  },
  {
    name: "c-id--components-activity-detail-table",
    path: "-components/activity-detail/table",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity-detail/table.vue")
  },
  {
    name: "c-id--components-activity",
    path: "-components/activity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/activity.vue")
  },
  {
    name: "c-id--components-journey-info",
    path: "-components/journey-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info.vue"),
    children: [
  {
    name: "c-id--components-journey-info-activities",
    path: "activities",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/activities.vue")
  },
  {
    name: "c-id--components-journey-info-alert-components-alert-action",
    path: "alert-components/alert-action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-action.vue")
  },
  {
    name: "c-id--components-journey-info-alert-components-alert-stage",
    path: "alert-components/alert-stage",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-stage.vue")
  },
  {
    name: "c-id--components-journey-info-alert-components-alert-task-delay",
    path: "alert-components/alert-task-delay",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task-delay.vue")
  },
  {
    name: "c-id--components-journey-info-alert-components-alert-task-process",
    path: "alert-components/alert-task-process",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task-process.vue")
  },
  {
    name: "c-id--components-journey-info-alert-components-alert-task-waiting",
    path: "alert-components/alert-task-waiting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task-waiting.vue")
  },
  {
    name: "c-id--components-journey-info-alert-components-alert-task",
    path: "alert-components/alert-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-components/alert-task.vue")
  },
  {
    name: "c-id--components-journey-info-alert-item",
    path: "alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alert-item.vue")
  },
  {
    name: "c-id--components-journey-info-alerts",
    path: "alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/alerts.vue")
  },
  {
    name: "c-id--components-journey-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-alert-item.vue")
  },
  {
    name: "c-id--components-journey-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-info.vue")
  },
  {
    name: "c-id--components-journey-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-notifications.vue")
  },
  {
    name: "c-id--components-journey-info-driver-status",
    path: "driver-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/driver-status.vue")
  },
  {
    name: "c-id--components-journey-info-files",
    path: "files",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/files.vue")
  },
  {
    name: "c-id--components-journey-info-planning-actual",
    path: "planning-actual",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/planning-actual.vue")
  },
  {
    name: "c-id--components-journey-info-planning",
    path: "planning",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/planning.vue")
  },
  {
    name: "c-id--components-journey-info-prices",
    path: "prices",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/prices.vue")
  },
  {
    name: "c-id--components-journey-info-sub-tasks",
    path: "sub-tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/sub-tasks.vue")
  },
  {
    name: "c-id--components-journey-info-tasks",
    path: "tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/tasks.vue")
  },
  {
    name: "c-id--components-journey-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-detail.vue")
  },
  {
    name: "c-id--components-journey-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-map.vue")
  },
  {
    name: "c-id--components-journey-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-route-info.vue")
  },
  {
    name: "c-id--components-journey-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-step.vue")
  },
  {
    name: "c-id--components-journey-info-travel-tabs-alerts",
    path: "travel-tabs/alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-tabs/alerts.vue")
  },
  {
    name: "c-id--components-journey-info-travel-tabs",
    path: "travel-tabs",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel-tabs/index.vue")
  },
  {
    name: "c-id--components-journey-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/travel.vue")
  },
  {
    name: "c-id--components-journey-info-utils",
    path: "utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/utils.ts")
  },
  {
    name: "c-id--components-journey-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/vehicle-info.vue")
  },
  {
    name: "c-id--components-journey-info-vehicle-status",
    path: "vehicle-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/journey-info/vehicle-status.vue")
  }
]
  },
  {
    name: "c-id--components-time-condition-format",
    path: "-components/time-condition-format",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/time-condition-format.ts")
  },
  {
    name: "c-id--components-transportation-info-driver",
    path: "-components/transportation-info/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/transportation-info/driver.vue")
  },
  {
    name: "c-id--components-transportation-info",
    path: "-components/transportation-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/transportation-info/index.vue")
  },
  {
    name: "c-id--components-transportation-info-vehicle",
    path: "-components/transportation-info/vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/transportation-info/vehicle.vue")
  },
  {
    name: "c-id--components-trip-info-content",
    path: "-components/trip-info-content",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info-content.vue")
  },
  {
    name: "c-id--components-trip-info",
    path: "-components/trip-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info.vue"),
    children: [
  {
    name: "c-id--components-trip-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/driver-alert-item.vue")
  },
  {
    name: "c-id--components-trip-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/driver-info.vue")
  },
  {
    name: "c-id--components-trip-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/driver-notifications.vue")
  },
  {
    name: "c-id--components-trip-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-detail.vue")
  },
  {
    name: "c-id--components-trip-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-map.vue")
  },
  {
    name: "c-id--components-trip-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-route-info.vue")
  },
  {
    name: "c-id--components-trip-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel-step.vue")
  },
  {
    name: "c-id--components-trip-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/travel.vue")
  },
  {
    name: "c-id--components-trip-info-trip-files",
    path: "trip-files",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/trip-files.vue")
  },
  {
    name: "c-id--components-trip-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-info/vehicle-info.vue")
  }
]
  },
  {
    name: "c-id--components-trip-utils",
    path: "-components/trip-utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/-components/trip-utils.ts")
  },
  {
    name: "c-id-company-bank",
    path: "company/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/bank.vue")
  },
  {
    name: "c-id-company-branch",
    path: "company/branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/branch.vue")
  },
  {
    name: "c-id-company-global-settings",
    path: "company/global-settings",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings.vue"),
    children: [
  {
    name: "c-id-company-global-settings-cost-ignore-imports-form",
    path: "cost/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/cost/ignore/imports/form.ts")
  },
  {
    name: "c-id-company-global-settings-cost",
    path: "cost",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/cost/index.vue")
  },
  {
    name: "c-id-company-global-settings-general-ignore-imports-form",
    path: "general/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/ignore/imports/form.ts")
  },
  {
    name: "c-id-company-global-settings-general-ignore-setting-cont",
    path: "general/ignore/setting-cont",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/ignore/setting-cont.vue")
  },
  {
    name: "c-id-company-global-settings-general-ignore-update-markup",
    path: "general/ignore/update-markup",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/ignore/update-markup.vue")
  },
  {
    name: "c-id-company-global-settings-general",
    path: "general",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/general/index.vue")
  },
  {
    name: "c-id-company-global-settings-gps",
    path: "gps",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/gps/index.vue")
  },
  {
    name: "c-id-company-global-settings-partner-driver",
    path: "partner/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/driver/index.vue")
  },
  {
    name: "c-id-company-global-settings-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/index.vue")
  },
  {
    name: "c-id-company-global-settings-partner-remooc",
    path: "partner/remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/remooc/index.vue")
  },
  {
    name: "c-id-company-global-settings-partner-vehicle",
    path: "partner/vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/partner/vehicle/index.vue")
  },
  {
    name: "c-id-company-global-settings-policy-ignore-imports-form",
    path: "policy/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/policy/ignore/imports/form.ts")
  },
  {
    name: "c-id-company-global-settings-policy",
    path: "policy",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/policy/index.vue")
  },
  {
    name: "c-id-company-global-settings-route",
    path: "route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/route/index.vue")
  },
  {
    name: "c-id-company-global-settings-schedule",
    path: "schedule",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/schedule/index.vue")
  },
  {
    name: "c-id-company-global-settings-times-ignore-imports-form",
    path: "times/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/times/ignore/imports/form.ts")
  },
  {
    name: "c-id-company-global-settings-times",
    path: "times",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/global-settings/times/index.vue")
  }
]
  },
  {
    name: "c-id-company-history",
    path: "company/history",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/history.vue")
  },
  {
    name: "c-id-company-ignore-action",
    path: "company/ignore/action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/action.vue")
  },
  {
    name: "c-id-company-ignore-add-banking",
    path: "company/ignore/add-banking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/add-banking.vue")
  },
  {
    name: "c-id-company-ignore-add-branch",
    path: "company/ignore/add-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/add-branch.vue")
  },
  {
    name: "c-id-company-ignore-add-company",
    path: "company/ignore/add-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/add-company.vue")
  },
  {
    name: "c-id-company-ignore-banking-branch",
    path: "company/ignore/banking-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/banking-branch.vue")
  },
  {
    name: "c-id-company-ignore-company-history-detail",
    path: "company/ignore/company-history-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/company-history-detail.vue")
  },
  {
    name: "c-id-company-ignore-edit-bank",
    path: "company/ignore/edit-bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-bank.vue")
  },
  {
    name: "c-id-company-ignore-edit-banking-branch",
    path: "company/ignore/edit-banking-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-banking-branch.vue")
  },
  {
    name: "c-id-company-ignore-edit-branch",
    path: "company/ignore/edit-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-branch.vue")
  },
  {
    name: "c-id-company-ignore-edit-company",
    path: "company/ignore/edit-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-company.vue")
  },
  {
    name: "c-id-company-ignore-edit-invoice-branch",
    path: "company/ignore/edit-invoice-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-invoice-branch.vue")
  },
  {
    name: "c-id-company-ignore-edit-invoice",
    path: "company/ignore/edit-invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/edit-invoice.vue")
  },
  {
    name: "c-id-company-ignore-imports-banking-form",
    path: "company/ignore/imports/banking-form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/imports/banking-form.ts")
  },
  {
    name: "c-id-company-ignore-imports-form",
    path: "company/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/imports/form.ts")
  },
  {
    name: "c-id-company-ignore-imports-invoice-form",
    path: "company/ignore/imports/invoice-form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/imports/invoice-form.ts")
  },
  {
    name: "c-id-company-ignore-invoicing-branch",
    path: "company/ignore/invoicing-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/invoicing-branch.vue")
  },
  {
    name: "c-id-company-ignore-list-company",
    path: "company/ignore/list-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/ignore/list-company.vue")
  },
  {
    name: "c-id-company-information",
    path: "company/information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/information/index.vue")
  },
  {
    name: "c-id-company-information-update",
    path: "company/information/update",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/information/update.vue")
  },
  {
    name: "c-id-company-integration-internal-ignore-add",
    path: "company/integration/internal/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/integration/internal/ignore/add.vue")
  },
  {
    name: "c-id-company-integration-internal",
    path: "company/integration/internal",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/integration/internal/index.vue")
  },
  {
    name: "c-id-company-invoice",
    path: "company/invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/invoice.vue")
  },
  {
    name: "c-id-company-user-group--components-actions",
    path: "company/user-group/-components/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/actions.vue")
  },
  {
    name: "c-id-company-user-group--components-add-company-user",
    path: "company/user-group/-components/add-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/add-company-user.vue")
  },
  {
    name: "c-id-company-user-group--components-add-group",
    path: "company/user-group/-components/add-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/add-group.vue")
  },
  {
    name: "c-id-company-user-group--components-edit-company-user",
    path: "company/user-group/-components/edit-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/edit-company-user.vue")
  },
  {
    name: "c-id-company-user-group--components-edit-group",
    path: "company/user-group/-components/edit-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/edit-group.vue")
  },
  {
    name: "c-id-company-user-group--components-ignore-group-name",
    path: "company/user-group/-components/ignore/group-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/ignore/group-name.vue")
  },
  {
    name: "c-id-company-user-group--components-ignore-group-type",
    path: "company/user-group/-components/ignore/group-type",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/ignore/group-type.vue")
  },
  {
    name: "c-id-company-user-group--components-ignore-permission-checkbox",
    path: "company/user-group/-components/ignore/permission-checkbox",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/ignore/permission-checkbox.vue")
  },
  {
    name: "c-id-company-user-group--components-imports-data",
    path: "company/user-group/-components/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/imports/data.ts")
  },
  {
    name: "c-id-company-user-group--components-imports-form",
    path: "company/user-group/-components/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/imports/form.ts")
  },
  {
    name: "c-id-company-user-group--components-imports-model",
    path: "company/user-group/-components/imports/model",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/imports/model.ts")
  },
  {
    name: "c-id-company-user-group--components-update-permissions",
    path: "company/user-group/-components/update-permissions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/update-permissions.vue")
  },
  {
    name: "c-id-company-user-group--components-user-status",
    path: "company/user-group/-components/user-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/-components/user-status.vue")
  },
  {
    name: "c-id-company-user-group-groups",
    path: "company/user-group/groups",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/groups.vue")
  },
  {
    name: "c-id-company-user-group-users",
    path: "company/user-group/users",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/company/user-group/users.vue")
  },
  {
    name: "c-id-components",
    path: "components",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/components/index.vue")
  },
  {
    name: "c-id-dashboard",
    path: "dashboard",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/dashboard/index.vue")
  },
  {
    name: "c-id",
    path: "",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/index.vue")
  },
  {
    name: "c-id-order-ignore-actions",
    path: "order/ignore/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/actions.vue")
  },
  {
    name: "c-id-order-ignore-add-order",
    path: "order/ignore/add-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/add-order.vue")
  },
  {
    name: "c-id-order-ignore-cancel",
    path: "order/ignore/cancel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/cancel.vue")
  },
  {
    name: "c-id-order-ignore-component-container-numbers",
    path: "order/ignore/component/container-numbers",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/container-numbers.vue")
  },
  {
    name: "c-id-order-ignore-component-date-time",
    path: "order/ignore/component/date-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/date-time.vue")
  },
  {
    name: "c-id-order-ignore-component-deadline",
    path: "order/ignore/component/deadline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/deadline.vue")
  },
  {
    name: "c-id-order-ignore-component-delivery-warehouse",
    path: "order/ignore/component/delivery-warehouse",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/delivery-warehouse.vue")
  },
  {
    name: "c-id-order-ignore-component-edit-productivity",
    path: "order/ignore/component/edit-productivity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/edit-productivity.vue")
  },
  {
    name: "c-id-order-ignore-component-edit-travel-time",
    path: "order/ignore/component/edit-travel-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/edit-travel-time.vue")
  },
  {
    name: "c-id-order-ignore-component-loading-task",
    path: "order/ignore/component/loading-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/loading-task.vue")
  },
  {
    name: "c-id-order-ignore-component-request",
    path: "order/ignore/component/request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/component/request.vue")
  },
  {
    name: "c-id-order-ignore-condition-setting",
    path: "order/ignore/condition-setting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/condition-setting.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-add-container-numbers",
    path: "order/ignore/detail-order/add-container-numbers",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/add-container-numbers.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-add-partner",
    path: "order/ignore/detail-order/add-partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/add-partner.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-add-quote-to-order",
    path: "order/ignore/detail-order/add-quote-to-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/add-quote-to-order.ts")
  },
  {
    name: "c-id-order-ignore-detail-order-allotment",
    path: "order/ignore/detail-order/allotment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/allotment.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-edit-allotment",
    path: "order/ignore/detail-order/edit-allotment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/edit-allotment.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-edit-shipping-plan",
    path: "order/ignore/detail-order/edit-shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/edit-shipping-plan.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-general-information",
    path: "order/ignore/detail-order/general-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/general-information.vue")
  },
  {
    name: "c-id-order-ignore-detail-order",
    path: "order/ignore/detail-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/index.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-quote",
    path: "order/ignore/detail-order/quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/quote.vue")
  },
  {
    name: "c-id-order-ignore-detail-order-shipping-plan",
    path: "order/ignore/detail-order/shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/detail-order/shipping-plan.vue")
  },
  {
    name: "c-id-order-ignore-document-add-document",
    path: "order/ignore/document/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/document/add-document.vue")
  },
  {
    name: "c-id-order-ignore-document-document",
    path: "order/ignore/document/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/document/document.vue")
  },
  {
    name: "c-id-order-ignore-document-edit-document",
    path: "order/ignore/document/edit-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/document/edit-document.vue")
  },
  {
    name: "c-id-order-ignore-edit-order",
    path: "order/ignore/edit-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/edit-order.vue")
  },
  {
    name: "c-id-order-ignore-edit-request",
    path: "order/ignore/edit-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/edit-request.vue")
  },
  {
    name: "c-id-order-ignore-imports-data",
    path: "order/ignore/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/imports/data.ts")
  },
  {
    name: "c-id-order-ignore-imports-form",
    path: "order/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/imports/form.ts")
  },
  {
    name: "c-id-order-ignore-optimize-waiting-time",
    path: "order/ignore/optimize-waiting-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/optimize-waiting-time/index.vue")
  },
  {
    name: "c-id-order-ignore-plugins-direction",
    path: "order/ignore/plugins/direction",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/plugins/direction.ts")
  },
  {
    name: "c-id-order-ignore-plugins",
    path: "order/ignore/plugins",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/plugins/index.ts")
  },
  {
    name: "c-id-order-ignore-plugins-route",
    path: "order/ignore/plugins/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/plugins/route.ts")
  },
  {
    name: "c-id-order-ignore-shipping-information",
    path: "order/ignore/shipping-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/shipping-information.vue")
  },
  {
    name: "c-id-order-ignore-shipping-plan",
    path: "order/ignore/shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/shipping-plan.vue")
  },
  {
    name: "c-id-order-ignore-table-commodity",
    path: "order/ignore/table/commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/table/commodity.vue")
  },
  {
    name: "c-id-order-ignore-table-cont",
    path: "order/ignore/table/cont",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/table/cont.vue")
  },
  {
    name: "c-id-order-ignore-table-customer",
    path: "order/ignore/table/customer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/table/customer.vue")
  },
  {
    name: "c-id-order-ignore-travel-detail",
    path: "order/ignore/travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/travel-detail.vue")
  },
  {
    name: "c-id-order-ignore-view-position",
    path: "order/ignore/view-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/view-position.vue")
  },
  {
    name: "c-id-order-ignore-waiting-task",
    path: "order/ignore/waiting-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/waiting-task.vue")
  },
  {
    name: "c-id-order-ignore-workflow-position",
    path: "order/ignore/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/ignore/workflow-position.vue")
  },
  {
    name: "c-id-order",
    path: "order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/order/index.vue")
  },
  {
    name: "c-id-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner.vue"),
    children: [
  {
    name: "c-id-partner--components-actions",
    path: "-components/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/actions.vue")
  },
  {
    name: "c-id-partner--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/add.vue")
  },
  {
    name: "c-id-partner--components-cooperator-label",
    path: "-components/cooperator-label",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/cooperator-label.vue")
  },
  {
    name: "c-id-partner--components-detail",
    path: "-components/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/detail.vue")
  },
  {
    name: "c-id-partner--components-imports-form",
    path: "-components/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/imports/form.ts")
  },
  {
    name: "c-id-partner--components-invite",
    path: "-components/invite",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/invite.vue")
  },
  {
    name: "c-id-partner--components-select",
    path: "-components/select",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/select.vue")
  },
  {
    name: "c-id-partner--components-status",
    path: "-components/status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/status.vue")
  },
  {
    name: "c-id-partner--components-tabels-commodity-name",
    path: "-components/tabels/commodity-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/tabels/commodity-name.vue")
  },
  {
    name: "c-id-partner--components-tabels-system-participation-status",
    path: "-components/tabels/system-participation-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/-components/tabels/system-participation-status.vue")
  },
  {
    name: "c-id-partner-idpartner-bank",
    path: ":idpartner()/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank.vue"),
    children: [
  {
    name: "c-id-partner-idpartner-bank--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank/-components/add.vue")
  },
  {
    name: "c-id-partner-idpartner-bank-idbank-edit",
    path: ":idbank()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank/[idbank]/edit.vue")
  },
  {
    name: "c-id-partner-idpartner-bank-ignore-bank",
    path: "ignore/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/bank/ignore/bank.ts")
  }
]
  },
  {
    name: "c-id-partner-idpartner-business-opportunity",
    path: ":idpartner()/business-opportunity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity.vue"),
    children: [
  {
    name: "c-id-partner-idpartner-business-opportunity--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/-components/add.vue")
  },
  {
    name: "c-id-partner-idpartner-business-opportunity--components-position",
    path: "-components/position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/-components/position.vue")
  },
  {
    name: "c-id-partner-idpartner-business-opportunity--components-workflow-position",
    path: "-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/-components/workflow-position.vue")
  },
  {
    name: "c-id-partner-idpartner-business-opportunity-idbusinessopportunity-edit",
    path: ":idbusinessopportunity()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/edit.vue")
  },
  {
    name: "c-id-partner-idpartner-business-opportunity-idbusinessopportunity-replicate",
    path: ":idbusinessopportunity()/replicate",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/replicate.vue")
  }
]
  },
  {
    name: "c-id-partner-idpartner-commodity",
    path: ":idpartner()/commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/commodity.vue"),
    children: [
  {
    name: "c-id-partner-idpartner-commodity--components-add-commodity",
    path: "-components/add-commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue")
  },
  {
    name: "c-id-partner-idpartner-commodity-idcommodity-edit",
    path: ":idcommodity()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/commodity/[idcommodity]/edit.vue")
  }
]
  },
  {
    name: "c-id-partner-idpartner-contact",
    path: ":idpartner()/contact",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact.vue"),
    children: [
  {
    name: "c-id-partner-idpartner-contact--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact/-components/add.vue")
  },
  {
    name: "c-id-partner-idpartner-contact-idcontact-edit",
    path: ":idcontact()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact/[idcontact]/edit.vue")
  },
  {
    name: "c-id-partner-idpartner-contact-ignore-data",
    path: "ignore/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/contact/ignore/data.ts")
  }
]
  },
  {
    name: "c-id-partner-idpartner-document",
    path: ":idpartner()/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document.vue"),
    children: [
  {
    name: "c-id-partner-idpartner-document--components-add-document",
    path: "-components/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document/-components/add-document.vue")
  },
  {
    name: "c-id-partner-idpartner-document-iddocumentpartner-approve",
    path: ":iddocumentpartner()/approve",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document/[iddocumentpartner]/approve.vue")
  },
  {
    name: "c-id-partner-idpartner-document-iddocumentpartner-edit",
    path: ":iddocumentpartner()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/document/[iddocumentpartner]/edit.vue")
  }
]
  },
  {
    name: "c-id-partner-idpartner-edit",
    path: ":idpartner()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/edit.vue")
  },
  {
    name: "c-id-partner-idpartner-task-completion-time",
    path: ":idpartner()/task-completion-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time.vue"),
    children: [
  {
    name: "c-id-partner-idpartner-task-completion-time-ignore-add",
    path: "ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/add.vue")
  },
  {
    name: "c-id-partner-idpartner-task-completion-time-ignore-detail",
    path: "ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/detail.vue")
  },
  {
    name: "c-id-partner-idpartner-task-completion-time-ignore-edit",
    path: "ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/edit.vue")
  },
  {
    name: "c-id-partner-idpartner-task-completion-time-ignore-form",
    path: "ignore/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/form.ts")
  },
  {
    name: "c-id-partner-idpartner-task-completion-time-ignore-utils",
    path: "ignore/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/[idpartner]/task-completion-time/ignore/utils.ts")
  }
]
  },
  {
    name: "c-id-partner-accept-customer",
    path: "accept/customer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/accept/customer.vue")
  },
  {
    name: "c-id-partner-accept-vendor",
    path: "accept/vendor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/partner/accept/vendor.vue")
  }
]
  },
  {
    name: "c-id-profile",
    path: "profile",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index.vue"),
    children: [
  {
    name: "c-id-profile-index-change-password",
    path: "change-password",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index/change-password.vue")
  },
  {
    name: "c-id-profile-index-information",
    path: "information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index/information.vue")
  },
  {
    name: "c-id-profile-index-time",
    path: "time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/profile/index/time.vue")
  }
]
  },
  {
    name: "c-id-quote--components-add",
    path: "quote/-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/add.vue")
  },
  {
    name: "c-id-quote--components-create",
    path: "quote/-components/create",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/create.vue")
  },
  {
    name: "c-id-quote--components-ignore-imports-form",
    path: "quote/-components/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/ignore/imports/form.ts")
  },
  {
    name: "c-id-quote--components-information",
    path: "quote/-components/information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/information.vue")
  },
  {
    name: "c-id-quote--components-markup-edit",
    path: "quote/-components/markup-edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/markup-edit.vue")
  },
  {
    name: "c-id-quote--components-markup-view",
    path: "quote/-components/markup-view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/markup-view.vue")
  },
  {
    name: "c-id-quote--components-price-information",
    path: "quote/-components/price-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/price-information.vue")
  },
  {
    name: "c-id-quote--components-type-commodity-name",
    path: "quote/-components/type-commodity-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/type-commodity-name.vue")
  },
  {
    name: "c-id-quote--components-view-offline-fee",
    path: "quote/-components/view-offline-fee",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/view-offline-fee.vue")
  },
  {
    name: "c-id-quote--components-view-price-detail",
    path: "quote/-components/view-price-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/view-price-detail.vue")
  },
  {
    name: "c-id-quote--components-view-quote-price",
    path: "quote/-components/view-quote-price",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/-components/view-quote-price.vue")
  },
  {
    name: "c-id-quote-management",
    path: "quote/management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/management.vue")
  },
  {
    name: "c-id-quote-quote-request",
    path: "quote/quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request.vue"),
    children: [
  {
    name: "c-id-quote-quote-request--components-add-quote",
    path: "-components/add-quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/add-quote.vue")
  },
  {
    name: "c-id-quote-quote-request--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/add.vue")
  },
  {
    name: "c-id-quote-quote-request--components-ignore-imports-form",
    path: "-components/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/ignore/imports/form.ts")
  },
  {
    name: "c-id-quote-quote-request--components-routing-connection",
    path: "-components/routing-connection",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/routing-connection.vue")
  },
  {
    name: "c-id-quote-quote-request--components-view-position",
    path: "-components/view-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/view-position.vue")
  },
  {
    name: "c-id-quote-quote-request--components-workflow-position",
    path: "-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/-components/workflow-position.vue")
  },
  {
    name: "c-id-quote-quote-request-idquoterequest-edit",
    path: ":idquoterequest()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/[idquoterequest]/edit.vue")
  },
  {
    name: "c-id-quote-quote-request-idquoterequest-view",
    path: ":idquoterequest()/view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/quote/quote-request/[idquoterequest]/view.vue")
  }
]
  },
  {
    name: "c-id-trip-ignore-add",
    path: "trip/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/add.vue")
  },
  {
    name: "c-id-trip-ignore-cancel",
    path: "trip/ignore/cancel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/cancel.vue")
  },
  {
    name: "c-id-trip-ignore-component-deadline",
    path: "trip/ignore/component/deadline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/deadline.vue")
  },
  {
    name: "c-id-trip-ignore-component-journey-cell",
    path: "trip/ignore/component/journey-cell",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/journey-cell.vue")
  },
  {
    name: "c-id-trip-ignore-component-request",
    path: "trip/ignore/component/request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/request.vue")
  },
  {
    name: "c-id-trip-ignore-component-route",
    path: "trip/ignore/component/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/component/route.vue")
  },
  {
    name: "c-id-trip-ignore-detail",
    path: "trip/ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/detail.vue")
  },
  {
    name: "c-id-trip-ignore-edit",
    path: "trip/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/edit.vue")
  },
  {
    name: "c-id-trip-ignore-reason",
    path: "trip/ignore/reason",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/ignore/reason.ts")
  },
  {
    name: "c-id-trip",
    path: "trip",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/c-[id]/trip/index.vue")
  }
]
  },
  {
    name: "callback-oauth",
    path: "/callback/oauth",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/callback/oauth.vue")
  },
  {
    name: "customer",
    path: "/customer",
    meta: customerRLouyP1MBEMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer.vue"),
    children: [
  {
    name: "customer-trip-code--component-travel-detail",
    path: "trip/:code()/-component/travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer/trip/[code]/-component/travel-detail.vue")
  },
  {
    name: "customer-trip-code--component-travel-step",
    path: "trip/:code()/-component/travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer/trip/[code]/-component/travel-step.vue")
  },
  {
    name: "customer-trip-code",
    path: "trip/:code()",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/customer/trip/[code]/index.vue")
  }
]
  },
  {
    name: "embed-search-booking",
    path: "/embed/search-booking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/embed/search-booking.vue")
  },
  {
    name: "errors-access-denied",
    path: "/errors/access-denied",
    meta: access_45deniedaWjiIg81MqMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/errors/access-denied.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexE5wZiFS5mnMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/index.vue")
  },
  {
    name: pc_45_91id_930rixQ2q9dZMeta?.name,
    path: "/pc-:id()",
    meta: pc_45_91id_930rixQ2q9dZMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id].vue"),
    children: [
  {
    name: "pc-id--components-activity-detail-orders",
    path: "-components/activity-detail/orders",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity-detail/orders.vue")
  },
  {
    name: "pc-id--components-activity-detail-quote-request",
    path: "-components/activity-detail/quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity-detail/quote-request.vue")
  },
  {
    name: "pc-id--components-activity-detail-table",
    path: "-components/activity-detail/table",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity-detail/table.vue")
  },
  {
    name: "pc-id--components-activity",
    path: "-components/activity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/activity.vue")
  },
  {
    name: "pc-id--components-journey-info",
    path: "-components/journey-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info.vue"),
    children: [
  {
    name: "pc-id--components-journey-info-activities",
    path: "activities",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/activities.vue")
  },
  {
    name: "pc-id--components-journey-info-alert-components-alert-action",
    path: "alert-components/alert-action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-action.vue")
  },
  {
    name: "pc-id--components-journey-info-alert-components-alert-stage",
    path: "alert-components/alert-stage",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-stage.vue")
  },
  {
    name: "pc-id--components-journey-info-alert-components-alert-task-delay",
    path: "alert-components/alert-task-delay",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task-delay.vue")
  },
  {
    name: "pc-id--components-journey-info-alert-components-alert-task-process",
    path: "alert-components/alert-task-process",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task-process.vue")
  },
  {
    name: "pc-id--components-journey-info-alert-components-alert-task-waiting",
    path: "alert-components/alert-task-waiting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task-waiting.vue")
  },
  {
    name: "pc-id--components-journey-info-alert-components-alert-task",
    path: "alert-components/alert-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-components/alert-task.vue")
  },
  {
    name: "pc-id--components-journey-info-alert-item",
    path: "alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alert-item.vue")
  },
  {
    name: "pc-id--components-journey-info-alerts",
    path: "alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/alerts.vue")
  },
  {
    name: "pc-id--components-journey-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-alert-item.vue")
  },
  {
    name: "pc-id--components-journey-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-info.vue")
  },
  {
    name: "pc-id--components-journey-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-notifications.vue")
  },
  {
    name: "pc-id--components-journey-info-driver-status",
    path: "driver-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/driver-status.vue")
  },
  {
    name: "pc-id--components-journey-info-files",
    path: "files",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/files.vue")
  },
  {
    name: "pc-id--components-journey-info-planning-actual",
    path: "planning-actual",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/planning-actual.vue")
  },
  {
    name: "pc-id--components-journey-info-planning",
    path: "planning",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/planning.vue")
  },
  {
    name: "pc-id--components-journey-info-prices",
    path: "prices",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/prices.vue")
  },
  {
    name: "pc-id--components-journey-info-sub-tasks",
    path: "sub-tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/sub-tasks.vue")
  },
  {
    name: "pc-id--components-journey-info-tasks",
    path: "tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/tasks.vue")
  },
  {
    name: "pc-id--components-journey-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-detail.vue")
  },
  {
    name: "pc-id--components-journey-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-map.vue")
  },
  {
    name: "pc-id--components-journey-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-route-info.vue")
  },
  {
    name: "pc-id--components-journey-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-step.vue")
  },
  {
    name: "pc-id--components-journey-info-travel-tabs-alerts",
    path: "travel-tabs/alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-tabs/alerts.vue")
  },
  {
    name: "pc-id--components-journey-info-travel-tabs",
    path: "travel-tabs",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel-tabs/index.vue")
  },
  {
    name: "pc-id--components-journey-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/travel.vue")
  },
  {
    name: "pc-id--components-journey-info-utils",
    path: "utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/utils.ts")
  },
  {
    name: "pc-id--components-journey-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/vehicle-info.vue")
  },
  {
    name: "pc-id--components-journey-info-vehicle-status",
    path: "vehicle-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/journey-info/vehicle-status.vue")
  }
]
  },
  {
    name: "pc-id--components-time-condition-format",
    path: "-components/time-condition-format",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/time-condition-format.ts")
  },
  {
    name: "pc-id--components-transportation-info-driver",
    path: "-components/transportation-info/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/transportation-info/driver.vue")
  },
  {
    name: "pc-id--components-transportation-info",
    path: "-components/transportation-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/transportation-info/index.vue")
  },
  {
    name: "pc-id--components-transportation-info-vehicle",
    path: "-components/transportation-info/vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/transportation-info/vehicle.vue")
  },
  {
    name: "pc-id--components-trip-info-content",
    path: "-components/trip-info-content",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info-content.vue")
  },
  {
    name: "pc-id--components-trip-info",
    path: "-components/trip-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info.vue"),
    children: [
  {
    name: "pc-id--components-trip-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/driver-alert-item.vue")
  },
  {
    name: "pc-id--components-trip-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/driver-info.vue")
  },
  {
    name: "pc-id--components-trip-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/driver-notifications.vue")
  },
  {
    name: "pc-id--components-trip-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-detail.vue")
  },
  {
    name: "pc-id--components-trip-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-map.vue")
  },
  {
    name: "pc-id--components-trip-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-route-info.vue")
  },
  {
    name: "pc-id--components-trip-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel-step.vue")
  },
  {
    name: "pc-id--components-trip-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/travel.vue")
  },
  {
    name: "pc-id--components-trip-info-trip-files",
    path: "trip-files",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/trip-files.vue")
  },
  {
    name: "pc-id--components-trip-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-info/vehicle-info.vue")
  }
]
  },
  {
    name: "pc-id--components-trip-utils",
    path: "-components/trip-utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/-components/trip-utils.ts")
  },
  {
    name: "pc-id-company-bank",
    path: "company/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/bank.vue")
  },
  {
    name: "pc-id-company-branch",
    path: "company/branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/branch.vue")
  },
  {
    name: "pc-id-company-global-settings",
    path: "company/global-settings",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings.vue"),
    children: [
  {
    name: "pc-id-company-global-settings-cost-ignore-imports-form",
    path: "cost/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/cost/ignore/imports/form.ts")
  },
  {
    name: "pc-id-company-global-settings-cost",
    path: "cost",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/cost/index.vue")
  },
  {
    name: "pc-id-company-global-settings-general-ignore-imports-form",
    path: "general/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/ignore/imports/form.ts")
  },
  {
    name: "pc-id-company-global-settings-general-ignore-setting-cont",
    path: "general/ignore/setting-cont",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/ignore/setting-cont.vue")
  },
  {
    name: "pc-id-company-global-settings-general-ignore-update-markup",
    path: "general/ignore/update-markup",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/ignore/update-markup.vue")
  },
  {
    name: "pc-id-company-global-settings-general",
    path: "general",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/general/index.vue")
  },
  {
    name: "pc-id-company-global-settings-gps",
    path: "gps",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/gps/index.vue")
  },
  {
    name: "pc-id-company-global-settings-partner-driver",
    path: "partner/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/driver/index.vue")
  },
  {
    name: "pc-id-company-global-settings-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/index.vue")
  },
  {
    name: "pc-id-company-global-settings-partner-remooc",
    path: "partner/remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/remooc/index.vue")
  },
  {
    name: "pc-id-company-global-settings-partner-vehicle",
    path: "partner/vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/partner/vehicle/index.vue")
  },
  {
    name: "pc-id-company-global-settings-policy-ignore-imports-form",
    path: "policy/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/policy/ignore/imports/form.ts")
  },
  {
    name: "pc-id-company-global-settings-policy",
    path: "policy",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/policy/index.vue")
  },
  {
    name: "pc-id-company-global-settings-route",
    path: "route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/route/index.vue")
  },
  {
    name: "pc-id-company-global-settings-schedule",
    path: "schedule",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/schedule/index.vue")
  },
  {
    name: "pc-id-company-global-settings-times-ignore-imports-form",
    path: "times/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/times/ignore/imports/form.ts")
  },
  {
    name: "pc-id-company-global-settings-times",
    path: "times",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/global-settings/times/index.vue")
  }
]
  },
  {
    name: "pc-id-company-history",
    path: "company/history",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/history.vue")
  },
  {
    name: "pc-id-company-ignore-action",
    path: "company/ignore/action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/action.vue")
  },
  {
    name: "pc-id-company-ignore-add-banking",
    path: "company/ignore/add-banking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/add-banking.vue")
  },
  {
    name: "pc-id-company-ignore-add-branch",
    path: "company/ignore/add-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/add-branch.vue")
  },
  {
    name: "pc-id-company-ignore-add-company",
    path: "company/ignore/add-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/add-company.vue")
  },
  {
    name: "pc-id-company-ignore-banking-branch",
    path: "company/ignore/banking-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/banking-branch.vue")
  },
  {
    name: "pc-id-company-ignore-company-history-detail",
    path: "company/ignore/company-history-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/company-history-detail.vue")
  },
  {
    name: "pc-id-company-ignore-edit-bank",
    path: "company/ignore/edit-bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-bank.vue")
  },
  {
    name: "pc-id-company-ignore-edit-banking-branch",
    path: "company/ignore/edit-banking-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-banking-branch.vue")
  },
  {
    name: "pc-id-company-ignore-edit-branch",
    path: "company/ignore/edit-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-branch.vue")
  },
  {
    name: "pc-id-company-ignore-edit-company",
    path: "company/ignore/edit-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-company.vue")
  },
  {
    name: "pc-id-company-ignore-edit-invoice-branch",
    path: "company/ignore/edit-invoice-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-invoice-branch.vue")
  },
  {
    name: "pc-id-company-ignore-edit-invoice",
    path: "company/ignore/edit-invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/edit-invoice.vue")
  },
  {
    name: "pc-id-company-ignore-imports-banking-form",
    path: "company/ignore/imports/banking-form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/imports/banking-form.ts")
  },
  {
    name: "pc-id-company-ignore-imports-form",
    path: "company/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/imports/form.ts")
  },
  {
    name: "pc-id-company-ignore-imports-invoice-form",
    path: "company/ignore/imports/invoice-form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/imports/invoice-form.ts")
  },
  {
    name: "pc-id-company-ignore-invoicing-branch",
    path: "company/ignore/invoicing-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/invoicing-branch.vue")
  },
  {
    name: "pc-id-company-ignore-list-company",
    path: "company/ignore/list-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/ignore/list-company.vue")
  },
  {
    name: "pc-id-company-information",
    path: "company/information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/information.vue")
  },
  {
    name: "pc-id-company-invoice",
    path: "company/invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/invoice.vue")
  },
  {
    name: "pc-id-company-user-group--components-actions",
    path: "company/user-group/-components/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/actions.vue")
  },
  {
    name: "pc-id-company-user-group--components-add-company-user",
    path: "company/user-group/-components/add-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/add-company-user.vue")
  },
  {
    name: "pc-id-company-user-group--components-add-group",
    path: "company/user-group/-components/add-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/add-group.vue")
  },
  {
    name: "pc-id-company-user-group--components-edit-company-user",
    path: "company/user-group/-components/edit-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/edit-company-user.vue")
  },
  {
    name: "pc-id-company-user-group--components-edit-group",
    path: "company/user-group/-components/edit-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/edit-group.vue")
  },
  {
    name: "pc-id-company-user-group--components-ignore-group-name",
    path: "company/user-group/-components/ignore/group-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/ignore/group-name.vue")
  },
  {
    name: "pc-id-company-user-group--components-ignore-group-type",
    path: "company/user-group/-components/ignore/group-type",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/ignore/group-type.vue")
  },
  {
    name: "pc-id-company-user-group--components-ignore-permission-checkbox",
    path: "company/user-group/-components/ignore/permission-checkbox",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/ignore/permission-checkbox.vue")
  },
  {
    name: "pc-id-company-user-group--components-imports-data",
    path: "company/user-group/-components/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/imports/data.ts")
  },
  {
    name: "pc-id-company-user-group--components-imports-form",
    path: "company/user-group/-components/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/imports/form.ts")
  },
  {
    name: "pc-id-company-user-group--components-imports-model",
    path: "company/user-group/-components/imports/model",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/imports/model.ts")
  },
  {
    name: "pc-id-company-user-group--components-update-permissions",
    path: "company/user-group/-components/update-permissions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/update-permissions.vue")
  },
  {
    name: "pc-id-company-user-group--components-user-status",
    path: "company/user-group/-components/user-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/-components/user-status.vue")
  },
  {
    name: "pc-id-company-user-group-groups",
    path: "company/user-group/groups",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/groups.vue")
  },
  {
    name: "pc-id-company-user-group-users",
    path: "company/user-group/users",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/company/user-group/users.vue")
  },
  {
    name: "pc-id-components",
    path: "components",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/components/index.vue")
  },
  {
    name: "pc-id-dashboard",
    path: "dashboard",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/dashboard/index.vue")
  },
  {
    name: "pc-id",
    path: "",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/index.vue")
  },
  {
    name: "pc-id-order-ignore-actions",
    path: "order/ignore/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/actions.vue")
  },
  {
    name: "pc-id-order-ignore-add-order",
    path: "order/ignore/add-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/add-order.vue")
  },
  {
    name: "pc-id-order-ignore-cancel",
    path: "order/ignore/cancel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/cancel.vue")
  },
  {
    name: "pc-id-order-ignore-component-container-numbers",
    path: "order/ignore/component/container-numbers",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/container-numbers.vue")
  },
  {
    name: "pc-id-order-ignore-component-date-time",
    path: "order/ignore/component/date-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/date-time.vue")
  },
  {
    name: "pc-id-order-ignore-component-deadline",
    path: "order/ignore/component/deadline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/deadline.vue")
  },
  {
    name: "pc-id-order-ignore-component-delivery-warehouse",
    path: "order/ignore/component/delivery-warehouse",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/delivery-warehouse.vue")
  },
  {
    name: "pc-id-order-ignore-component-edit-productivity",
    path: "order/ignore/component/edit-productivity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/edit-productivity.vue")
  },
  {
    name: "pc-id-order-ignore-component-edit-travel-time",
    path: "order/ignore/component/edit-travel-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/edit-travel-time.vue")
  },
  {
    name: "pc-id-order-ignore-component-loading-task",
    path: "order/ignore/component/loading-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/loading-task.vue")
  },
  {
    name: "pc-id-order-ignore-component-request",
    path: "order/ignore/component/request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/component/request.vue")
  },
  {
    name: "pc-id-order-ignore-condition-setting",
    path: "order/ignore/condition-setting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/condition-setting.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-add-container-numbers",
    path: "order/ignore/detail-order/add-container-numbers",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/add-container-numbers.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-add-partner",
    path: "order/ignore/detail-order/add-partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/add-partner.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-add-quote-to-order",
    path: "order/ignore/detail-order/add-quote-to-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/add-quote-to-order.ts")
  },
  {
    name: "pc-id-order-ignore-detail-order-allotment",
    path: "order/ignore/detail-order/allotment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/allotment.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-edit-allotment",
    path: "order/ignore/detail-order/edit-allotment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/edit-allotment.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-edit-shipping-plan",
    path: "order/ignore/detail-order/edit-shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/edit-shipping-plan.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-general-information",
    path: "order/ignore/detail-order/general-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/general-information.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order",
    path: "order/ignore/detail-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/index.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-quote",
    path: "order/ignore/detail-order/quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/quote.vue")
  },
  {
    name: "pc-id-order-ignore-detail-order-shipping-plan",
    path: "order/ignore/detail-order/shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/detail-order/shipping-plan.vue")
  },
  {
    name: "pc-id-order-ignore-document-add-document",
    path: "order/ignore/document/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/document/add-document.vue")
  },
  {
    name: "pc-id-order-ignore-document-document",
    path: "order/ignore/document/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/document/document.vue")
  },
  {
    name: "pc-id-order-ignore-document-edit-document",
    path: "order/ignore/document/edit-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/document/edit-document.vue")
  },
  {
    name: "pc-id-order-ignore-edit-order",
    path: "order/ignore/edit-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/edit-order.vue")
  },
  {
    name: "pc-id-order-ignore-edit-request",
    path: "order/ignore/edit-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/edit-request.vue")
  },
  {
    name: "pc-id-order-ignore-imports-data",
    path: "order/ignore/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/imports/data.ts")
  },
  {
    name: "pc-id-order-ignore-imports-form",
    path: "order/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/imports/form.ts")
  },
  {
    name: "pc-id-order-ignore-optimize-waiting-time",
    path: "order/ignore/optimize-waiting-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/optimize-waiting-time/index.vue")
  },
  {
    name: "pc-id-order-ignore-plugins-direction",
    path: "order/ignore/plugins/direction",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/plugins/direction.ts")
  },
  {
    name: "pc-id-order-ignore-plugins",
    path: "order/ignore/plugins",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/plugins/index.ts")
  },
  {
    name: "pc-id-order-ignore-plugins-route",
    path: "order/ignore/plugins/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/plugins/route.ts")
  },
  {
    name: "pc-id-order-ignore-shipping-information",
    path: "order/ignore/shipping-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/shipping-information.vue")
  },
  {
    name: "pc-id-order-ignore-shipping-plan",
    path: "order/ignore/shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/shipping-plan.vue")
  },
  {
    name: "pc-id-order-ignore-table-commodity",
    path: "order/ignore/table/commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/table/commodity.vue")
  },
  {
    name: "pc-id-order-ignore-table-cont",
    path: "order/ignore/table/cont",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/table/cont.vue")
  },
  {
    name: "pc-id-order-ignore-table-customer",
    path: "order/ignore/table/customer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/table/customer.vue")
  },
  {
    name: "pc-id-order-ignore-travel-detail",
    path: "order/ignore/travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/travel-detail.vue")
  },
  {
    name: "pc-id-order-ignore-view-position",
    path: "order/ignore/view-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/view-position.vue")
  },
  {
    name: "pc-id-order-ignore-waiting-task",
    path: "order/ignore/waiting-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/waiting-task.vue")
  },
  {
    name: "pc-id-order-ignore-workflow-position",
    path: "order/ignore/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/ignore/workflow-position.vue")
  },
  {
    name: "pc-id-order",
    path: "order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/order/index.vue")
  },
  {
    name: "pc-id-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner.vue"),
    children: [
  {
    name: "pc-id-partner--components-actions",
    path: "-components/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/actions.vue")
  },
  {
    name: "pc-id-partner--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/add.vue")
  },
  {
    name: "pc-id-partner--components-cooperator-label",
    path: "-components/cooperator-label",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/cooperator-label.vue")
  },
  {
    name: "pc-id-partner--components-detail",
    path: "-components/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/detail.vue")
  },
  {
    name: "pc-id-partner--components-imports-form",
    path: "-components/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/imports/form.ts")
  },
  {
    name: "pc-id-partner--components-invite",
    path: "-components/invite",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/invite.vue")
  },
  {
    name: "pc-id-partner--components-select",
    path: "-components/select",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/select.vue")
  },
  {
    name: "pc-id-partner--components-status",
    path: "-components/status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/status.vue")
  },
  {
    name: "pc-id-partner--components-tabels-commodity-name",
    path: "-components/tabels/commodity-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/tabels/commodity-name.vue")
  },
  {
    name: "pc-id-partner--components-tabels-system-participation-status",
    path: "-components/tabels/system-participation-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/-components/tabels/system-participation-status.vue")
  },
  {
    name: "pc-id-partner-idpartner-bank",
    path: ":idpartner()/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank.vue"),
    children: [
  {
    name: "pc-id-partner-idpartner-bank--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank/-components/add.vue")
  },
  {
    name: "pc-id-partner-idpartner-bank-idbank-edit",
    path: ":idbank()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank/[idbank]/edit.vue")
  },
  {
    name: "pc-id-partner-idpartner-bank-ignore-bank",
    path: "ignore/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/bank/ignore/bank.ts")
  }
]
  },
  {
    name: "pc-id-partner-idpartner-business-opportunity",
    path: ":idpartner()/business-opportunity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity.vue"),
    children: [
  {
    name: "pc-id-partner-idpartner-business-opportunity--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/-components/add.vue")
  },
  {
    name: "pc-id-partner-idpartner-business-opportunity--components-position",
    path: "-components/position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/-components/position.vue")
  },
  {
    name: "pc-id-partner-idpartner-business-opportunity--components-workflow-position",
    path: "-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/-components/workflow-position.vue")
  },
  {
    name: "pc-id-partner-idpartner-business-opportunity-idbusinessopportunity-edit",
    path: ":idbusinessopportunity()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/edit.vue")
  },
  {
    name: "pc-id-partner-idpartner-business-opportunity-idbusinessopportunity-replicate",
    path: ":idbusinessopportunity()/replicate",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/replicate.vue")
  }
]
  },
  {
    name: "pc-id-partner-idpartner-commodity",
    path: ":idpartner()/commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/commodity.vue"),
    children: [
  {
    name: "pc-id-partner-idpartner-commodity--components-add-commodity",
    path: "-components/add-commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue")
  },
  {
    name: "pc-id-partner-idpartner-commodity-idcommodity-edit",
    path: ":idcommodity()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/commodity/[idcommodity]/edit.vue")
  }
]
  },
  {
    name: "pc-id-partner-idpartner-contact",
    path: ":idpartner()/contact",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact.vue"),
    children: [
  {
    name: "pc-id-partner-idpartner-contact--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact/-components/add.vue")
  },
  {
    name: "pc-id-partner-idpartner-contact-idcontact-edit",
    path: ":idcontact()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact/[idcontact]/edit.vue")
  },
  {
    name: "pc-id-partner-idpartner-contact-ignore-data",
    path: "ignore/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/contact/ignore/data.ts")
  }
]
  },
  {
    name: "pc-id-partner-idpartner-document",
    path: ":idpartner()/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document.vue"),
    children: [
  {
    name: "pc-id-partner-idpartner-document--components-add-document",
    path: "-components/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document/-components/add-document.vue")
  },
  {
    name: "pc-id-partner-idpartner-document-iddocumentpartner-approve",
    path: ":iddocumentpartner()/approve",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document/[iddocumentpartner]/approve.vue")
  },
  {
    name: "pc-id-partner-idpartner-document-iddocumentpartner-edit",
    path: ":iddocumentpartner()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/document/[iddocumentpartner]/edit.vue")
  }
]
  },
  {
    name: "pc-id-partner-idpartner-edit",
    path: ":idpartner()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/edit.vue")
  },
  {
    name: "pc-id-partner-idpartner-task-completion-time",
    path: ":idpartner()/task-completion-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time.vue"),
    children: [
  {
    name: "pc-id-partner-idpartner-task-completion-time-ignore-add",
    path: "ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/add.vue")
  },
  {
    name: "pc-id-partner-idpartner-task-completion-time-ignore-detail",
    path: "ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/detail.vue")
  },
  {
    name: "pc-id-partner-idpartner-task-completion-time-ignore-edit",
    path: "ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/edit.vue")
  },
  {
    name: "pc-id-partner-idpartner-task-completion-time-ignore-form",
    path: "ignore/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/form.ts")
  },
  {
    name: "pc-id-partner-idpartner-task-completion-time-ignore-utils",
    path: "ignore/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/[idpartner]/task-completion-time/ignore/utils.ts")
  }
]
  },
  {
    name: "pc-id-partner-accept-customer",
    path: "accept/customer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/accept/customer.vue")
  },
  {
    name: "pc-id-partner-accept-vendor",
    path: "accept/vendor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/partner/accept/vendor.vue")
  }
]
  },
  {
    name: "pc-id-profile",
    path: "profile",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index.vue"),
    children: [
  {
    name: "pc-id-profile-index-change-password",
    path: "change-password",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index/change-password.vue")
  },
  {
    name: "pc-id-profile-index-information",
    path: "information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index/information.vue")
  },
  {
    name: "pc-id-profile-index-time",
    path: "time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/profile/index/time.vue")
  }
]
  },
  {
    name: "pc-id-quote--components-add",
    path: "quote/-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/add.vue")
  },
  {
    name: "pc-id-quote--components-create",
    path: "quote/-components/create",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/create.vue")
  },
  {
    name: "pc-id-quote--components-ignore-imports-form",
    path: "quote/-components/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/ignore/imports/form.ts")
  },
  {
    name: "pc-id-quote--components-information",
    path: "quote/-components/information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/information.vue")
  },
  {
    name: "pc-id-quote--components-markup-edit",
    path: "quote/-components/markup-edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/markup-edit.vue")
  },
  {
    name: "pc-id-quote--components-markup-view",
    path: "quote/-components/markup-view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/markup-view.vue")
  },
  {
    name: "pc-id-quote--components-price-information",
    path: "quote/-components/price-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/price-information.vue")
  },
  {
    name: "pc-id-quote--components-type-commodity-name",
    path: "quote/-components/type-commodity-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/type-commodity-name.vue")
  },
  {
    name: "pc-id-quote--components-view-offline-fee",
    path: "quote/-components/view-offline-fee",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/view-offline-fee.vue")
  },
  {
    name: "pc-id-quote--components-view-price-detail",
    path: "quote/-components/view-price-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/view-price-detail.vue")
  },
  {
    name: "pc-id-quote--components-view-quote-price",
    path: "quote/-components/view-quote-price",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/-components/view-quote-price.vue")
  },
  {
    name: "pc-id-quote-management",
    path: "quote/management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/management.vue")
  },
  {
    name: "pc-id-quote-quote-request",
    path: "quote/quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request.vue"),
    children: [
  {
    name: "pc-id-quote-quote-request--components-add-quote",
    path: "-components/add-quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/add-quote.vue")
  },
  {
    name: "pc-id-quote-quote-request--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/add.vue")
  },
  {
    name: "pc-id-quote-quote-request--components-ignore-imports-form",
    path: "-components/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/ignore/imports/form.ts")
  },
  {
    name: "pc-id-quote-quote-request--components-routing-connection",
    path: "-components/routing-connection",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/routing-connection.vue")
  },
  {
    name: "pc-id-quote-quote-request--components-view-position",
    path: "-components/view-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/view-position.vue")
  },
  {
    name: "pc-id-quote-quote-request--components-workflow-position",
    path: "-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/-components/workflow-position.vue")
  },
  {
    name: "pc-id-quote-quote-request-idquoterequest-edit",
    path: ":idquoterequest()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/[idquoterequest]/edit.vue")
  },
  {
    name: "pc-id-quote-quote-request-idquoterequest-view",
    path: ":idquoterequest()/view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/quote/quote-request/[idquoterequest]/view.vue")
  }
]
  },
  {
    name: "pc-id-trip-ignore-add",
    path: "trip/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/add.vue")
  },
  {
    name: "pc-id-trip-ignore-cancel",
    path: "trip/ignore/cancel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/cancel.vue")
  },
  {
    name: "pc-id-trip-ignore-component-deadline",
    path: "trip/ignore/component/deadline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/deadline.vue")
  },
  {
    name: "pc-id-trip-ignore-component-journey-cell",
    path: "trip/ignore/component/journey-cell",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/journey-cell.vue")
  },
  {
    name: "pc-id-trip-ignore-component-request",
    path: "trip/ignore/component/request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/request.vue")
  },
  {
    name: "pc-id-trip-ignore-component-route",
    path: "trip/ignore/component/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/component/route.vue")
  },
  {
    name: "pc-id-trip-ignore-detail",
    path: "trip/ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/detail.vue")
  },
  {
    name: "pc-id-trip-ignore-edit",
    path: "trip/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/edit.vue")
  },
  {
    name: "pc-id-trip-ignore-reason",
    path: "trip/ignore/reason",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/ignore/reason.ts")
  },
  {
    name: "pc-id-trip",
    path: "trip",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pc-[id]/trip/index.vue")
  }
]
  },
  {
    name: pp_45_91id_93Q4wuVR760VMeta?.name,
    path: "/pp-:id()",
    meta: pp_45_91id_93Q4wuVR760VMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id].vue"),
    children: [
  {
    name: "pp-id--components-activity-detail-orders",
    path: "-components/activity-detail/orders",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity-detail/orders.vue")
  },
  {
    name: "pp-id--components-activity-detail-quote-request",
    path: "-components/activity-detail/quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity-detail/quote-request.vue")
  },
  {
    name: "pp-id--components-activity-detail-table",
    path: "-components/activity-detail/table",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity-detail/table.vue")
  },
  {
    name: "pp-id--components-activity",
    path: "-components/activity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/activity.vue")
  },
  {
    name: "pp-id--components-journey-info",
    path: "-components/journey-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info.vue"),
    children: [
  {
    name: "pp-id--components-journey-info-activities",
    path: "activities",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/activities.vue")
  },
  {
    name: "pp-id--components-journey-info-alert-components-alert-action",
    path: "alert-components/alert-action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-action.vue")
  },
  {
    name: "pp-id--components-journey-info-alert-components-alert-stage",
    path: "alert-components/alert-stage",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-stage.vue")
  },
  {
    name: "pp-id--components-journey-info-alert-components-alert-task-delay",
    path: "alert-components/alert-task-delay",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task-delay.vue")
  },
  {
    name: "pp-id--components-journey-info-alert-components-alert-task-process",
    path: "alert-components/alert-task-process",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task-process.vue")
  },
  {
    name: "pp-id--components-journey-info-alert-components-alert-task-waiting",
    path: "alert-components/alert-task-waiting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task-waiting.vue")
  },
  {
    name: "pp-id--components-journey-info-alert-components-alert-task",
    path: "alert-components/alert-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-components/alert-task.vue")
  },
  {
    name: "pp-id--components-journey-info-alert-item",
    path: "alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alert-item.vue")
  },
  {
    name: "pp-id--components-journey-info-alerts",
    path: "alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/alerts.vue")
  },
  {
    name: "pp-id--components-journey-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-alert-item.vue")
  },
  {
    name: "pp-id--components-journey-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-info.vue")
  },
  {
    name: "pp-id--components-journey-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-notifications.vue")
  },
  {
    name: "pp-id--components-journey-info-driver-status",
    path: "driver-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/driver-status.vue")
  },
  {
    name: "pp-id--components-journey-info-files",
    path: "files",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/files.vue")
  },
  {
    name: "pp-id--components-journey-info-planning-actual",
    path: "planning-actual",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/planning-actual.vue")
  },
  {
    name: "pp-id--components-journey-info-planning",
    path: "planning",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/planning.vue")
  },
  {
    name: "pp-id--components-journey-info-prices",
    path: "prices",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/prices.vue")
  },
  {
    name: "pp-id--components-journey-info-sub-tasks",
    path: "sub-tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/sub-tasks.vue")
  },
  {
    name: "pp-id--components-journey-info-tasks",
    path: "tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/tasks.vue")
  },
  {
    name: "pp-id--components-journey-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-detail.vue")
  },
  {
    name: "pp-id--components-journey-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-map.vue")
  },
  {
    name: "pp-id--components-journey-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-route-info.vue")
  },
  {
    name: "pp-id--components-journey-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-step.vue")
  },
  {
    name: "pp-id--components-journey-info-travel-tabs-alerts",
    path: "travel-tabs/alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-tabs/alerts.vue")
  },
  {
    name: "pp-id--components-journey-info-travel-tabs",
    path: "travel-tabs",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel-tabs/index.vue")
  },
  {
    name: "pp-id--components-journey-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/travel.vue")
  },
  {
    name: "pp-id--components-journey-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/vehicle-info.vue")
  },
  {
    name: "pp-id--components-journey-info-vehicle-status",
    path: "vehicle-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/journey-info/vehicle-status.vue")
  }
]
  },
  {
    name: "pp-id--components-transportation-info-driver",
    path: "-components/transportation-info/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/transportation-info/driver.vue")
  },
  {
    name: "pp-id--components-transportation-info",
    path: "-components/transportation-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/transportation-info/index.vue")
  },
  {
    name: "pp-id--components-transportation-info-vehicle",
    path: "-components/transportation-info/vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/transportation-info/vehicle.vue")
  },
  {
    name: "pp-id--components-trip-info-content",
    path: "-components/trip-info-content",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info-content.vue")
  },
  {
    name: "pp-id--components-trip-info",
    path: "-components/trip-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info.vue"),
    children: [
  {
    name: "pp-id--components-trip-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/driver-alert-item.vue")
  },
  {
    name: "pp-id--components-trip-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/driver-info.vue")
  },
  {
    name: "pp-id--components-trip-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/driver-notifications.vue")
  },
  {
    name: "pp-id--components-trip-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-detail.vue")
  },
  {
    name: "pp-id--components-trip-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-map.vue")
  },
  {
    name: "pp-id--components-trip-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-route-info.vue")
  },
  {
    name: "pp-id--components-trip-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel-step.vue")
  },
  {
    name: "pp-id--components-trip-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/travel.vue")
  },
  {
    name: "pp-id--components-trip-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/-components/trip-info/vehicle-info.vue")
  }
]
  },
  {
    name: "pp-id-company-global-settings",
    path: "company/global-settings",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/global-settings.vue"),
    children: [
  {
    name: "pp-id-company-global-settings-gps",
    path: "gps",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/global-settings/gps/index.vue")
  }
]
  },
  {
    name: "pp-id-company-gps-settings",
    path: "company/gps-settings",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/gps-settings.vue")
  },
  {
    name: "pp-id-company-ignore-action",
    path: "company/ignore/action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/action.vue")
  },
  {
    name: "pp-id-company-ignore-add-company",
    path: "company/ignore/add-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/add-company.vue")
  },
  {
    name: "pp-id-company-ignore-edit-company",
    path: "company/ignore/edit-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/edit-company.vue")
  },
  {
    name: "pp-id-company-ignore-imports-form",
    path: "company/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/imports/form.ts")
  },
  {
    name: "pp-id-company-ignore-list-company",
    path: "company/ignore/list-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/ignore/list-company.vue")
  },
  {
    name: "pp-id-company-information",
    path: "company/information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/information.vue")
  },
  {
    name: "pp-id-company-user-group--components-actions",
    path: "company/user-group/-components/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/actions.vue")
  },
  {
    name: "pp-id-company-user-group--components-add-company-user",
    path: "company/user-group/-components/add-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/add-company-user.vue")
  },
  {
    name: "pp-id-company-user-group--components-add-group",
    path: "company/user-group/-components/add-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/add-group.vue")
  },
  {
    name: "pp-id-company-user-group--components-edit-company-user",
    path: "company/user-group/-components/edit-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/edit-company-user.vue")
  },
  {
    name: "pp-id-company-user-group--components-edit-group",
    path: "company/user-group/-components/edit-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/edit-group.vue")
  },
  {
    name: "pp-id-company-user-group--components-ignore-permission-checkbox",
    path: "company/user-group/-components/ignore/permission-checkbox",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/ignore/permission-checkbox.vue")
  },
  {
    name: "pp-id-company-user-group--components-imports-data",
    path: "company/user-group/-components/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/imports/data.ts")
  },
  {
    name: "pp-id-company-user-group--components-imports-form",
    path: "company/user-group/-components/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/imports/form.ts")
  },
  {
    name: "pp-id-company-user-group--components-imports-model",
    path: "company/user-group/-components/imports/model",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/imports/model.ts")
  },
  {
    name: "pp-id-company-user-group--components-update-permissions",
    path: "company/user-group/-components/update-permissions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/update-permissions.vue")
  },
  {
    name: "pp-id-company-user-group--components-user-status",
    path: "company/user-group/-components/user-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/-components/user-status.vue")
  },
  {
    name: "pp-id-company-user-group-groups",
    path: "company/user-group/groups",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/groups.vue")
  },
  {
    name: "pp-id-company-user-group-users",
    path: "company/user-group/users",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/company/user-group/users.vue")
  },
  {
    name: "pp-id-dashboard",
    path: "dashboard",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/dashboard/index.vue")
  },
  {
    name: "pp-id",
    path: "",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/index.vue")
  },
  {
    name: "pp-id-journey",
    path: "journey",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey.vue"),
    children: [
  {
    name: "pp-id-journey--components-journey-card",
    path: "-components/journey-card",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-card.vue")
  },
  {
    name: "pp-id-journey--components-journey-detach-card",
    path: "-components/journey-detach-card",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-detach-card.vue")
  },
  {
    name: "pp-id-journey--components-journey-list",
    path: "-components/journey-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-list.vue")
  },
  {
    name: "pp-id-journey--components-journey-schedule",
    path: "-components/journey-schedule",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule.vue"),
    children: [
  {
    name: "pp-id-journey--components-journey-schedule-action-tabs",
    path: "action-tabs",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/action-tabs.vue")
  },
  {
    name: "pp-id-journey--components-journey-schedule-board",
    path: "board",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/board.vue")
  },
  {
    name: "pp-id-journey--components-journey-schedule-map",
    path: "map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/map.vue")
  },
  {
    name: "pp-id-journey--components-journey-schedule-warning-list",
    path: "warning-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/journey-schedule/warning-list.vue")
  }
]
  },
  {
    name: "pp-id-journey--components-route",
    path: "-components/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/route.vue")
  },
  {
    name: "pp-id-journey--components-schedule-info",
    path: "-components/schedule-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/-components/schedule-info.vue")
  },
  {
    name: "pp-id-journey-allocationcode-confirm",
    path: ":allocationcode()/confirm",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/[allocation-code]/confirm.vue")
  },
  {
    name: "pp-id-journey-distributing",
    path: "distributing",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/distributing.vue")
  },
  {
    name: "pp-id-journey-management",
    path: "management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/journey/management.vue")
  }
]
  },
  {
    name: "pp-id-monitoring--components-alert-list-drawer",
    path: "monitoring/-components/alert-list-drawer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/alert-list-drawer.vue")
  },
  {
    name: "pp-id-monitoring--components-alert-list",
    path: "monitoring/-components/alert-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/alert-list.vue")
  },
  {
    name: "pp-id-monitoring--components-vehicle-item",
    path: "monitoring/-components/vehicle-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/vehicle-item.vue")
  },
  {
    name: "pp-id-monitoring--components-vehicle-list",
    path: "monitoring/-components/vehicle-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/-components/vehicle-list.vue")
  },
  {
    name: "pp-id-monitoring-management",
    path: "monitoring/management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/monitoring/management.vue")
  },
  {
    name: "pp-id-profile",
    path: "profile",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index.vue"),
    children: [
  {
    name: "pp-id-profile-index-change-password",
    path: "change-password",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index/change-password.vue")
  },
  {
    name: "pp-id-profile-index-information",
    path: "information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index/information.vue")
  },
  {
    name: "pp-id-profile-index-time",
    path: "time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/profile/index/time.vue")
  }
]
  },
  {
    name: "pp-id-selling-price-ignore-add",
    path: "selling-price/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/add.vue")
  },
  {
    name: "pp-id-selling-price-ignore-data",
    path: "selling-price/ignore/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/data.ts")
  },
  {
    name: "pp-id-selling-price-ignore-detail",
    path: "selling-price/ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/detail.vue")
  },
  {
    name: "pp-id-selling-price-ignore-edit",
    path: "selling-price/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/edit.vue")
  },
  {
    name: "pp-id-selling-price-ignore-form",
    path: "selling-price/ignore/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/form.ts")
  },
  {
    name: "pp-id-selling-price-ignore-status",
    path: "selling-price/ignore/status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/status.vue")
  },
  {
    name: "pp-id-selling-price-ignore-view-selling-price",
    path: "selling-price/ignore/view-selling-price",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/ignore/view-selling-price.vue")
  },
  {
    name: "pp-id-selling-price",
    path: "selling-price",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/selling-price/index.vue")
  },
  {
    name: "pp-id-vehicle-ignore-actions",
    path: "vehicle/ignore/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/actions.vue")
  },
  {
    name: "pp-id-vehicle-ignore-add-vehicle",
    path: "vehicle/ignore/add-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/add-vehicle.vue")
  },
  {
    name: "pp-id-vehicle-ignore-autocomplete-select-remooc-category",
    path: "vehicle/ignore/autocomplete/select-remooc-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/autocomplete/select-remooc-category.vue")
  },
  {
    name: "pp-id-vehicle-ignore-autocomplete-select-remooc",
    path: "vehicle/ignore/autocomplete/select-remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/autocomplete/select-remooc.vue")
  },
  {
    name: "pp-id-vehicle-ignore-autocomplete-select-vehicle-category",
    path: "vehicle/ignore/autocomplete/select-vehicle-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/autocomplete/select-vehicle-category.vue")
  },
  {
    name: "pp-id-vehicle-ignore-detail-vehicle",
    path: "vehicle/ignore/detail-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/detail-vehicle.vue")
  },
  {
    name: "pp-id-vehicle-ignore-document-add-document",
    path: "vehicle/ignore/document/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/document/add-document.vue")
  },
  {
    name: "pp-id-vehicle-ignore-document-document",
    path: "vehicle/ignore/document/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/document/document.vue")
  },
  {
    name: "pp-id-vehicle-ignore-document-edit-document",
    path: "vehicle/ignore/document/edit-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/document/edit-document.vue")
  },
  {
    name: "pp-id-vehicle-ignore-edit-vehicle",
    path: "vehicle/ignore/edit-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/edit-vehicle.vue")
  },
  {
    name: "pp-id-vehicle-ignore-imports-form",
    path: "vehicle/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/imports/form.ts")
  },
  {
    name: "pp-id-vehicle-ignore-imports-remooc",
    path: "vehicle/ignore/imports/remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/imports/remooc.ts")
  },
  {
    name: "pp-id-vehicle-ignore-imports-utils",
    path: "vehicle/ignore/imports/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/imports/utils.ts")
  },
  {
    name: "pp-id-vehicle-ignore-maintenance-schedule",
    path: "vehicle/ignore/maintenance-schedule",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/maintenance-schedule.vue")
  },
  {
    name: "pp-id-vehicle-ignore-plugin-add-plugin",
    path: "vehicle/ignore/plugin/add-plugin",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/plugin/add-plugin.vue")
  },
  {
    name: "pp-id-vehicle-ignore-plugin-edit-plugin",
    path: "vehicle/ignore/plugin/edit-plugin",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/plugin/edit-plugin.vue")
  },
  {
    name: "pp-id-vehicle-ignore-plugin-list-plugin",
    path: "vehicle/ignore/plugin/list-plugin",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/plugin/list-plugin.vue")
  },
  {
    name: "pp-id-vehicle-ignore-status",
    path: "vehicle/ignore/status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/status.vue")
  },
  {
    name: "pp-id-vehicle-ignore-vehicle-category-add-category",
    path: "vehicle/ignore/vehicle-category/add-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/vehicle-category/add-category.vue")
  },
  {
    name: "pp-id-vehicle-ignore-vehicle-category-edit-category",
    path: "vehicle/ignore/vehicle-category/edit-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/ignore/vehicle-category/edit-category.vue")
  },
  {
    name: "pp-id-vehicle-list",
    path: "vehicle/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/pp-[id]/vehicle/list.vue")
  }
]
  },
  {
    name: "shared",
    path: "/shared",
    meta: shared8ExSRcTmNcMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/shared.vue"),
    children: [
  {
    name: "shared-trip",
    path: "trip",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/shared/trip.vue")
  }
]
  },
  {
    name: trucker_45_91id_937WrNPBndifMeta?.name,
    path: "/trucker-:id()",
    meta: trucker_45_91id_937WrNPBndifMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id].vue"),
    children: [
  {
    name: "trucker-id--components-activity-detail-orders",
    path: "-components/activity-detail/orders",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity-detail/orders.vue")
  },
  {
    name: "trucker-id--components-activity-detail-quote-request",
    path: "-components/activity-detail/quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity-detail/quote-request.vue")
  },
  {
    name: "trucker-id--components-activity-detail-table",
    path: "-components/activity-detail/table",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity-detail/table.vue")
  },
  {
    name: "trucker-id--components-activity",
    path: "-components/activity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/activity.vue")
  },
  {
    name: "trucker-id--components-journey-info",
    path: "-components/journey-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info.vue"),
    children: [
  {
    name: "trucker-id--components-journey-info-activities",
    path: "activities",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/activities.vue")
  },
  {
    name: "trucker-id--components-journey-info-alert-components-alert-action",
    path: "alert-components/alert-action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-action.vue")
  },
  {
    name: "trucker-id--components-journey-info-alert-components-alert-stage",
    path: "alert-components/alert-stage",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-stage.vue")
  },
  {
    name: "trucker-id--components-journey-info-alert-components-alert-task-delay",
    path: "alert-components/alert-task-delay",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task-delay.vue")
  },
  {
    name: "trucker-id--components-journey-info-alert-components-alert-task-process",
    path: "alert-components/alert-task-process",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task-process.vue")
  },
  {
    name: "trucker-id--components-journey-info-alert-components-alert-task-waiting",
    path: "alert-components/alert-task-waiting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task-waiting.vue")
  },
  {
    name: "trucker-id--components-journey-info-alert-components-alert-task",
    path: "alert-components/alert-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-components/alert-task.vue")
  },
  {
    name: "trucker-id--components-journey-info-alert-item",
    path: "alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alert-item.vue")
  },
  {
    name: "trucker-id--components-journey-info-alerts",
    path: "alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/alerts.vue")
  },
  {
    name: "trucker-id--components-journey-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-alert-item.vue")
  },
  {
    name: "trucker-id--components-journey-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-info.vue")
  },
  {
    name: "trucker-id--components-journey-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-notifications.vue")
  },
  {
    name: "trucker-id--components-journey-info-driver-status",
    path: "driver-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/driver-status.vue")
  },
  {
    name: "trucker-id--components-journey-info-files",
    path: "files",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/files.vue")
  },
  {
    name: "trucker-id--components-journey-info-planning-actual",
    path: "planning-actual",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/planning-actual.vue")
  },
  {
    name: "trucker-id--components-journey-info-planning",
    path: "planning",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/planning.vue")
  },
  {
    name: "trucker-id--components-journey-info-prices",
    path: "prices",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/prices.vue")
  },
  {
    name: "trucker-id--components-journey-info-sub-tasks",
    path: "sub-tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/sub-tasks.vue")
  },
  {
    name: "trucker-id--components-journey-info-tasks",
    path: "tasks",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/tasks.vue")
  },
  {
    name: "trucker-id--components-journey-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-detail.vue")
  },
  {
    name: "trucker-id--components-journey-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-map.vue")
  },
  {
    name: "trucker-id--components-journey-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-route-info.vue")
  },
  {
    name: "trucker-id--components-journey-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-step.vue")
  },
  {
    name: "trucker-id--components-journey-info-travel-tabs-alerts",
    path: "travel-tabs/alerts",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-tabs/alerts.vue")
  },
  {
    name: "trucker-id--components-journey-info-travel-tabs",
    path: "travel-tabs",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel-tabs/index.vue")
  },
  {
    name: "trucker-id--components-journey-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/travel.vue")
  },
  {
    name: "trucker-id--components-journey-info-utils",
    path: "utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/utils.ts")
  },
  {
    name: "trucker-id--components-journey-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/vehicle-info.vue")
  },
  {
    name: "trucker-id--components-journey-info-vehicle-status",
    path: "vehicle-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/journey-info/vehicle-status.vue")
  }
]
  },
  {
    name: "trucker-id--components-time-condition-format",
    path: "-components/time-condition-format",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/time-condition-format.ts")
  },
  {
    name: "trucker-id--components-transportation-info-driver",
    path: "-components/transportation-info/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/transportation-info/driver.vue")
  },
  {
    name: "trucker-id--components-transportation-info",
    path: "-components/transportation-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/transportation-info/index.vue")
  },
  {
    name: "trucker-id--components-transportation-info-vehicle",
    path: "-components/transportation-info/vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/transportation-info/vehicle.vue")
  },
  {
    name: "trucker-id--components-trip-info-content",
    path: "-components/trip-info-content",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info-content.vue")
  },
  {
    name: "trucker-id--components-trip-info",
    path: "-components/trip-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info.vue"),
    children: [
  {
    name: "trucker-id--components-trip-info-driver-alert-item",
    path: "driver-alert-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/driver-alert-item.vue")
  },
  {
    name: "trucker-id--components-trip-info-driver-info",
    path: "driver-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/driver-info.vue")
  },
  {
    name: "trucker-id--components-trip-info-driver-notifications",
    path: "driver-notifications",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/driver-notifications.vue")
  },
  {
    name: "trucker-id--components-trip-info-travel-detail",
    path: "travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-detail.vue")
  },
  {
    name: "trucker-id--components-trip-info-travel-map",
    path: "travel-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-map.vue")
  },
  {
    name: "trucker-id--components-trip-info-travel-route-info",
    path: "travel-route-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-route-info.vue")
  },
  {
    name: "trucker-id--components-trip-info-travel-step",
    path: "travel-step",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel-step.vue")
  },
  {
    name: "trucker-id--components-trip-info-travel",
    path: "travel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/travel.vue")
  },
  {
    name: "trucker-id--components-trip-info-trip-files",
    path: "trip-files",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/trip-files.vue")
  },
  {
    name: "trucker-id--components-trip-info-vehicle-info",
    path: "vehicle-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-info/vehicle-info.vue")
  }
]
  },
  {
    name: "trucker-id--components-trip-utils",
    path: "-components/trip-utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/-components/trip-utils.ts")
  },
  {
    name: "trucker-id-area-history",
    path: "area/history",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/history.vue")
  },
  {
    name: "trucker-id-area-ignore-add-area",
    path: "area/ignore/add-area",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/add-area.vue")
  },
  {
    name: "trucker-id-area-ignore-edit-area",
    path: "area/ignore/edit-area",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/edit-area.vue")
  },
  {
    name: "trucker-id-area-ignore-imports-model",
    path: "area/ignore/imports/model",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/imports/model.ts")
  },
  {
    name: "trucker-id-area-ignore-select-area",
    path: "area/ignore/select-area",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/ignore/select-area.vue")
  },
  {
    name: "trucker-id-area-list",
    path: "area/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/area/list.vue")
  },
  {
    name: "trucker-id-category-ignore-add-category",
    path: "category/ignore/add-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/ignore/add-category.vue")
  },
  {
    name: "trucker-id-category-ignore-list-category",
    path: "category/ignore/list-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/ignore/list-category.vue")
  },
  {
    name: "trucker-id-category-ignore-type-category",
    path: "category/ignore/type-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/ignore/type-category.vue")
  },
  {
    name: "trucker-id-category",
    path: "category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/index.vue"),
    children: [
  {
    name: "trucker-id-category-index-list",
    path: "list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/index/list.vue")
  },
  {
    name: "trucker-id-category-index-type",
    path: "type",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/category/index/type.vue")
  }
]
  },
  {
    name: "trucker-id-company-api-key-add",
    path: "company/api-key/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/add.vue")
  },
  {
    name: "trucker-id-company-api-key-edit",
    path: "company/api-key/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/edit.vue")
  },
  {
    name: "trucker-id-company-api-key",
    path: "company/api-key",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/index.vue")
  },
  {
    name: "trucker-id-company-api-key-table-key",
    path: "company/api-key/table/key",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/api-key/table/key.vue")
  },
  {
    name: "trucker-id-company-bank",
    path: "company/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/bank.vue")
  },
  {
    name: "trucker-id-company-branch",
    path: "company/branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/branch.vue")
  },
  {
    name: "trucker-id-company-global-settings",
    path: "company/global-settings",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings.vue"),
    children: [
  {
    name: "trucker-id-company-global-settings-bank-account-ignore-add",
    path: "bank-account/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/ignore/add.vue")
  },
  {
    name: "trucker-id-company-global-settings-bank-account-ignore-delete",
    path: "bank-account/ignore/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/ignore/delete.vue")
  },
  {
    name: "trucker-id-company-global-settings-bank-account-ignore-edit",
    path: "bank-account/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/ignore/edit.vue")
  },
  {
    name: "trucker-id-company-global-settings-bank-account",
    path: "bank-account",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/bank-account/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-cost-ignore-imports-form",
    path: "cost/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/cost/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-company-global-settings-cost",
    path: "cost",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/cost/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-general-ignore-imports-form",
    path: "general/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-company-global-settings-general-ignore-setting-cont",
    path: "general/ignore/setting-cont",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/ignore/setting-cont.vue")
  },
  {
    name: "trucker-id-company-global-settings-general-ignore-update-markup",
    path: "general/ignore/update-markup",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/ignore/update-markup.vue")
  },
  {
    name: "trucker-id-company-global-settings-general",
    path: "general",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/general/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-gps",
    path: "gps",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/gps/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-partner-driver",
    path: "partner/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/driver/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-partner-remooc",
    path: "partner/remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/remooc/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-partner-vehicle",
    path: "partner/vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/partner/vehicle/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-policy-ignore-imports-form",
    path: "policy/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/policy/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-company-global-settings-policy",
    path: "policy",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/policy/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-route",
    path: "route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/route/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-schedule",
    path: "schedule",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/schedule/index.vue")
  },
  {
    name: "trucker-id-company-global-settings-times-ignore-imports-form",
    path: "times/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/times/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-company-global-settings-times",
    path: "times",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/global-settings/times/index.vue")
  }
]
  },
  {
    name: "trucker-id-company-history",
    path: "company/history",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/history.vue")
  },
  {
    name: "trucker-id-company-ignore-action",
    path: "company/ignore/action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/action.vue")
  },
  {
    name: "trucker-id-company-ignore-add-banking",
    path: "company/ignore/add-banking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/add-banking.vue")
  },
  {
    name: "trucker-id-company-ignore-add-branch",
    path: "company/ignore/add-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/add-branch.vue")
  },
  {
    name: "trucker-id-company-ignore-add-company",
    path: "company/ignore/add-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/add-company.vue")
  },
  {
    name: "trucker-id-company-ignore-banking-branch",
    path: "company/ignore/banking-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/banking-branch.vue")
  },
  {
    name: "trucker-id-company-ignore-company-history-detail",
    path: "company/ignore/company-history-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/company-history-detail.vue")
  },
  {
    name: "trucker-id-company-ignore-edit-bank",
    path: "company/ignore/edit-bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-bank.vue")
  },
  {
    name: "trucker-id-company-ignore-edit-banking-branch",
    path: "company/ignore/edit-banking-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-banking-branch.vue")
  },
  {
    name: "trucker-id-company-ignore-edit-branch",
    path: "company/ignore/edit-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-branch.vue")
  },
  {
    name: "trucker-id-company-ignore-edit-company",
    path: "company/ignore/edit-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-company.vue")
  },
  {
    name: "trucker-id-company-ignore-edit-invoice-branch",
    path: "company/ignore/edit-invoice-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-invoice-branch.vue")
  },
  {
    name: "trucker-id-company-ignore-edit-invoice",
    path: "company/ignore/edit-invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/edit-invoice.vue")
  },
  {
    name: "trucker-id-company-ignore-imports-banking-form",
    path: "company/ignore/imports/banking-form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/imports/banking-form.ts")
  },
  {
    name: "trucker-id-company-ignore-imports-form",
    path: "company/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-company-ignore-imports-invoice-form",
    path: "company/ignore/imports/invoice-form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/imports/invoice-form.ts")
  },
  {
    name: "trucker-id-company-ignore-invoicing-branch",
    path: "company/ignore/invoicing-branch",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/invoicing-branch.vue")
  },
  {
    name: "trucker-id-company-ignore-list-company",
    path: "company/ignore/list-company",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/ignore/list-company.vue")
  },
  {
    name: "trucker-id-company-information",
    path: "company/information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/information/index.vue")
  },
  {
    name: "trucker-id-company-information-update",
    path: "company/information/update",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/information/update.vue")
  },
  {
    name: "trucker-id-company-integration-external-app",
    path: "company/integration/external/app",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/app.vue")
  },
  {
    name: "trucker-id-company-integration-external-apps-freightek-workspaces",
    path: "company/integration/external/apps/freightek-workspaces",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/apps/freightek-workspaces.vue")
  },
  {
    name: "trucker-id-company-integration-external-apps-freightek",
    path: "company/integration/external/apps/freightek",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/apps/freightek.vue")
  },
  {
    name: "trucker-id-company-integration-external-apps-hwl-crm",
    path: "company/integration/external/apps/hwl-crm",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/apps/hwl-crm.vue")
  },
  {
    name: "trucker-id-company-integration-external",
    path: "company/integration/external",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/external/index.vue")
  },
  {
    name: "trucker-id-company-integration-internal-ignore-add",
    path: "company/integration/internal/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/internal/ignore/add.vue")
  },
  {
    name: "trucker-id-company-integration-internal",
    path: "company/integration/internal",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/integration/internal/index.vue")
  },
  {
    name: "trucker-id-company-invoice",
    path: "company/invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/invoice.vue")
  },
  {
    name: "trucker-id-company-user-group--components-actions",
    path: "company/user-group/-components/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/actions.vue")
  },
  {
    name: "trucker-id-company-user-group--components-add-company-user",
    path: "company/user-group/-components/add-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/add-company-user.vue")
  },
  {
    name: "trucker-id-company-user-group--components-add-group",
    path: "company/user-group/-components/add-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/add-group.vue")
  },
  {
    name: "trucker-id-company-user-group--components-edit-company-user",
    path: "company/user-group/-components/edit-company-user",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/edit-company-user.vue")
  },
  {
    name: "trucker-id-company-user-group--components-edit-group",
    path: "company/user-group/-components/edit-group",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/edit-group.vue")
  },
  {
    name: "trucker-id-company-user-group--components-ignore-group-name",
    path: "company/user-group/-components/ignore/group-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/ignore/group-name.vue")
  },
  {
    name: "trucker-id-company-user-group--components-ignore-group-type",
    path: "company/user-group/-components/ignore/group-type",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/ignore/group-type.vue")
  },
  {
    name: "trucker-id-company-user-group--components-ignore-permission-checkbox",
    path: "company/user-group/-components/ignore/permission-checkbox",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/ignore/permission-checkbox.vue")
  },
  {
    name: "trucker-id-company-user-group--components-imports-data",
    path: "company/user-group/-components/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/imports/data.ts")
  },
  {
    name: "trucker-id-company-user-group--components-imports-form",
    path: "company/user-group/-components/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/imports/form.ts")
  },
  {
    name: "trucker-id-company-user-group--components-imports-model",
    path: "company/user-group/-components/imports/model",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/imports/model.ts")
  },
  {
    name: "trucker-id-company-user-group--components-update-permissions",
    path: "company/user-group/-components/update-permissions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/update-permissions.vue")
  },
  {
    name: "trucker-id-company-user-group--components-user-status",
    path: "company/user-group/-components/user-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/-components/user-status.vue")
  },
  {
    name: "trucker-id-company-user-group-groups",
    path: "company/user-group/groups",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/groups.vue")
  },
  {
    name: "trucker-id-company-user-group-users",
    path: "company/user-group/users",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/company/user-group/users.vue")
  },
  {
    name: "trucker-id-components",
    path: "components",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/components/index.vue")
  },
  {
    name: "trucker-id-cost--component-assumption-costing-add",
    path: "cost/-component/assumption-costing/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-costing/add.vue")
  },
  {
    name: "trucker-id-cost--component-assumption-costing-edit",
    path: "cost/-component/assumption-costing/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-costing/edit.vue")
  },
  {
    name: "trucker-id-cost--component-assumption-driver-add",
    path: "cost/-component/assumption-driver/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-driver/add.vue")
  },
  {
    name: "trucker-id-cost--component-assumption-driver-edit",
    path: "cost/-component/assumption-driver/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption-driver/edit.vue")
  },
  {
    name: "trucker-id-cost--component-assumption-add",
    path: "cost/-component/assumption/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption/add.vue")
  },
  {
    name: "trucker-id-cost--component-assumption-edit",
    path: "cost/-component/assumption/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/assumption/edit.vue")
  },
  {
    name: "trucker-id-cost--component-gasoline-add",
    path: "cost/-component/gasoline/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/gasoline/add.vue")
  },
  {
    name: "trucker-id-cost--component-gasoline-edit",
    path: "cost/-component/gasoline/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/gasoline/edit.vue")
  },
  {
    name: "trucker-id-cost--component-imports-form",
    path: "cost/-component/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/imports/form.ts")
  },
  {
    name: "trucker-id-cost--component-tables-actions",
    path: "cost/-component/tables/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/tables/actions.vue")
  },
  {
    name: "trucker-id-cost--component-tables-vehicle-name",
    path: "cost/-component/tables/vehicle-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/-component/tables/vehicle-name.vue")
  },
  {
    name: "trucker-id-cost-assumption-driver",
    path: "cost/assumption-driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/assumption-driver.vue")
  },
  {
    name: "trucker-id-cost-assumption",
    path: "cost/assumption",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/assumption.vue")
  },
  {
    name: "trucker-id-cost-driver",
    path: "cost/driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/driver.vue")
  },
  {
    name: "trucker-id-cost-gasoline",
    path: "cost/gasoline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/gasoline.vue")
  },
  {
    name: "trucker-id-cost",
    path: "cost",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/cost/index.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-analytics-card",
    path: "dashboard/-components/analytics/analytics-card",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/analytics-card.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-analytics-modal",
    path: "dashboard/-components/analytics/analytics-modal",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/analytics-modal.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-direction-of-fleet",
    path: "dashboard/-components/analytics/direction-of-fleet",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet.vue"),
    children: [
  {
    name: "trucker-id-dashboard--components-analytics-direction-of-fleet-cargo-segment-status",
    path: "cargo-segment-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/cargo-segment-status.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-direction-of-fleet-order-allocation-status",
    path: "order-allocation-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/order-allocation-status.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-direction-of-fleet-order-allocation-volume",
    path: "order-allocation-volume",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/order-allocation-volume.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-direction-of-fleet-shipment-leg-transport-status-in-day",
    path: "shipment-leg-transport-status-in-day",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/shipment-leg-transport-status-in-day.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-direction-of-fleet-shipment-scheduling-status",
    path: "shipment-scheduling-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/direction-of-fleet/shipment-scheduling-status.vue")
  }
]
  },
  {
    name: "trucker-id-dashboard--components-analytics-fleet-operation",
    path: "dashboard/-components/analytics/fleet-operation",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/fleet-operation.vue"),
    children: [
  {
    name: "trucker-id-dashboard--components-analytics-fleet-operation-fleet-operation-status",
    path: "fleet-operation-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/fleet-operation/fleet-operation-status.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-fleet-operation-vehicle-transport-status",
    path: "vehicle-transport-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/fleet-operation/vehicle-transport-status.vue")
  }
]
  },
  {
    name: "trucker-id-dashboard--components-analytics-operation-shipment-leg",
    path: "dashboard/-components/analytics/operation-shipment-leg",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg.vue"),
    children: [
  {
    name: "trucker-id-dashboard--components-analytics-operation-shipment-leg-cargo-segment-alert-status",
    path: "cargo-segment-alert-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg/cargo-segment-alert-status.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-operation-shipment-leg-shipment-operation-status-for-task-close-cargo",
    path: "shipment-operation-status-for-task-close-cargo",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg/shipment-operation-status-for-task-close-cargo.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-operation-shipment-leg-shipment-operation-status-for-task-unloading-yard",
    path: "shipment-operation-status-for-task-unloading-yard",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/operation-shipment-leg/shipment-operation-status-for-task-unloading-yard.vue")
  }
]
  },
  {
    name: "trucker-id-dashboard--components-analytics-order-allocation-volume",
    path: "dashboard/-components/analytics/order-allocation-volume",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/order-allocation-volume.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-sales",
    path: "dashboard/-components/analytics/sales",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales.vue"),
    children: [
  {
    name: "trucker-id-dashboard--components-analytics-sales-status-quote-request",
    path: "status-quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales/status-quote-request.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-sales-status-quote",
    path: "status-quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales/status-quote.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-sales-timely-alert-creation-tracking-operation",
    path: "timely-alert-creation-tracking-operation",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/sales/timely-alert-creation-tracking-operation.vue")
  }
]
  },
  {
    name: "trucker-id-dashboard--components-analytics-trip-monitor",
    path: "dashboard/-components/analytics/trip-monitor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/trip-monitor.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-vehicle-fleet-management",
    path: "dashboard/-components/analytics/vehicle-fleet-management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management.vue"),
    children: [
  {
    name: "trucker-id-dashboard--components-analytics-vehicle-fleet-management-legal_status_container_transport",
    path: "legal_status_container_transport",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/legal_status_container_transport.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-vehicle-fleet-management-nearing-expiration-document-driver",
    path: "nearing-expiration-document-driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/nearing-expiration-document-driver.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-vehicle-fleet-management-nearing-expiration-remooc",
    path: "nearing-expiration-remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/nearing-expiration-remooc.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-vehicle-fleet-management-nearing-expiration-vehicle",
    path: "nearing-expiration-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/nearing-expiration-vehicle.vue")
  },
  {
    name: "trucker-id-dashboard--components-analytics-vehicle-fleet-management-vehicle-transport-ready-status",
    path: "vehicle-transport-ready-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/analytics/vehicle-fleet-management/vehicle-transport-ready-status.vue")
  }
]
  },
  {
    name: "trucker-id-dashboard--components-rating",
    path: "dashboard/-components/rating",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/rating.vue")
  },
  {
    name: "trucker-id-dashboard--components-view-detail-static",
    path: "dashboard/-components/view-detail-static",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/view-detail-static.vue")
  },
  {
    name: "trucker-id-dashboard--components-view-general-static",
    path: "dashboard/-components/view-general-static",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/view-general-static.vue")
  },
  {
    name: "trucker-id-dashboard--components-view-map",
    path: "dashboard/-components/view-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/-components/view-map.vue")
  },
  {
    name: "trucker-id-dashboard",
    path: "dashboard",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/index.vue")
  },
  {
    name: "trucker-id-dashboard-tmp",
    path: "dashboard/tmp",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/dashboard/tmp.vue")
  },
  {
    name: "trucker-id-driver-ignore-actions",
    path: "driver/ignore/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/actions.vue")
  },
  {
    name: "trucker-id-driver-ignore-add-document",
    path: "driver/ignore/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/add-document.vue")
  },
  {
    name: "trucker-id-driver-ignore-add-driver",
    path: "driver/ignore/add-driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/add-driver.vue")
  },
  {
    name: "trucker-id-driver-ignore-document",
    path: "driver/ignore/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/document.vue")
  },
  {
    name: "trucker-id-driver-ignore-driver-history-detail",
    path: "driver/ignore/driver-history-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/driver-history-detail.vue")
  },
  {
    name: "trucker-id-driver-ignore-edit-document-driver",
    path: "driver/ignore/edit-document-driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/edit-document-driver.vue")
  },
  {
    name: "trucker-id-driver-ignore-edit-driver",
    path: "driver/ignore/edit-driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/edit-driver.vue")
  },
  {
    name: "trucker-id-driver-ignore-history-driver",
    path: "driver/ignore/history-driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/history-driver.vue")
  },
  {
    name: "trucker-id-driver-ignore-imports-data",
    path: "driver/ignore/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/imports/data.ts")
  },
  {
    name: "trucker-id-driver-ignore-imports-form",
    path: "driver/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-driver-ignore-imports-license",
    path: "driver/ignore/imports/license",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/imports/license.ts")
  },
  {
    name: "trucker-id-driver-ignore-license-add",
    path: "driver/ignore/license-add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/license-add.vue")
  },
  {
    name: "trucker-id-driver-ignore-license-edit",
    path: "driver/ignore/license-edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/license-edit.vue")
  },
  {
    name: "trucker-id-driver-ignore-license",
    path: "driver/ignore/license",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/license.vue")
  },
  {
    name: "trucker-id-driver-ignore-select-driver",
    path: "driver/ignore/select-driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/ignore/select-driver.vue")
  },
  {
    name: "trucker-id-driver-list",
    path: "driver/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/driver/list.vue")
  },
  {
    name: "trucker-id",
    path: "",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/index.vue")
  },
  {
    name: "trucker-id-journey",
    path: "journey",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey.vue"),
    children: [
  {
    name: "trucker-id-journey--components-deadline",
    path: "-components/deadline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/deadline.vue")
  },
  {
    name: "trucker-id-journey--components-journey-card",
    path: "-components/journey-card",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-card.vue")
  },
  {
    name: "trucker-id-journey--components-journey-detach-card",
    path: "-components/journey-detach-card",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-detach-card.vue")
  },
  {
    name: "trucker-id-journey--components-journey-list",
    path: "-components/journey-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-list.vue")
  },
  {
    name: "trucker-id-journey--components-journey-schedule",
    path: "-components/journey-schedule",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule.vue"),
    children: [
  {
    name: "trucker-id-journey--components-journey-schedule-action-tabs",
    path: "action-tabs",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/action-tabs.vue")
  },
  {
    name: "trucker-id-journey--components-journey-schedule-board",
    path: "board",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/board.vue")
  },
  {
    name: "trucker-id-journey--components-journey-schedule-map",
    path: "map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/map.vue")
  },
  {
    name: "trucker-id-journey--components-journey-schedule-warning-list",
    path: "warning-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey-schedule/warning-list.vue")
  }
]
  },
  {
    name: "trucker-id-journey--components-journey-change-partner",
    path: "-components/journey/change-partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/change-partner.vue")
  },
  {
    name: "trucker-id-journey--components-journey-container-no",
    path: "-components/journey/container-no",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/container-no.vue")
  },
  {
    name: "trucker-id-journey--components-journey-reason",
    path: "-components/journey/reason",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/reason.ts")
  },
  {
    name: "trucker-id-journey--components-journey-update-status",
    path: "-components/journey/update-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/journey/update-status.vue")
  },
  {
    name: "trucker-id-journey--components-request",
    path: "-components/request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/request.vue")
  },
  {
    name: "trucker-id-journey--components-route",
    path: "-components/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/route.vue")
  },
  {
    name: "trucker-id-journey--components-schedule-info",
    path: "-components/schedule-info",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/schedule-info.vue")
  },
  {
    name: "trucker-id-journey--components-schedule-settings",
    path: "-components/schedule-settings",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/-components/schedule-settings.vue")
  },
  {
    name: "trucker-id-journey-distributing",
    path: "distributing",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/distributing.vue")
  },
  {
    name: "trucker-id-journey-management",
    path: "management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/journey/management.vue")
  }
]
  },
  {
    name: "trucker-id-last-24h-path-ignore-movement",
    path: "last-24h-path/ignore/movement",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/last-24h-path/ignore/movement.vue")
  },
  {
    name: "trucker-id-last-24h-path",
    path: "last-24h-path",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/last-24h-path/index.vue")
  },
  {
    name: "trucker-id-marketplace-booking",
    path: "marketplace/booking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/booking.vue")
  },
  {
    name: "trucker-id-marketplace-ignore-booking-detail",
    path: "marketplace/ignore/booking-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/booking-detail.vue")
  },
  {
    name: "trucker-id-marketplace-ignore-reject-booking",
    path: "marketplace/ignore/reject-booking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/reject-booking.vue")
  },
  {
    name: "trucker-id-marketplace-ignore-setting-add",
    path: "marketplace/ignore/setting/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/add.vue")
  },
  {
    name: "trucker-id-marketplace-ignore-setting-detail",
    path: "marketplace/ignore/setting/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/detail.vue")
  },
  {
    name: "trucker-id-marketplace-ignore-setting-edit",
    path: "marketplace/ignore/setting/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/edit.vue")
  },
  {
    name: "trucker-id-marketplace-ignore-setting-workflow-position",
    path: "marketplace/ignore/setting/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/setting/workflow-position.vue")
  },
  {
    name: "trucker-id-marketplace-ignore-update-status",
    path: "marketplace/ignore/update-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/ignore/update-status.vue")
  },
  {
    name: "trucker-id-marketplace-setting",
    path: "marketplace/setting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/marketplace/setting.vue")
  },
  {
    name: "trucker-id-monitoring",
    path: "monitoring",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring.vue"),
    children: [
  {
    name: "trucker-id-monitoring--components-alert-list-drawer",
    path: "-components/alert-list-drawer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/alert-list-drawer.vue")
  },
  {
    name: "trucker-id-monitoring--components-alert-list",
    path: "-components/alert-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/alert-list.vue")
  },
  {
    name: "trucker-id-monitoring--components-alert-status",
    path: "-components/alert-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/alert-status.vue")
  },
  {
    name: "trucker-id-monitoring--components-vehicle-item",
    path: "-components/vehicle-item",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/vehicle-item.vue")
  },
  {
    name: "trucker-id-monitoring--components-vehicle-list",
    path: "-components/vehicle-list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-components/vehicle-list.vue")
  },
  {
    name: "trucker-id-monitoring--driver-abc",
    path: "-driver/abc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/-driver/abc.vue")
  },
  {
    name: "trucker-id-monitoring-driver",
    path: "driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/driver.vue")
  },
  {
    name: "trucker-id-monitoring-owner",
    path: "owner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/owner.vue")
  },
  {
    name: "trucker-id-monitoring-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/monitoring/partner.vue")
  }
]
  },
  {
    name: "trucker-id-order-ignore-add-order",
    path: "order/ignore/add-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/add-order.vue")
  },
  {
    name: "trucker-id-order-ignore-cancel",
    path: "order/ignore/cancel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/cancel.vue")
  },
  {
    name: "trucker-id-order-ignore-component-container-numbers",
    path: "order/ignore/component/container-numbers",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/container-numbers.vue")
  },
  {
    name: "trucker-id-order-ignore-component-CRMStatus",
    path: "order/ignore/component/CRMStatus",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/CRMStatus.vue")
  },
  {
    name: "trucker-id-order-ignore-component-date-time",
    path: "order/ignore/component/date-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/date-time.vue")
  },
  {
    name: "trucker-id-order-ignore-component-deadline",
    path: "order/ignore/component/deadline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/deadline.vue")
  },
  {
    name: "trucker-id-order-ignore-component-delivery-warehouse",
    path: "order/ignore/component/delivery-warehouse",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/delivery-warehouse.vue")
  },
  {
    name: "trucker-id-order-ignore-component-edit-productivity",
    path: "order/ignore/component/edit-productivity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/edit-productivity.vue")
  },
  {
    name: "trucker-id-order-ignore-component-edit-travel-time",
    path: "order/ignore/component/edit-travel-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/edit-travel-time.vue")
  },
  {
    name: "trucker-id-order-ignore-component-loading-task",
    path: "order/ignore/component/loading-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/loading-task.vue")
  },
  {
    name: "trucker-id-order-ignore-component-request",
    path: "order/ignore/component/request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/component/request.vue")
  },
  {
    name: "trucker-id-order-ignore-condition-setting",
    path: "order/ignore/condition-setting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/condition-setting.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-add-container-numbers",
    path: "order/ignore/detail-order/add-container-numbers",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/add-container-numbers.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-add-partner",
    path: "order/ignore/detail-order/add-partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/add-partner.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-add-quote-to-order",
    path: "order/ignore/detail-order/add-quote-to-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/add-quote-to-order.ts")
  },
  {
    name: "trucker-id-order-ignore-detail-order-allotment",
    path: "order/ignore/detail-order/allotment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/allotment.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-edit-allotment",
    path: "order/ignore/detail-order/edit-allotment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/edit-allotment.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-edit-shipping-plan",
    path: "order/ignore/detail-order/edit-shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/edit-shipping-plan.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-general-information",
    path: "order/ignore/detail-order/general-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/general-information.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order",
    path: "order/ignore/detail-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/index.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-quote",
    path: "order/ignore/detail-order/quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/quote.vue")
  },
  {
    name: "trucker-id-order-ignore-detail-order-shipping-plan",
    path: "order/ignore/detail-order/shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/detail-order/shipping-plan.vue")
  },
  {
    name: "trucker-id-order-ignore-document-add-document",
    path: "order/ignore/document/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/document/add-document.vue")
  },
  {
    name: "trucker-id-order-ignore-document-document",
    path: "order/ignore/document/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/document/document.vue")
  },
  {
    name: "trucker-id-order-ignore-document-edit-document",
    path: "order/ignore/document/edit-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/document/edit-document.vue")
  },
  {
    name: "trucker-id-order-ignore-edit-order",
    path: "order/ignore/edit-order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/edit-order.vue")
  },
  {
    name: "trucker-id-order-ignore-edit-request",
    path: "order/ignore/edit-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/edit-request.vue")
  },
  {
    name: "trucker-id-order-ignore-imports-data",
    path: "order/ignore/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/imports/data.ts")
  },
  {
    name: "trucker-id-order-ignore-imports-form",
    path: "order/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-order-ignore-optimize-waiting-time",
    path: "order/ignore/optimize-waiting-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/optimize-waiting-time/index.vue")
  },
  {
    name: "trucker-id-order-ignore-plugins-direction",
    path: "order/ignore/plugins/direction",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/plugins/direction.ts")
  },
  {
    name: "trucker-id-order-ignore-plugins",
    path: "order/ignore/plugins",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/plugins/index.ts")
  },
  {
    name: "trucker-id-order-ignore-plugins-route",
    path: "order/ignore/plugins/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/plugins/route.ts")
  },
  {
    name: "trucker-id-order-ignore-shipping-information",
    path: "order/ignore/shipping-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/shipping-information.vue")
  },
  {
    name: "trucker-id-order-ignore-shipping-plan",
    path: "order/ignore/shipping-plan",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/shipping-plan.vue")
  },
  {
    name: "trucker-id-order-ignore-table-commodity",
    path: "order/ignore/table/commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/table/commodity.vue")
  },
  {
    name: "trucker-id-order-ignore-table-cont",
    path: "order/ignore/table/cont",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/table/cont.vue")
  },
  {
    name: "trucker-id-order-ignore-table-customer",
    path: "order/ignore/table/customer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/table/customer.vue")
  },
  {
    name: "trucker-id-order-ignore-travel-detail",
    path: "order/ignore/travel-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/travel-detail.vue")
  },
  {
    name: "trucker-id-order-ignore-waiting-task",
    path: "order/ignore/waiting-task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/ignore/waiting-task.vue")
  },
  {
    name: "trucker-id-order",
    path: "order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/order/index.vue")
  },
  {
    name: "trucker-id-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner.vue"),
    children: [
  {
    name: "trucker-id-partner--components-actions",
    path: "-components/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/actions.vue")
  },
  {
    name: "trucker-id-partner--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/add.vue")
  },
  {
    name: "trucker-id-partner--components-cooperator-label",
    path: "-components/cooperator-label",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/cooperator-label.vue")
  },
  {
    name: "trucker-id-partner--components-detail",
    path: "-components/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/detail.vue")
  },
  {
    name: "trucker-id-partner--components-imports-form",
    path: "-components/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/imports/form.ts")
  },
  {
    name: "trucker-id-partner--components-invite",
    path: "-components/invite",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/invite.vue")
  },
  {
    name: "trucker-id-partner--components-select",
    path: "-components/select",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/select.vue")
  },
  {
    name: "trucker-id-partner--components-status",
    path: "-components/status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/status.vue")
  },
  {
    name: "trucker-id-partner--components-tabels-commodity-name",
    path: "-components/tabels/commodity-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/tabels/commodity-name.vue")
  },
  {
    name: "trucker-id-partner--components-tabels-system-participation-status",
    path: "-components/tabels/system-participation-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/-components/tabels/system-participation-status.vue")
  },
  {
    name: "trucker-id-partner-idpartner-bank",
    path: ":idpartner()/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank.vue"),
    children: [
  {
    name: "trucker-id-partner-idpartner-bank--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank/-components/add.vue")
  },
  {
    name: "trucker-id-partner-idpartner-bank-idbank-edit",
    path: ":idbank()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank/[idbank]/edit.vue")
  },
  {
    name: "trucker-id-partner-idpartner-bank-ignore-bank",
    path: "ignore/bank",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/bank/ignore/bank.ts")
  }
]
  },
  {
    name: "trucker-id-partner-idpartner-business-opportunity",
    path: ":idpartner()/business-opportunity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity.vue"),
    children: [
  {
    name: "trucker-id-partner-idpartner-business-opportunity--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/-components/add.vue")
  },
  {
    name: "trucker-id-partner-idpartner-business-opportunity--components-position",
    path: "-components/position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/-components/position.vue")
  },
  {
    name: "trucker-id-partner-idpartner-business-opportunity--components-workflow-position",
    path: "-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/-components/workflow-position.vue")
  },
  {
    name: "trucker-id-partner-idpartner-business-opportunity-idbusinessopportunity-edit",
    path: ":idbusinessopportunity()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/edit.vue")
  },
  {
    name: "trucker-id-partner-idpartner-business-opportunity-idbusinessopportunity-replicate",
    path: ":idbusinessopportunity()/replicate",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/business-opportunity/[idbusinessopportunity]/replicate.vue")
  }
]
  },
  {
    name: "trucker-id-partner-idpartner-commodity",
    path: ":idpartner()/commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/commodity.vue"),
    children: [
  {
    name: "trucker-id-partner-idpartner-commodity--components-add-commodity",
    path: "-components/add-commodity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue")
  },
  {
    name: "trucker-id-partner-idpartner-commodity-idcommodity-edit",
    path: ":idcommodity()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/commodity/[idcommodity]/edit.vue")
  }
]
  },
  {
    name: "trucker-id-partner-idpartner-contact",
    path: ":idpartner()/contact",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact.vue"),
    children: [
  {
    name: "trucker-id-partner-idpartner-contact--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact/-components/add.vue")
  },
  {
    name: "trucker-id-partner-idpartner-contact-idcontact-edit",
    path: ":idcontact()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact/[idcontact]/edit.vue")
  },
  {
    name: "trucker-id-partner-idpartner-contact-ignore-data",
    path: "ignore/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/contact/ignore/data.ts")
  }
]
  },
  {
    name: "trucker-id-partner-idpartner-document",
    path: ":idpartner()/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document.vue"),
    children: [
  {
    name: "trucker-id-partner-idpartner-document--components-add-document",
    path: "-components/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document/-components/add-document.vue")
  },
  {
    name: "trucker-id-partner-idpartner-document-iddocumentpartner-approve",
    path: ":iddocumentpartner()/approve",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document/[iddocumentpartner]/approve.vue")
  },
  {
    name: "trucker-id-partner-idpartner-document-iddocumentpartner-edit",
    path: ":iddocumentpartner()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/document/[iddocumentpartner]/edit.vue")
  }
]
  },
  {
    name: "trucker-id-partner-idpartner-edit",
    path: ":idpartner()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/edit.vue")
  },
  {
    name: "trucker-id-partner-idpartner-invoicing-information",
    path: ":idpartner()/invoicing-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information.vue"),
    children: [
  {
    name: "trucker-id-partner-idpartner-invoicing-information--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information/-components/add.vue")
  },
  {
    name: "trucker-id-partner-idpartner-invoicing-information-idinvoicinginformation-edit",
    path: ":idinvoicinginformation()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information/[idinvoicinginformation]/edit.vue")
  },
  {
    name: "trucker-id-partner-idpartner-invoicing-information-ignore-data",
    path: "ignore/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/invoicing-information/ignore/data.ts")
  }
]
  },
  {
    name: "trucker-id-partner-idpartner-task-completion-time",
    path: ":idpartner()/task-completion-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time.vue"),
    children: [
  {
    name: "trucker-id-partner-idpartner-task-completion-time-ignore-add",
    path: "ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/add.vue")
  },
  {
    name: "trucker-id-partner-idpartner-task-completion-time-ignore-detail",
    path: "ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/detail.vue")
  },
  {
    name: "trucker-id-partner-idpartner-task-completion-time-ignore-edit",
    path: "ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/edit.vue")
  },
  {
    name: "trucker-id-partner-idpartner-task-completion-time-ignore-form",
    path: "ignore/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/form.ts")
  },
  {
    name: "trucker-id-partner-idpartner-task-completion-time-ignore-utils",
    path: "ignore/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/[idpartner]/task-completion-time/ignore/utils.ts")
  }
]
  },
  {
    name: "trucker-id-partner-accept-customer",
    path: "accept/customer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/accept/customer.vue")
  },
  {
    name: "trucker-id-partner-accept-vendor",
    path: "accept/vendor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/partner/accept/vendor.vue")
  }
]
  },
  {
    name: "trucker-id-price-vendor",
    path: "price/vendor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor.vue"),
    children: [
  {
    name: "trucker-id-price-vendor--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/-components/add.vue")
  },
  {
    name: "trucker-id-price-vendor--components-view-price-vendor",
    path: "-components/view-price-vendor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/-components/view-price-vendor.vue")
  },
  {
    name: "trucker-id-price-vendor-cooperatorId-edit",
    path: ":cooperatorId()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/[cooperatorId]/edit.vue")
  },
  {
    name: "trucker-id-price-vendor-cooperatorId-view",
    path: ":cooperatorId()/view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/[cooperatorId]/view.vue")
  },
  {
    name: "trucker-id-price-vendor-action",
    path: "action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/action.vue")
  },
  {
    name: "trucker-id-price-vendor-detail",
    path: "detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/detail.vue")
  },
  {
    name: "trucker-id-price-vendor-ignore-data",
    path: "ignore/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/ignore/data.ts")
  },
  {
    name: "trucker-id-price-vendor-ignore-form",
    path: "ignore/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/ignore/form.ts")
  },
  {
    name: "trucker-id-price-vendor-status",
    path: "status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/price/vendor/status.vue")
  }
]
  },
  {
    name: "trucker-id-profile",
    path: "profile",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index.vue"),
    children: [
  {
    name: "trucker-id-profile-index-change-password",
    path: "change-password",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index/change-password.vue")
  },
  {
    name: "trucker-id-profile-index-information",
    path: "information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index/information.vue")
  },
  {
    name: "trucker-id-profile-index-time",
    path: "time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/profile/index/time.vue")
  }
]
  },
  {
    name: "trucker-id-provider",
    path: "provider",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/provider/index.vue")
  },
  {
    name: "trucker-id-quote",
    path: "quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote.vue"),
    children: [
  {
    name: "trucker-id-quote--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/add.vue")
  },
  {
    name: "trucker-id-quote--components-create",
    path: "-components/create",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/create.vue")
  },
  {
    name: "trucker-id-quote--components-ignore-imports-form",
    path: "-components/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-quote--components-information",
    path: "-components/information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/information.vue")
  },
  {
    name: "trucker-id-quote--components-markup-edit",
    path: "-components/markup-edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/markup-edit.vue")
  },
  {
    name: "trucker-id-quote--components-markup-view",
    path: "-components/markup-view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/markup-view.vue")
  },
  {
    name: "trucker-id-quote--components-price-information",
    path: "-components/price-information",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/price-information.vue")
  },
  {
    name: "trucker-id-quote--components-sync-status",
    path: "-components/sync-status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/sync-status.vue")
  },
  {
    name: "trucker-id-quote--components-type-commodity-name",
    path: "-components/type-commodity-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/type-commodity-name.vue")
  },
  {
    name: "trucker-id-quote--components-view-offline-fee",
    path: "-components/view-offline-fee",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-offline-fee.vue")
  },
  {
    name: "trucker-id-quote--components-view-price-detail",
    path: "-components/view-price-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-price-detail.vue")
  },
  {
    name: "trucker-id-quote--components-view-price-vendor",
    path: "-components/view-price-vendor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-price-vendor.vue")
  },
  {
    name: "trucker-id-quote--components-view-quote-price",
    path: "-components/view-quote-price",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/-components/view-quote-price.vue")
  },
  {
    name: "trucker-id-quote-management",
    path: "management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management.vue"),
    children: [
  {
    name: "trucker-id-quote-management--components-data-table-price",
    path: "-components/data-table-price",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management/-components/data-table-price.vue")
  },
  {
    name: "trucker-id-quote-management-idquote-edit",
    path: ":idquote()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management/[idquote]/edit.vue")
  },
  {
    name: "trucker-id-quote-management-idquote-view",
    path: ":idquote()/view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/management/[idquote]/view.vue")
  }
]
  },
  {
    name: "trucker-id-quote-quote-request",
    path: "quote-request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request.vue"),
    children: [
  {
    name: "trucker-id-quote-quote-request--components-add-quote",
    path: "-components/add-quote",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/add-quote.vue")
  },
  {
    name: "trucker-id-quote-quote-request--components-add",
    path: "-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/add.vue")
  },
  {
    name: "trucker-id-quote-quote-request--components-ignore-imports-form",
    path: "-components/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-quote-quote-request--components-routing-connection",
    path: "-components/routing-connection",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/routing-connection.vue")
  },
  {
    name: "trucker-id-quote-quote-request--components-view-position",
    path: "-components/view-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/view-position.vue")
  },
  {
    name: "trucker-id-quote-quote-request--components-workflow-position",
    path: "-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/-components/workflow-position.vue")
  },
  {
    name: "trucker-id-quote-quote-request-idquoterequest-edit",
    path: ":idquoterequest()/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/[idquoterequest]/edit.vue")
  },
  {
    name: "trucker-id-quote-quote-request-idquoterequest-view",
    path: ":idquoterequest()/view",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/quote/quote-request/[idquoterequest]/view.vue")
  }
]
  }
]
  },
  {
    name: "trucker-id-rate",
    path: "rate",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index.vue"),
    children: [
  {
    name: "trucker-id-rate-index-driver",
    path: "driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index/driver.vue")
  },
  {
    name: "trucker-id-rate-index-supply",
    path: "supply",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index/supply.vue")
  },
  {
    name: "trucker-id-rate-index-vehicle",
    path: "vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/rate/index/vehicle.vue")
  }
]
  },
  {
    name: "trucker-id-report",
    path: "report",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report.vue"),
    children: [
  {
    name: "trucker-id-report-general",
    path: "general",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general.vue"),
    children: [
  {
    name: "trucker-id-report-general-customer",
    path: "customer",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/customer.vue")
  },
  {
    name: "trucker-id-report-general-distribution",
    path: "distribution",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/distribution.vue")
  },
  {
    name: "trucker-id-report-general-driver",
    path: "driver",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/driver.vue")
  },
  {
    name: "trucker-id-report-general-journey",
    path: "journey",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/journey.vue")
  },
  {
    name: "trucker-id-report-general-opportunity",
    path: "opportunity",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/opportunity.vue")
  },
  {
    name: "trucker-id-report-general-order",
    path: "order",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/order.vue")
  },
  {
    name: "trucker-id-report-general-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/partner.vue")
  },
  {
    name: "trucker-id-report-general-route",
    path: "route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/route.vue")
  },
  {
    name: "trucker-id-report-general-sale-kpi",
    path: "sale-kpi",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/sale-kpi.vue")
  },
  {
    name: "trucker-id-report-general-sales",
    path: "sales",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/sales.vue")
  },
  {
    name: "trucker-id-report-general-task",
    path: "task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/task.vue")
  },
  {
    name: "trucker-id-report-general-toll-station-vehicle",
    path: "toll-station-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/toll-station-vehicle.vue")
  },
  {
    name: "trucker-id-report-general-toll-station",
    path: "toll-station",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/toll-station.vue")
  },
  {
    name: "trucker-id-report-general-trip",
    path: "trip",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/trip.vue")
  },
  {
    name: "trucker-id-report-general-vehicle",
    path: "vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/vehicle.vue")
  },
  {
    name: "trucker-id-report-general-workflow",
    path: "workflow",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/report/general/workflow.vue")
  }
]
  }
]
  },
  {
    name: "trucker-id-route-fee",
    path: "route-fee",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route-fee/index.vue"),
    children: [
  {
    name: "trucker-id-route-fee-index-internal",
    path: "internal",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route-fee/index/internal.vue")
  },
  {
    name: "trucker-id-route-fee-index-partner",
    path: "partner",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route-fee/index/partner.vue")
  }
]
  },
  {
    name: "trucker-id-route-ignore-add",
    path: "route/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/add.vue")
  },
  {
    name: "trucker-id-route-ignore-delete",
    path: "route/ignore/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/delete.vue")
  },
  {
    name: "trucker-id-route-ignore-detail",
    path: "route/ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/detail.vue")
  },
  {
    name: "trucker-id-route-ignore-edit",
    path: "route/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/edit.vue")
  },
  {
    name: "trucker-id-route-ignore-route-map",
    path: "route/ignore/route-map",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/route-map.ts")
  },
  {
    name: "trucker-id-route-ignore-table-compoment-distance",
    path: "route/ignore/table/compoment/distance",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/distance.vue")
  },
  {
    name: "trucker-id-route-ignore-table-compoment-duration",
    path: "route/ignore/table/compoment/duration",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/duration.vue")
  },
  {
    name: "trucker-id-route-ignore-table-compoment-route",
    path: "route/ignore/table/compoment/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/route.vue")
  },
  {
    name: "trucker-id-route-ignore-table-compoment-toll-station",
    path: "route/ignore/table/compoment/toll-station",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/ignore/table/compoment/toll-station.vue")
  },
  {
    name: "trucker-id-route",
    path: "route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/route/index.vue")
  },
  {
    name: "trucker-id-routing-add-routing",
    path: "routing/add-routing",
    meta: add_45routingJjKBaPAgpZMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/add-routing.vue")
  },
  {
    name: "trucker-id-routing-edit-routing",
    path: "routing/edit-routing",
    meta: edit_45routingBA4peeVnqXMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/edit-routing.vue")
  },
  {
    name: "trucker-id-routing-ignore-component-input-routing",
    path: "routing/ignore/component/input-routing",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/component/input-routing.vue")
  },
  {
    name: "trucker-id-routing-ignore-imports-form",
    path: "routing/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-routing-ignore-imports-utils",
    path: "routing/ignore/imports/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/imports/utils.ts")
  },
  {
    name: "trucker-id-routing-ignore-screen-map-routing",
    path: "routing/ignore/screen/map-routing",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/screen/map-routing.vue")
  },
  {
    name: "trucker-id-routing-ignore-screen-select-routing",
    path: "routing/ignore/screen/select-routing",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/ignore/screen/select-routing.vue")
  },
  {
    name: "trucker-id-routing-list",
    path: "routing/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/list.vue")
  },
  {
    name: "trucker-id-routing-routing-detail",
    path: "routing/routing-detail",
    meta: routing_45detailrUD9TgiNBdMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/routing/routing-detail.vue")
  },
  {
    name: "trucker-id-shipment",
    path: "shipment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index.vue"),
    children: [
  {
    name: "trucker-id-shipment-index-list-booking",
    path: "list/booking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/booking.vue")
  },
  {
    name: "trucker-id-shipment-index-list-customs",
    path: "list/customs",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/customs.vue")
  },
  {
    name: "trucker-id-shipment-index-list-document",
    path: "list/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/document.vue")
  },
  {
    name: "trucker-id-shipment-index-list-shipment",
    path: "list/shipment",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/shipment/index/list/shipment.vue")
  }
]
  },
  {
    name: "trucker-id-statistics--components-ignore-imports-data",
    path: "statistics/-components/ignore/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/ignore/imports/data.ts")
  },
  {
    name: "trucker-id-statistics--components-report-card-chart",
    path: "statistics/-components/report-card-chart",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-card-chart.vue")
  },
  {
    name: "trucker-id-statistics--components-report-chart",
    path: "statistics/-components/report-chart",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-chart.vue")
  },
  {
    name: "trucker-id-statistics--components-report-detail-table",
    path: "statistics/-components/report-detail-table",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-detail-table.vue")
  },
  {
    name: "trucker-id-statistics--components-report-management",
    path: "statistics/-components/report-management",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/report-management.vue")
  },
  {
    name: "trucker-id-statistics--components-status",
    path: "statistics/-components/status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/-components/status.vue")
  },
  {
    name: "trucker-id-statistics-company-operation",
    path: "statistics/company-operation",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/company-operation.vue")
  },
  {
    name: "trucker-id-statistics-finance",
    path: "statistics/finance",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/finance.vue")
  },
  {
    name: "trucker-id-statistics-general",
    path: "statistics/general",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/statistics/general.vue")
  },
  {
    name: "trucker-id-supply-ignore-add-type-supply",
    path: "supply/ignore/add-type-supply",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/add-type-supply.vue")
  },
  {
    name: "trucker-id-supply-ignore-edit-type-supply",
    path: "supply/ignore/edit-type-supply",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/edit-type-supply.vue")
  },
  {
    name: "trucker-id-supply-ignore-list-supply",
    path: "supply/ignore/list-supply",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/list-supply.vue")
  },
  {
    name: "trucker-id-supply-ignore-list-type-supply",
    path: "supply/ignore/list-type-supply",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/list-type-supply.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-document-editor",
    path: "supply/ignore/supply-document-editor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-document-editor.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-editor",
    path: "supply/ignore/supply-editor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-editor.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-history-detail",
    path: "supply/ignore/supply-history-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-history-detail.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-history",
    path: "supply/ignore/supply-history",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-history.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-insurance-editor",
    path: "supply/ignore/supply-insurance-editor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-insurance-editor.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-list-document",
    path: "supply/ignore/supply-list-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-list-document.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-list-insurance",
    path: "supply/ignore/supply-list-insurance",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-list-insurance.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-list-plugins",
    path: "supply/ignore/supply-list-plugins",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-list-plugins.vue")
  },
  {
    name: "trucker-id-supply-ignore-supply-plugins-editor",
    path: "supply/ignore/supply-plugins-editor",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/ignore/supply-plugins-editor.vue")
  },
  {
    name: "trucker-id-supply-list",
    path: "supply/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/list.vue")
  },
  {
    name: "trucker-id-supply-models-supply",
    path: "supply/models/supply",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/models/supply.ts")
  },
  {
    name: "trucker-id-supply-service-helper",
    path: "supply/service/helper",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/service/helper.ts")
  },
  {
    name: "trucker-id-supply-service-router",
    path: "supply/service/router",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/supply/service/router.ts")
  },
  {
    name: "trucker-id-test",
    path: "test",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/test.vue")
  },
  {
    name: "trucker-id-trip-ignore-add",
    path: "trip/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/add.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-create-invoice",
    path: "trip/ignore/billing-and-costing/create-invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/create-invoice.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-create-receipt-record",
    path: "trip/ignore/billing-and-costing/create-receipt-record",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/create-receipt-record.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-delete-invoice",
    path: "trip/ignore/billing-and-costing/delete-invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/delete-invoice.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-detail-invoice",
    path: "trip/ignore/billing-and-costing/detail-invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/detail-invoice.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing",
    path: "trip/ignore/billing-and-costing",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/index.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-invoice",
    path: "trip/ignore/billing-and-costing/invoice",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/invoice.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note--components-change-table",
    path: "trip/ignore/billing-and-costing/payment-note/-components/change-table",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/-components/change-table.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note--components-InvoiceStatus",
    path: "trip/ignore/billing-and-costing/payment-note/-components/InvoiceStatus",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/-components/InvoiceStatus.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note-create",
    path: "trip/ignore/billing-and-costing/payment-note/create",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/create.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note-delete",
    path: "trip/ignore/billing-and-costing/payment-note/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/delete.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note-detail",
    path: "trip/ignore/billing-and-costing/payment-note/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/detail.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note-edit",
    path: "trip/ignore/billing-and-costing/payment-note/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/edit.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note-list-payment-note",
    path: "trip/ignore/billing-and-costing/payment-note/list-payment-note",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/list-payment-note.vue")
  },
  {
    name: "trucker-id-trip-ignore-billing-and-costing-payment-note-list",
    path: "trip/ignore/billing-and-costing/payment-note/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/billing-and-costing/payment-note/list.vue")
  },
  {
    name: "trucker-id-trip-ignore-cancel",
    path: "trip/ignore/cancel",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/cancel.vue")
  },
  {
    name: "trucker-id-trip-ignore-component-deadline",
    path: "trip/ignore/component/deadline",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/deadline.vue")
  },
  {
    name: "trucker-id-trip-ignore-component-journey-cell",
    path: "trip/ignore/component/journey-cell",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/journey-cell.vue")
  },
  {
    name: "trucker-id-trip-ignore-component-request",
    path: "trip/ignore/component/request",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/request.vue")
  },
  {
    name: "trucker-id-trip-ignore-component-route",
    path: "trip/ignore/component/route",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/component/route.vue")
  },
  {
    name: "trucker-id-trip-ignore-detail",
    path: "trip/ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/detail.vue")
  },
  {
    name: "trucker-id-trip-ignore-edit",
    path: "trip/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/ignore/edit.vue")
  },
  {
    name: "trucker-id-trip",
    path: "trip",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/trip/index.vue")
  },
  {
    name: "trucker-id-unit-price",
    path: "unit-price",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/unit-price/index.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-actions",
    path: "vehicle/ignore/actions",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/actions.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-add-toll-station",
    path: "vehicle/ignore/add-toll-station",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/add-toll-station.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-add-vehicle",
    path: "vehicle/ignore/add-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/add-vehicle.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-autocomplete-select-remooc-category",
    path: "vehicle/ignore/autocomplete/select-remooc-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/autocomplete/select-remooc-category.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-autocomplete-select-remooc",
    path: "vehicle/ignore/autocomplete/select-remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/autocomplete/select-remooc.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-autocomplete-select-vehicle-category",
    path: "vehicle/ignore/autocomplete/select-vehicle-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/autocomplete/select-vehicle-category.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-detail-vehicle",
    path: "vehicle/ignore/detail-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/detail-vehicle.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-document-add-document",
    path: "vehicle/ignore/document/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/document/add-document.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-document-document",
    path: "vehicle/ignore/document/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/document/document.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-document-edit-document",
    path: "vehicle/ignore/document/edit-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/document/edit-document.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-edit-vehicle",
    path: "vehicle/ignore/edit-vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/edit-vehicle.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-exploit-open",
    path: "vehicle/ignore/exploit/open",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/exploit/open.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-exploit-stop",
    path: "vehicle/ignore/exploit/stop",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/exploit/stop.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-imports-form",
    path: "vehicle/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/imports/form.ts")
  },
  {
    name: "trucker-id-vehicle-ignore-imports-remooc",
    path: "vehicle/ignore/imports/remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/imports/remooc.ts")
  },
  {
    name: "trucker-id-vehicle-ignore-imports-utils",
    path: "vehicle/ignore/imports/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/imports/utils.ts")
  },
  {
    name: "trucker-id-vehicle-ignore-plugin-add-plugin",
    path: "vehicle/ignore/plugin/add-plugin",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/plugin/add-plugin.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-plugin-list-plugin",
    path: "vehicle/ignore/plugin/list-plugin",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/plugin/list-plugin.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-category-add-remooc-category",
    path: "vehicle/ignore/remooc-category/add-remooc-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-category/add-remooc-category.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-category-detail",
    path: "vehicle/ignore/remooc-category/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-category/detail.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-category-edit-remooc-category",
    path: "vehicle/ignore/remooc-category/edit-remooc-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-category/edit-remooc-category.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-document-add-document",
    path: "vehicle/ignore/remooc-document/add-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-document/add-document.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-document-document",
    path: "vehicle/ignore/remooc-document/document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-document/document.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-document-edit-document",
    path: "vehicle/ignore/remooc-document/edit-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc-document/edit-document.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-add-remooc",
    path: "vehicle/ignore/remooc/add-remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc/add-remooc.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-detail",
    path: "vehicle/ignore/remooc/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc/detail.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-remooc-edit-remooc",
    path: "vehicle/ignore/remooc/edit-remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/remooc/edit-remooc.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-repair-add",
    path: "vehicle/ignore/repair/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/add.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-repair-detail",
    path: "vehicle/ignore/repair/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/detail.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-repair-edit",
    path: "vehicle/ignore/repair/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/edit.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-repair-link-document",
    path: "vehicle/ignore/repair/link-document",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/repair/link-document.vue")
  },
  {
    name: "trucker-id-vehicle-ignore-status",
    path: "vehicle/ignore/status",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/ignore/status.vue")
  },
  {
    name: "trucker-id-vehicle-list",
    path: "vehicle/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/list.vue")
  },
  {
    name: "trucker-id-vehicle-remooc-category",
    path: "vehicle/remooc-category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/remooc-category.vue")
  },
  {
    name: "trucker-id-vehicle-remooc",
    path: "vehicle/remooc",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/remooc.vue")
  },
  {
    name: "trucker-id-vehicle-repair",
    path: "vehicle/repair",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-[id]/vehicle/repair.vue")
  }
]
  },
  {
    name: "trucker-admin-id",
    path: "/trucker-admin-:id()",
    meta: trucker_45admin_45_91id_93JC5eyqWJ5xMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id].vue"),
    children: [
  {
    name: "trucker-admin-id-admin",
    path: "admin",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/admin.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-businesses-add",
    path: "business/ignore/businesses/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/add.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-businesses-delete",
    path: "business/ignore/businesses/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/delete.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-businesses-detail",
    path: "business/ignore/businesses/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/detail.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-businesses-edit",
    path: "business/ignore/businesses/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/businesses/edit.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-imports-data",
    path: "business/ignore/imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/imports/data.ts")
  },
  {
    name: "trucker-admin-id-business-ignore-imports-form",
    path: "business/ignore/imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/imports/form.ts")
  },
  {
    name: "trucker-admin-id-business-ignore-tables-node-type-name",
    path: "business/ignore/tables/node-type-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/node-type-name.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tables-node-types",
    path: "business/ignore/tables/node-types",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/node-types.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tables-task-name",
    path: "business/ignore/tables/task-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/task-name.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tables-tasks-name",
    path: "business/ignore/tables/tasks-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tables/tasks-name.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tasks-add",
    path: "business/ignore/tasks/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/add.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tasks-delete",
    path: "business/ignore/tasks/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/delete.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tasks-detail",
    path: "business/ignore/tasks/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/detail.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tasks-edit",
    path: "business/ignore/tasks/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/edit.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tasks-replicate",
    path: "business/ignore/tasks/replicate",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/replicate.vue")
  },
  {
    name: "trucker-admin-id-business-ignore-tasks-task-name",
    path: "business/ignore/tasks/task-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/ignore/tasks/task-name.vue")
  },
  {
    name: "trucker-admin-id-business",
    path: "business",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/index.vue")
  },
  {
    name: "trucker-admin-id-business-task",
    path: "business/task",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/business/task.vue")
  },
  {
    name: "trucker-admin-id-node-history",
    path: "node/history",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/history.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-add-node",
    path: "node/ignore/add-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/add-node.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-autocomplete-select-node",
    path: "node/ignore/autocomplete/select-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/autocomplete/select-node.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-detail-node",
    path: "node/ignore/detail-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/detail-node.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-edit-node",
    path: "node/ignore/edit-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/edit-node.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-imports-init",
    path: "node/ignore/imports/init",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/imports/init.ts")
  },
  {
    name: "trucker-admin-id-node-ignore-imports-model",
    path: "node/ignore/imports/model",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/imports/model.ts")
  },
  {
    name: "trucker-admin-id-node-ignore-imports-utils",
    path: "node/ignore/imports/utils",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/imports/utils.ts")
  },
  {
    name: "trucker-admin-id-node-ignore-node-connection-add",
    path: "node/ignore/node-connection/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/add.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-connection-detail",
    path: "node/ignore/node-connection/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/detail.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-connection-edit",
    path: "node/ignore/node-connection/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/edit.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-connection-list",
    path: "node/ignore/node-connection/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/list.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-connection-tables-business-name",
    path: "node/ignore/node-connection/tables/business-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/tables/business-name.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-connection-tables-node-name",
    path: "node/ignore/node-connection/tables/node-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/tables/node-name.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-connection-tables-task-name",
    path: "node/ignore/node-connection/tables/task-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node-connection/tables/task-name.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-edit-working-time",
    path: "node/ignore/node/edit-working-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node/edit-working-time.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-toll-stations",
    path: "node/ignore/node/toll-stations",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node/toll-stations.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-node-working-time",
    path: "node/ignore/node/working-time",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/node/working-time.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-tables-business-name",
    path: "node/ignore/tables/business-name",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/tables/business-name.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-type-add",
    path: "node/ignore/type/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/add.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-type-delete",
    path: "node/ignore/type/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/delete.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-type-detail",
    path: "node/ignore/type/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/detail.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-type-edit",
    path: "node/ignore/type/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/type/edit.vue")
  },
  {
    name: "trucker-admin-id-node-ignore-update-relation-node",
    path: "node/ignore/update-relation-node",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/ignore/update-relation-node.vue")
  },
  {
    name: "trucker-admin-id-node-list",
    path: "node/list",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/list.vue")
  },
  {
    name: "trucker-admin-id-node-location",
    path: "node/location",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location.vue"),
    children: [
  {
    name: "trucker-admin-id-node-location-ignore-action",
    path: "ignore/action",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/action.vue")
  },
  {
    name: "trucker-admin-id-node-location-ignore-add",
    path: "ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/add.vue")
  },
  {
    name: "trucker-admin-id-node-location-ignore-detail",
    path: "ignore/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/detail.vue")
  },
  {
    name: "trucker-admin-id-node-location-ignore-edit",
    path: "ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/location/ignore/edit.vue")
  }
]
  },
  {
    name: "trucker-admin-id-node-type",
    path: "node/type",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/node/type.vue")
  },
  {
    name: "trucker-admin-id-vehicle-search-setting",
    path: "vehicle-search-setting",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle-search-setting/index.vue")
  },
  {
    name: "trucker-admin-id-vehicle-category-ignore-add",
    path: "vehicle/category/ignore/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/ignore/add.vue")
  },
  {
    name: "trucker-admin-id-vehicle-category-ignore-edit",
    path: "vehicle/category/ignore/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/ignore/edit.vue")
  },
  {
    name: "trucker-admin-id-vehicle-category-ignore-import-form",
    path: "vehicle/category/ignore/import/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/ignore/import/form.ts")
  },
  {
    name: "trucker-admin-id-vehicle-category",
    path: "vehicle/category",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/category/index.vue")
  },
  {
    name: "trucker-admin-id-vehicle",
    path: "vehicle",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/vehicle/index.vue")
  },
  {
    name: "trucker-admin-id-workflow--components-add",
    path: "workflow/-components/add",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/add.vue")
  },
  {
    name: "trucker-admin-id-workflow--components-delete",
    path: "workflow/-components/delete",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/delete.vue")
  },
  {
    name: "trucker-admin-id-workflow--components-detail",
    path: "workflow/-components/detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/detail.vue")
  },
  {
    name: "trucker-admin-id-workflow--components-edit",
    path: "workflow/-components/edit",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/edit.vue")
  },
  {
    name: "trucker-admin-id-workflow--components-find-business",
    path: "workflow/-components/find-business",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/find-business.vue")
  },
  {
    name: "trucker-admin-id-workflow--components-setting-position-number",
    path: "workflow/-components/setting-position-number",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/setting-position-number.vue")
  },
  {
    name: "trucker-admin-id-workflow--components-workflow-position",
    path: "workflow/-components/workflow-position",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-components/workflow-position.vue")
  },
  {
    name: "trucker-admin-id-workflow--imports-data",
    path: "workflow/-imports/data",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-imports/data.ts")
  },
  {
    name: "trucker-admin-id-workflow--imports-form",
    path: "workflow/-imports/form",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/-imports/form.ts")
  },
  {
    name: "trucker-admin-id-workflow",
    path: "workflow",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/trucker-admin-[id]/workflow/index.vue")
  }
]
  },
  {
    name: "user",
    path: "/user",
    meta: userAmT8guRmOZMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user.vue"),
    children: [
  {
    name: "user-booking-management",
    path: "booking-management",
    meta: booking_45managementZqL6Ser4taMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/booking-management.vue")
  },
  {
    name: "user-ignore-booking-detail",
    path: "ignore/booking-detail",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/ignore/booking-detail.vue")
  },
  {
    name: "user-ignore-cancel-booking",
    path: "ignore/cancel-booking",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/ignore/cancel-booking.vue")
  },
  {
    name: "user-search-booking",
    path: "search-booking",
    meta: search_45bookingE8j4rLMb5lMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/search-booking.vue")
  },
  {
    name: "user-upgrate",
    path: "upgrate",
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/user/upgrate/index.vue")
  }
]
  },
  {
    name: "workspace-list",
    path: "/workspace/list",
    meta: listeVPs6P69MhMeta || {},
    component: () => import("C:/Users/ngngo/Projects/ft_hts_fe/src/pages/workspace/list.vue")
  }
]